import en_US from 'ant-design-vue/es/locale/en_US'

export const lang = {
  ...en_US,
  // 提示
  ep_admin_tips_input: 'Please input',
  ep_admin_tips_select: 'Please select',
  ep_admin_tips_search: 'Please search',
  ep_admin_tips_upload: 'Please upload',
  ep_admin_tips_yes: 'Yes',
  ep_admin_tips_no: 'No',
  ep_admin_tips_error: 'error',
  ep_admin_tips_uploading: 'Uploading...',
  ep_admin_tips_uploadSuccessful: 'Upload Successful!',
  ep_admin_tips_savedSuccessful: 'Saved Successful!',
  ep_admin_tips_uploadFailed: 'Upload Failed!',
  ep_admin_tips_successful: 'successful',
  ep_admin_tips_success: 'Success',
  ep_admin_tips_totalItems: 'Total {total} items',
  ep_admin_tips_fill_in: 'Please fill in',

  // 按钮
  ep_admin_btns_search: 'Search',
  ep_admin_btns_reset: 'Reset',
  ep_admin_btns_unfold: 'Unfold',
  ep_admin_btns_fold: 'Fold',
  ep_admin_btns_Export: 'Export',
  ep_admin_btns_Import: 'Import',
  ep_admin_btns_operation: 'Operation',
  ep_admin_cdg_action: 'Action',
  ep_admin_btns_ok: 'OK',
  ep_admin_btns_cancel: 'Cancel',
  ep_admin_btns_download: 'Download',
  ep_admin_btns_upload: 'Upload',
  ep_admin_btns_confirm: 'Confirm',
  ep_admin_btns_operate: 'Operate',
  ep_admin_btns_config: 'Config',
  ep_admin_btns_detail: 'Detail',
  ep_admin_btns_ignore: 'Ignore',
  ep_admin_btns_edit: 'Edit',
  ep_admin_btns_preview: 'Preview',
  ep_admin_btns_clear: 'Clear',
  ep_admin_btns_back: 'Back',
  ep_admin_btns_previous: 'Previous',
  ep_admin_btns_save: 'Save',
  ep_admin_btns_save_Draft: 'Save Draft',
  ep_admin_btns_next: 'Next',
  ep_admin_btns_submit: 'Submit',
  ep_admin_btns_re_submit: 'Re-Submit',
  ep_admin_btns_approve: 'Approve',
  ep_admin_btns_terminated: 'Terminated',
  ep_admin_btns_copy: 'Copy',
  ep_admin_btns_reply: 'Reply',
  ep_admin_btns_add: 'Add',
  ep_admin_btns_Unpublish: 'Unpublish',
  ep_admin_btns_More: 'More',
  ep_admin_btns_Template: 'Template',
  ep_admin_btns_publish: 'Publish',
  ep_admin_btns_conceal: 'Conceal',
  ep_admin_btns_Refresh: 'Refresh',
  ep_admin_btns_Close: 'Close',
  ep_admin_btns_Go_Back: 'Go Back',
  ep_admin_btns_Recall: 'Recall',
  ep_admin_btns_clone: 'Clone',

  // 菜单
  'menu.userManage': 'Customer Management',
  'menu.userManage.customerLoginRecord': 'Customer Login Record',
  'menu.userManage.invitationAndRegistration': 'Invitation To Register',
  'menu.userManage.userManage': 'User Management',
  'menu.userManage.companyManage': 'Company Management',
  'menu.userManage.loginRecord': 'Customer Login Record',
  'menu.userManage.roleManagement': 'Role Management',
  'menu.userManage.deleteAccount': 'Delete Account',
  'menu.mps': 'MPS Product Management',
  'menu.product.productCategory': 'Product Category',
  'menu.product.goodsManage': 'Goods Management',
  'menu.product.productManageDetail': 'Product Detail',
  'menu.product.priceManage': 'Price Management',
  'menu.product.miniBuyNum': 'Fullbox Management',
  'menu.product.productTags': 'Product Tags',
  'menu.homepage': 'Homepage Management',
  'menu.homepage.noticeManage': 'Notice Management',
  'menu.homepage.shopwindowManage': 'Window Management',
  'menu.homepage.helpManage': 'Manual Management',
  'menu.homepage.helpManageDetail': 'Manual Management Detail',
  'menu.homepage.helpManageEdit': 'Manual Management Edit',
  'menu.homepage.helpManageAdd': 'Manual Management Add',
  'menu.homepage.systermManage': 'System Config',
  'menu.order': 'Order Management',
  'menu.order.orderManage': 'Order Management',
  'menu.order.orderCheck': 'Order Approval',
  'menu.order.orderReport': 'Order Report',
  'menu.order.invoiceManage': 'Invoice Management',
  'menu.wallet': 'Discount Pool Management',
  'menu.order.financialManagement': 'Financial Management',
  'menu.wallet.walletManage': 'Discount Pool List',
  'menu.wallet.refundManage': 'Discount Pool Refund',
  'menu.promotion': 'Promotion Management',
  'menu.promotion.promotionManage': 'Promotion Management',
  'menu.promotion.todManage': 'TOD Management',
  // 'menu.promotion.walletManage': 'Discount Pool Management',
  'menu.promotion.walletManage': 'E-Wallet Management',
  // 'menu.promotion.refundManage': 'Discount Pool Refund',
  'menu.promotion.refundManage': 'E-Wallet Refund',
  'menu.promotion.promotionSteps': 'Promotion Management Edit Page',
  'menu.promotion.promotionSteps.step1': 'Customer Type',
  'menu.promotion.promotionSteps.step2': 'Choose Customer',
  'menu.promotion.promotionSteps.step3': 'Product',
  'menu.promotion.promotionSteps.step4': 'Summary',
  'menu.homepage.noticeManageEdit': 'NoticeManage Edit',
  'menu.homepage.noticeManageAdd': 'NoticeManage Add',
  'menu.homepage.noticeManageDetail': 'NoticeManage Detail',
  'menu.homepage.labelManage': 'New Page Management',
  'menu.homepage.salesOrganization': 'SalesOrganization',
  'menu.homepage.salesOrganizationEdit': 'SalesOrganization Edit',
  'menu.product.goodsManageDetail': 'GoodsManage Detail',
  'menu.product.productManageParts': 'Product Parts',
  'menu.permission': 'Admin Permission Management',
  'menu.permission.adminList': 'Admin List',
  'menu.permission.roleList': 'Role List',
  'menu.systemManage.systemMenu': 'System Menu',
  'menu.permission.operateRecord': 'Admin Operate Record',
  'menu.sapInfo': 'SAP Data Synchronization',
  'menu.baseData': 'General Management',
  'menu.baseData.helpCenter': 'Help Center',
  'menu.baseData.regionManage': 'Region',
  'menu.baseData.regionProgram': 'DPP&VSAP Policy',
  'menu.baseData.regionProgramEdit': 'DPP&VSAP Policy Edit',
  'menu.baseData.legalPolicy': ' Channel Policy-BU',
  'menu.baseData.legalPolicyHQ': 'Legal Policy-HQ',
  'menu.baseData.legalPolicyEdit': 'Legal Policy Edit',
  'menu.baseData.onlineTraining': 'Online Event List',
  'menu.baseData.trainingMember': 'Event Member',
  'menu.onsideTraining.onsiteTraining': 'Onsite Training List',
  'menu.baseData.notification': 'Notification',
  'menu.baseData.addNotification': 'Add Notification',
  'menu.baseData.cloneNotification': 'Clone Notification',
  'menu.baseData.viewNotification': 'View Notification',
  'menu.marketing.onsiteTraining': 'Onsite Training List',
  'menu.marketing.onlineTraining': 'Event Management',
  'menu.marketing.onlineTrainingHq': 'Online Training HQ',
  'menu.baseData.trainingPush': 'Event Push',
  'menu.baseData.languageConversion': 'Language Conversion',
  'menu.superManage': 'Super Manage',
  'menu.marketing': 'Marketing Management',
  'menu.superManage.businessUnit': 'Business Unit',
  'menu.superManage.businessUnitLanguage': 'Business Unit Language',
  'menu.superManage.regionLanguage': 'Region Language',
  'menu.superManage.language': 'Language Manage',
  'menu.systemManage.businessUnit': 'Business Unit',
  'menu.systemManage.language': 'Language Management',
  'menu.systemManage': 'System Administration',
  'menu.systemManage.userManagement': 'Users',
  'menu.systemManage.roleManagement': 'Role Management',
  'menu.systemManage.roleAddOrEdit': 'RoleModify',
  'menu.systemManage.resourceManagement': 'Portal Menu',
  'menu.systemManage.adminList': 'System Administrators',
  'menu.systemManage.roleList': 'System Roles',
  'menu.systemManage.operateRecord': 'Admiration Record',
  'menu.systemManage.regionManage': 'Region',
  'menu.systemManage.appVersion': 'App Version',
  'menu.baseData.bannerManage': 'Banner Management',
  'menu.baseData.leadsManage': 'Leads Management',
  'menu.baseData.disseminate': 'Disseminate Management',
  'menu.baseData.noticeSendEmail': 'Send Email',
  'menu.baseData.invitationAndRegistration': 'Invitation To Register',
  'menu.homepage.helpCenter': 'Portal HelpCenter',
  'menu.resourcePage': 'PIS Product Management',
  'menu.resourcePage.GlobalProduct': 'Global Product List',
  'menu.resourcePage.Offering': 'PIS Offering Sync',
  'menu.resourcePage.Product': 'Regional Product List',
  'menu.resourcePage.Verify': 'Regional Product Approval',
  'menu.baseData.notice': 'Notice Management',
  'menu.systemManage.baseConfig': 'System Configuration',
  'menu.baseData.emailManage': 'Local Email Templates',
  'menu.baseData.provinceManage': 'Province Management',
  'menu.baseData.globalEmailManage': 'Global Email Templates',
  'menu.userManage.appUserRegister': 'ePartner User',
  'menu.userManage.marketingBU': 'Sales&Marketing BU',
  'menu.userManage.marketingHQ': 'Sales&Marketing HQ',
  'menu.userManage.SalesBU': 'Sales Collateral BU',
  'menu.userManage.SalesHQ': 'Sales Collateral HQ',
  'menu.contentManagent': 'Content Managent',

  // 20191016
  'menu.userManage.companyUserManager': 'Customer Management',
  'menu.baseData.gobalEmailManage': 'Global Email Templates',
  'menu.baseData.provinceManager': 'Province Management',
  'menu.systemManage.portalBaseConfig': 'System Configuration',
  'menu.baseData.Notice': 'Portal Notice Management',
  'menu.userManage.invitationToRegister': 'Invitation To Register',
  'menu.resourcePage.GloabalProduct': 'Global Product List',
  'menu.resourcePage.ProductOffering': 'PIS Offering Sync',
  'menu.resourcePage.ProductVerify': 'Regional Product Approval',
  'menu.resourcePage.ProductResource': 'Regional Product List',
  'menu.userManage.portalRoleManage': 'Role Management',
  'menu.systemManage.portalUserManage': 'Portal User Management',
  'menu.systemManage.portalResourceManage': 'Portal Menu',
  'menu.systemManage.customForm': 'Custom Form',
  'menu.systemManage.customFormCountry': 'custom Form Country',
  'menu.systemManage.customFormSetting': 'Custom Form Setting',
  'menu.coordinatorManage': 'Coordinator Management',
  'menu.coordinatorManage.srdCoordinatorManageList': 'Coordinator Management',
  'menu.pointManage': 'Point Management',
  'menu.pointManage.pointManageList': 'Point Management',
  'menu.pointManage.pointRecord': 'Point Record',
  'menu.pointManage.pointAjustment': 'Point Adjustment',
  'menu.pointManage.pointAjustmentEdit': 'Point Adjustment Edit',
  'menu.pointManage.taskManageList': 'Point Task Management',
  'menu.pointManage.invitationManageList': 'Invitation Management',
  'menu.giftManage': 'Gift Management',
  'menu.giftManage.giftManageList': 'Gift Management',
  'menu.giftManage.giftEdit': 'Gift Edit',
  'menu.giftManage.giftOrderEdit': 'Gift Delivery Order',
  'menu.giftManage.deliveryManageList': 'Gift Delivery Management',
  'menu.giftManage.delivery.orderView': 'Gift Delivery Order View',
  'menu.giftManage.delivery.orderEdit': 'Gift Delivery Order Edit',
  'menu.questionManage': 'Question Management',
  'menu.questionManage.questionManageList': 'Question Management',

  'menu.baseData.Offering': 'Offering',
  'menu.rewards': 'Rewards Management',
  'menu.rewards.pointsManagement': 'Points Management',
  'menu.rewards.giftManagement': 'Gift Management',
  'menu.rewards.redeemRecord': 'Ship Management',
  'menu.rewards.scanRecord': 'Scan Management',
  'menu.rewards.claimManage': 'Claim Management',
  'menu.rewards.claimManageDetail': 'Claim Detail',
  'menu.rewards.pointsManage': 'Points Management',
  // 'menu.rewards.pointsManage': 'Rewards Type Management',
  'menu.rewards.columnManage': 'Category Management',
  'menu.rewards.giftPickUpHistory': 'Gifts Picked Up History',
  'menu.appProduct': 'App Product Management',
  'menu.appProduct.productViewManagement': 'Product View Management',
  'menu.mergeProduct': 'MPS Product Management',
  'menu.mergeProduct.b2bPro': 'B2B Product',
  'menu.epartnerMarketing.epartnerLotteryPromotion': 'Lottery Promotion',
  //20200407 epartner新增
  'menu.epartnerUserManage': 'Customer Management',
  'menu.epartnerUserManage.epartnerCompanyAndUser': 'Company&User Management',
  'menu.epartnerProduct': 'Product Management',
  'menu.epartnerProduct.epartnerProductViewManagement': 'Product Management',
  'menu.epartnerProduct.pointsManagement': 'Point  Management',
  'menu.contentManagement': 'Content Management',
  'menu.contentManagement.newsManageHQ': 'Hik News-HQ',
  'menu.contentManagement.newsManageBU': 'Hik News-BU',
  'menu.contentManagement.solutionManageHQ': 'Solution-HQ',
  'menu.contentManagement.solutionManageBU': 'Solution-BU',
  'menu.contentManagement.supportManageHQ': 'Support-HQ',
  'menu.contentManagement.supportManageBU': 'Support-BU',
  // 'menu.contentManagement.swipeManageHQ': 'Handouts-HQ',
  // 'menu.contentManagement.swipeManageBU': 'Handouts-BU',
  // 'menu.contentManagement.videoManageHQ': 'Video-HQ',
  // 'menu.contentManagement.videoManageBU': 'Video-BU',
  'menu.contentManagement.disseminateManage': 'AD Page Management',
  'b2b-btns-preview': 'Preview',

  //20200430 epartner新增
  'menu.epartnerUserManage.epartnerAppUserRegister': 'User Management',
  'menu.epartnerUserManage.epartnerAppUserRegisterDetail': 'User Detail',
  'menu.epartnerUserManage.epartnerCompanyManagement': 'Company Management',
  'menu.epartnerUserManage.epartnerCompanyManagementDetail': 'Company Detail',
  'menu.contentManagement.epartnerBannerManage': 'Banner Management',
  'menu.epartnerMarketing': 'Marketing Management',
  'menu.epartnerMarketing.epartnerNotification': 'Notice Management',
  // 20201112新增
  'menu.epartnerUserManage.epartnerPointsBalance': 'Points Balance',
  'menu.epartnerUserManage.specialPoints': 'Special Points processing history',

  // 2020/11/18新增
  'menu.epartnerMarketing.epartnerMarketQuestion': 'Questions Management',
  'menu.epartnerMarketing.epartnerMarketSignIn': 'Sign In Management',
  'menu.epartnerMarketing.epartnerMarketAddSignIn': 'Add Sign In',
  'menu.epartnerMarketing.epartnerMarketCloneSignIn': 'Clone Sign In',
  'menu.epartnerMarketing.epartnerMarketDetailSignIn': 'Detail Sign In',
  'menu.epartnerMarketing.epartnerMarketEditSignIn': 'Edit Sign In',
  'menu.rewards.luckDrawManage': 'Lucky Draw Management',
  'menu.rewards.luckDrawManageLayout': 'Lucky Draw Management',
  // 2021/3/18新增
  'menu.epartnerMarketing.epartnerMarketSurvey': 'Survey Management',
  'menu.epartnerMarketing.epartnerSurveyResult': 'Survey Result',
  'menu.epartnerMarketing.epartnerMarketFeedback': 'Feedback Centre',

  // 2021/01/12新增
  'menu.epartnerMarketing.disburseManage': 'Disbursement Accounting',
  'menu.epartnerMarketing.startupMange': 'STRATUP Notification',
  'menu.systemManage.regionConfigure': 'Region Configure',
  'menu.contentManagement.swipeManageHQ': 'Hands outs-HQ',
  'menu.contentManagement.swipeManageBU': 'Hands outs-BU',
  'menu.contentManagement.videoManageHQ': 'Video-HQ',
  'menu.contentManagement.videoManageBU': 'Video-BU',
  'menu.colorVuManage.giftExchange': 'Gift Exchange',
  'menu.colorVuManage.campaignStatistics': 'Campaign Statistics',
  //20210222 RMA新增
  'menu.rma': 'RMA Management',
  // 20220606 wzq修改
  'menu.rma.myRepair': 'Repair Application - Distributor',

  // 20210526 pqx 新增
  'menu.customerData.sellout': 'Customer Sellout',
  'menu.customerData.forecast': 'Customer Forecast',
  'menu.customerData.inventory': 'Customer Inventory',

  // 20210618 pqx 新增
  'menu.userManage.EPCustomerMGT': 'Customer Management',
  'menu.EPcontentManagement': 'EP Content Management',
  'menu.userManage.pointBalance': 'Points Balance',
  'menu.marketing.notification': 'Push Management',
  'menu.marketing.lotteryPromotion': 'Lottery Promotion',
  'menu.marketing.question': 'Questions Management',
  'menu.marketing.signIn': 'Sign In Management',
  'menu.marketing.disburseManage': 'Disbursement Accounting',
  'menu.marketing.survey': 'Survey Management',
  'menu.marketing.feedback': 'Feedback Centre',
  'menu.EPcontentManagement.newsManageHQ': 'Hik News-HQ',
  'menu.EPcontentManagement.newsManageBU': 'Hik News-BU',
  'menu.EPcontentManagement.solutionManageHQ': 'Solution-HQ',
  'menu.EPcontentManagement.solutionManageBU': 'Solution-BU',
  'menu.EPcontentManagement.supportManageHQ': 'Support-HQ',
  'menu.EPcontentManagement.supportManageBU': 'Support-BU',
  'menu.EPcontentManagement.swipeManageHQ': 'Handouts-HQ',
  'menu.EPcontentManagement.swipeManageBU': 'Handouts-BU',
  'menu.EPcontentManagement.videoManageBU': 'Video-BU',
  'menu.EPcontentManagement.videoManageHQ': 'Video-HQ',
  'menu.EPcontentManagement.epartnerBannerManage': 'Banner Management',
  'menu.EPcontentManagement.columnManage': 'Category Management',
  'menu.EPproduct': 'EP Product Management',
  'menu.EPproduct.productManage': 'Product Management',
  'menu.EPproduct.pointsManagement': 'Point  Management',
  'menu.EPrewards': 'Rewards Management',
  'menu.EPrewards.pointsManagement': 'Points Management',
  'menu.EPrewards.giftManagement': 'Gift Management',
  'menu.EPrewards.redeemRecord': 'Ship Management',
  'menu.EPrewards.scanRecord': 'Scan Management',
  'menu.EPrewards.claimManage': 'Claim Management',
  'menu.EPrewards.claimManageDetail': 'Claim Detail',
  'menu.EPrewards.pointsManage': 'Points Management',
  // 'menu.EPrewards.pointsManage': 'Rewards Type Management',
  'menu.EPrewards.columnManage': 'Category Management',
  'menu.EPrewards.giftPickUpHistory': 'Gifts Picked Up History',
  'menu.EPrewards.luckDrawManage': 'Lucky Draw Management',

  // 20210728 pqx 新增
  'menu.userManage.OneHikId': 'OneHikID Customer',

  // 20210709 pqx 新建
  'menu.EPproduct.preOrderManagement': 'Promotion (Sell-Out) Management',
  'menu.EPproduct.preOrderManagementID': 'Pre-Order ID:',
  'menu.EPproduct.preOrderManagementPreName': 'Pre-Order Name:',
  // 20210817 pqx 新增
  'menu.project': 'Project Management',
  'menu.project.projectManage': 'Project Management',

  // 20210819 lzy新建
  'menu.project.priceBook': 'Price Book',
  // 20220426 wzq修改
  // 'menu.project.solution': 'Solution by Scenario',
  'menu.project.solution': 'Solution',
  // 'menu.baseData.homepageManagement':'Homepage Management',
  'menu.baseData.quotationManagement': 'Quotatition Management',

  // 20210826 pqx 新建
  'menu.content': 'Content Management',
  'menu.content.newsManage': 'News Management',
  'menu.content.howToManage': '【How To】Management',
  'menu.content.applicate': ' Application Management',

  //20210916 jwq新建
  'b2b.inviteRegisterNeedAgree': 'Invite Register Need Customer Agree',

  // 20210916 pqx 新增
  'menu.marketing.pushManagement': 'Message Management',
  'menu.marketing.activiteManagement': 'Activities Management',

  //20211021  jwq新建
  'menu.mps.mpsProduct': 'MPS Product Management',
  'menu.product': 'Product Management',
  'menu.product.productManage': 'B2B Product Management',
  'menu.product.maxBuyNum': 'MaxOQ Management',
  'menu.product.addCategory': 'Set Category',
  'menu.customerData': 'Data Management',
  'menu.systemManage.salesOrganization': 'Sale Organize Management',
  'menu.sapInfo.interfaceList': 'Sync Data from SAP',
  'menu.sapInfo.sapSyncRecord': 'Sync Record',
  'menu.contentManagent.marketingBU': 'Sales Marketing BU',
  'menu.contentManagent.marketingHQ': 'Sales Marketing HQ',
  'menu.public.product': 'Public Product Management',
  'menu.colorVuManage': 'colorVuManage',
  'menu.colorVuManage.activity': 'Activity',
  'menu.marketing.startupMange': 'Startup Notification',
  //20220125
  'menu.userManage.pddManagement': 'DPP Apply History',
  'b2b.systermManage.checkCustomerContact': 'Check Customer Contact Person&Phone Number',
  //20220323 pi模板银行新增
  'menu.systemManage.bankDetail': 'Bank Detail',
  // HPC
  'menu.HPCManagement': 'HPC Management',
  /* 社区 */
  'menu.forumManagement': 'Community Management',
  'menu.forumManagement.postsManagement': 'Posts Management',
  'menu.forumManagement.postDetail': 'Post Detail',
  'menu.forumManagement.categoryManage': 'Category Management',
  'menu.forumManagement.wordsFiltering': 'Words Filtering',
  'menu.forumManagement.userManagement': 'User Management',
  'menu.forumManagement.userDetail': 'User Detail',
  'menu.forumManagement.noEditRole.tip':
    'The SRD Registration process of the user is under verification. Please deal with the registration process firstly or wait till registration process is completed. Then it is allowed to modify this field.',

  // 直播模块
  'menu.srdLiveManagement': 'Live Management',
  'menu.srdLiveManagement.srdLiveMeetManagement': 'Live Management',
  'menu.srdLiveManagement.srdPostLiveManagement': 'Post Live Management',
  'menu.srdLiveManagement.srdEquipmentManagement': 'Equipment Management',
  'menu.srdLiveManagement.enterpriseCertification': 'Enterprise Certification',
  'menu.srdLiveManagement.srdTrainerManagement': 'Trainer Management',
  'menu.srdLiveManagement.srdLiveMeetingManagementDetails': 'Live Meeting Management-Details',
  'menu.srdLiveManagement.basicInfo': 'Basic Info',
  'menu.srdLiveManagement.customer': 'Customer',
  'menu.srdLiveManagement.column': 'Column',
  'menu.srdLiveManagement.shareAndPush': 'Share and Push',
  'menu.srdLiveManagement.srdProDisco': 'Pro Disco',
  'menu.srdContentManagement.proLandingManage': 'Promotion Landing',
  //2022 08 25
  'menu.marketing.activiteManagementPro': 'Activities Management Pro',

  // customerManagement
  ep_admin_user_company: 'Company ID/Name',
  ep_admin_user_companyType: 'Company Type',
  ep_admin_user_companyEmail: 'Company Email',
  ep_admin_user_sapId: 'SAP ID',
  ep_admin_user_countryId: 'Country',
  ep_admin_user_authorizedStatus: 'Is Authorized',
  ep_admin_user_isActive: 'Active Status',
  ep_admin_user_integration: 'Integration',
  ep_admin_user_hikIdOrName: 'OneHikID/Name',
  ep_admin_user_phone: 'Phone',
  ep_admin_user_userEmailSapId: 'User Email/SAP ID',
  ep_admin_user_userSource: 'Source',
  ep_admin_user_userType: 'User Type',
  ep_admin_user_isInternation: 'Is Internation',
  ep_admin_user_roleId: 'Customer Role',
  ep_admin_user_userStatus: 'User Approved',
  ep_admin_user_scanLimit: 'Scan Permission',
  ep_admin_user_vaspStatus: 'Vasp Status',
  ep_admin_user_province: 'State',
  ep_admin_user_crmAccountId: 'CRM Account ID',
  ep_admin_user_crmContactId: 'CRM Contact ID',
  ep_admin_user_registerDate: 'Register Date',
  ep_admin_user_uploadPurchaseEmail: 'Batch Upload B2B CustomerInfo',
  ep_admin_user_addCustomerFromSap: 'Add Customer from SAP',
  ep_admin_user_createAccount: 'Create Account',
  ep_admin_user_exportPartnerNetworkList: 'Export Partner Network List',
  ep_admin_user_companyId: 'Company ID',
  ep_admin_user_companyName: 'Company Name',
  ep_admin_user_city: 'City',
  ep_admin_user_companyPhone: 'Company Phone',
  ep_admin_user_oneHikId: 'One HikID',
  ep_admin_user_name: 'Name',
  ep_admin_user_role: 'Role',
  ep_admin_user_email: 'Email',
  ep_admin_user_downloadTemplate: 'Download template',
  ep_admin_user_selectCountry: 'Please select country',
  ep_admin_user_companyKeyWord: 'Company Key Word',
  ep_admin_user_userKeyWord: 'User Key Word',
  ep_admin_user_getSap: 'Get Info From SAP',
  ep_admin_user_userSapId: 'User SAP ID',
  ep_admin_user_userName: 'User Name',
  ep_admin_user_userEmail: 'User Email',
  ep_admin_user_userTelphone: 'User Telphone',
  ep_admin_user_userMobile: 'User Mobile',
  ep_admin_user_countryName: 'Country Name',
  ep_admin_user_contactPerson: 'Contact Person',
  ep_admin_user_contactPersonPhone: 'Contact Person Phone',
  ep_admin_user_currency: 'Currency',
  ep_admin_user_saleOrg: 'Sale Org',
  ep_admin_user_saleDept: 'Sale Dept',
  ep_admin_user_saleGroup: 'Sale Group',
  ep_admin_user_saleSapId: 'Sale SapId',
  ep_admin_user_region: 'Region',
  ep_admin_user_GST: 'GST',
  ep_admin_user_PAN: 'PAN',
  ep_admin_user_userGroup: 'User Group',
  ep_admin_user_priceGroup: 'Price Group',
  ep_admin_user_userGrade: 'User Grade',
  ep_admin_user_userArea: 'User Area',
  ep_admin_user_branch: 'Branch',
  ep_admin_user_docusignEmail: 'Docusign Email',
  ep_admin_user_financeEmail: 'Finance Email',
  ep_admin_user_purchaseEmail: 'Purchase Email',
  ep_admin_user_domesticTradeBusiness: 'Domestic Trade Business',
  ep_admin_user_internationalTradeBusiness: 'International Trade Business',
  ep_admin_user_domesticTradeBusinessEmail: 'Domestic Trade Business Email',
  ep_admin_user_internationalTradeBusinessEmail: 'International Trade Business Email',
  ep_admin_user_hierarchyAuthority: 'Hierarchy Authority',
  ep_admin_user_shiptocountry: 'Ship to country',
  ep_admin_user_creatToCountry: 'Create to Country',
  ep_admin_user_creatToCountry_tip: 'Please revise the country here if it\'s inconsistent with the real business country',
  ep_admin_user_displayUserGroup: 'Display User Group',
  ep_admin_user_countryRegion: 'Country/Region',
  ep_admin_user_hikId: 'HIK ID',
  ep_admin_user_maxLen128: 'Maximum length 128',
  ep_admin_user_iptFirstName: 'Please input firstName',
  ep_admin_user_iptLastName: 'Please input lastName',
  ep_admin_user_iptEmail: 'Please input email',
  ep_admin_user_firstName: 'First name',
  ep_admin_user_lastName: 'Last name',
  ep_admin_user_companyExistsTip:
    'The company already exists and this account will be created as an employee of the company.',
  ep_admin_user_companyNotExistsTip:
    'The company does not exist, we will create the OneHikID account.',
  ep_admin_user_createByOneHikID:
    'I’d like to create a parallel account with inputting its OneHikID to let it manage multiple company.',
  ep_admin_user_confirmPolice:
    'I confirm that I have informed the user and agreed to use this method to help him create an account .',
  ep_admin_user_checkPolice: 'Please check the agreement first!',
  ep_admin_user_setSapId: 'Set SAP ID',
  ep_admin_user_setCrmAccountId: 'Set CRM Account ID',
  ep_admin_user_setPortal: 'Set Portal Info',
  ep_admin_user_setB2b: 'Set B2B Info',
  ep_admin_user_setHpc: 'Set HPC Country',
  ep_admin_user_shippingAddress: 'Shipping address',
  ep_admin_user_subsidiaryCompany: 'Subsidiary Company',
  ep_admin_user_setEWallet: 'Set E-Wallet Sharing',
  ep_admin_user_approvedReject: 'Approved/Reject',
  ep_admin_user_setRole: 'Set Role',
  ep_admin_user_resetLogin: 'Reset Login',
  ep_admin_user_resetPassword: 'Reset Password',
  ep_admin_user_setCrmContactId: 'Set CRM Contact Id',
  ep_admin_user_setShipToSap: 'Set ship to SAP ID',
  ep_admin_user_addressLock: 'Address Lock',
  ep_admin_user_addressUnlock: 'Address Unlock',
  ep_admin_user_companyDetail: 'Company Detail',
  ep_admin_user_userDetail: 'User Detail',
  ep_admin_user_userSaleOrg: 'Sales Organization',
  ep_admin_user_mobile: 'Mobile',
  ep_admin_user_district: 'DISTRICT',
  ep_admin_user_currencyCode: 'Currency (Local/HQ)',
  ep_admin_user_internation: 'Internation',
  ep_admin_user_userAddressLock: 'Allow Address Editing',
  ep_admin_user_userStockShow: 'Allow Stock Display',
  ep_admin_user_userSaleName: 'Sales Name',
  ep_admin_user_hardware_contract: 'Hardware Contract',
  ep_admin_user_software_contract: 'Software Contract',
  ep_admin_user_billingAddress: 'Billing Address',
  ep_admin_user_partnerNo: 'Partner No.',
  ep_admin_user_crmLeadId: 'CRM Lead ID',
  ep_admin_user_crmOwnerName: 'CRM Owner Name',
  ep_admin_user_esalesAccountId: 'Esales Account ID',
  ep_admin_user_active: 'Active',
  ep_admin_user_status: 'Status',
  ep_admin_user_stateProvince: 'State/Province',
  ep_admin_user_address: 'Address Line 1',
  ep_admin_user_address2: 'Address Line 2',
  ep_admin_user_zipcode: 'Zip Code',
  ep_admin_user_taxId: 'Tax Id',
  ep_admin_user_creationTime: 'Created Time',
  ep_admin_user_authorizedTime: 'Approved Time',
  ep_admin_user_modificationTime: 'Modified Time',
  ep_admin_user_createdBy: 'Created By',
  ep_admin_user_modifiedBy: 'Modified By',
  ep_admin_user_FirstName: 'First Name',
  ep_admin_user_LastName: 'Last Name',
  ep_admin_user_oneHikID: 'OneHikID',
  ep_admin_user_mobilePhone: 'Mobile Phone',
  ep_admin_user_jobTitle: 'Job Title',
  ep_admin_user_registerData: 'Register Data',
  ep_admin_user_department: 'Department',
  ep_admin_user_lastLoginTime: 'Last Login Date',
  ep_admin_user_sapIdLogin: 'SAP ID Login',
  ep_admin_user_companyImageList: 'Shop/Business Image',
  ep_admin_user_companyConfig: 'Configuration items-Company',
  ep_admin_user_userConfig: 'Configuration items-User',
  ep_admin_user_companyActive: 'Company Active',
  ep_admin_user_hideStock: 'Hide Stock',
  ep_admin_user_HQTrading: 'HQ Trading',
  ep_admin_user_freightActive: 'Freight Active',
  ep_admin_user_handingFee: 'Handling Fee Active',
  ep_admin_user_maximumOrderQty: 'Maximum Order Qty',
  ep_admin_user_userActive: 'User Active',
  ep_admin_user_activationEmail: 'Unlock to send activation email to customer?',
  ep_admin_user_sendEmail2Unlock: 'Unlock and send email',
  ep_admin_user_notSendEmail2Unlock: 'Unlock but not send email',
  ep_admin_user_inputReason: 'Please Input Reason',
  ep_admin_user_reason: 'Reason',
  ep_admin_user_hide: 'hide',
  ep_admin_user_show: 'show',
  ep_admin_user_userStockStatusShow: 'Are you sure to {showStatus} stock for this company?',
  ep_admin_user_forbid: 'forbid',
  ep_admin_user_allow: 'allow',
  ep_admin_user_userAddressLockStatusShow:
    'Are you sure to {showStatus} this company to change address?',
  ep_admin_user_close: 'close',
  ep_admin_user_open: 'open',
  ep_admin_user_enable: 'enable',
  ep_admin_user_disable: 'disable',
  ep_admin_user_internationShowStatusShow:
    'Are you sure to {internationShowStatus} internation function for this customer?',
  ep_admin_user_activeHandlingFee: 'Confirm to {showStatus} the handling fee function?',
  ep_admin_user_activeMaximumOrderQty: 'Confirm to {showStatus} the maximum order quantity function?',
  ep_admin_user_sendActivationEmail2Customer: 'Unlock to send activation email to customer?',
  ep_admin_b2b_shopping_address: 'Domestic Shipping Address',
  ep_admin_b2b_internation_address: 'International Shipping Address',
  ep_admin_b2b_default: 'Default',

  //积分按钮
  ep_admin_gift_description: 'Gift Description',
  ep_admin_btns_reject: 'Reject',
  ep_admin_btns_ship: 'Ship',
  ep_admin_btns_view: 'View',
  ep_admin_btns_template: 'Template',
  ep_admin_btns_delete: 'Delete',
  ep_admin_btns_approve_reject: 'Approve/Reject',
  ep_admin_batch_delete: 'Batch Delete',

  //积分管理
  ep_admin_supplementary_settings: 'Supplementary Settings',
  ep_admin_shipped_date: 'Shipped Date',
  ep_admin_refund_date: 'Refund Date',
  ep_admin_address: 'Address',
  ep_admin_post_code: 'Post Code',
  ep_admin_receiving_info: 'Receiving Info',
  ep_admin_create_date: 'Create Date',
  ep_admin_batch_ship: 'Batch Ship',
  ep_admin_batch_reject: 'Batch Reject',
  ep_admin_message_received: 'Message received',
  ep_admin_giftId_giftname: 'Gift ID/Gift Name',
  ep_admin_confirm_delete: 'Are you sure you want to delete it?',
  ep_admin_display_order: 'Display Order',
  ep_admin_hot: 'Hot',
  ep_admin_publish: 'Publish',
  ep_admin_modification_date: 'Modify Date',
  ep_admin_effective_time: 'Effective Time',
  ep_admin_limitation_num: 'Limitations Per Person',
  ep_admin_redeemed_of_qty: 'Redeemed QTY',
  ep_admin_stock: 'Stock',
  ep_admin_scribing_price: 'Scribing Price',
  ep_admin_unit_price: 'Unit Price(Points)',
  ep_admin_sort: 'Sort',
  ep_admin_cover_image: 'Cover Image',
  ep_admin_gift_name: 'Gift Name',
  ep_admin_gift_id: 'Gift ID',
  ep_admin_gift_type: 'Gift Type',
  ep_admin_e_coupin_id: 'eCoupon ID',
  ep_admin_service_type: 'Service Type',
  ep_admin_ship_type: 'Ship Type',
  ep_admin_refund_reason: 'Refund Reason',
  ep_admin_points_return: 'Points Return',
  ep_admin_gift_infomation: 'Gift Information',
  ep_admin_logistics_company: 'Logistics Company',
  ep_admin_logistics_code: 'Logistics Code',
  ep_admin_ship_id: 'Ship ID',
  ep_admin_edit: 'Edit',
  ep_admin_claimID: 'Claim ID',
  ep_admin_appealPoints: 'Approver Points',
  ep_admin_approverDate: 'Approver Date',
  ep_admin_approver: 'Approver',
  ep_admin_approve: 'Approve',
  ep_admin_number_of_scan: 'Number of Scan(Successful)',
  ep_admin_warningDate: 'Warning Date',
  ep_admin_claimDate: 'Claim Date',
  ep_admin_scanDate: 'Scan Date',
  ep_admin_sn_code: 'SN Code',
  ep_admin_scanID: 'Scan ID',
  ep_admin_scan_history: 'Scan History',
  ep_admin_claim_history: 'Claim History',
  ep_admin_points_per_scan: 'Points Per Scan',
  ep_admin_productName: 'Product Name',
  ep_admin_productLineCode: 'Product Line Code',
  ep_admin_productKeyWord: 'Product Key Word',
  ep_admin_offering: 'Offering',
  ep_admin_brand: 'Brand',
  ep_admin_productLine: 'Product Line',
  ep_admin_series: 'Series',
  ep_admin_materialCode: 'Material Code',
  ep_admin_materialCode_batch: 'Material Code (Separate with ";")',
  ep_admin_materialCode_batch_limit: 'Maximum 1000 material codes allowed',
  ep_admin_exceptional_points: 'Exceptional points',
  ep_admin_companyID_email: 'Company ID/Email',
  ep_admin_btns_batchProcess: 'Batch Processing',
  ep_admin_btns_specialPoints: 'Special Points Processing',
  ep_admin_createdDate: 'Created Date',
  ep_admin_operate: 'Operate',
  ep_admin_operator: 'Operator',
  ep_admin_hpcSyncStatus: 'Hpc Sync Status',
  ep_admin_description: 'Description',
  ep_admin_specialPoints: 'Special Points',
  ep_admin_region: 'Region',
  ep_admin_positive: 'Positive or negative',
  ep_admin_creationDate: 'Creation Date',
  ep_admin_oAStatus: 'OA Status',
  ep_admin_remark: 'Remark',
  ep_admin_points: 'Points',
  ep_admin_date: 'Date',
  ep_admin_oneHikID: 'OneHikID',
  ep_admin_period: 'Period',
  ep_admin_category: 'Category',
  ep_admin_points_company_points_avalible: 'Company Points Avalible',
  ep_admin_points_admin_name: 'Admin Name',
  ep_admin_points_admin_oneHikID: 'Admin OneHikID',
  ep_admin_points_oneHikID_adminName: 'OneHikID',
  ep_admin_points_companyName_ID: 'Company Name/ID',
  ep_admin_points_companyName_email: 'Company Name/Email',
  ep_admin_points_companyKeywords: 'Company Keywords',
  ep_admin_points_balance: 'Points Balance',
  ep_admin_points_processHistory: 'Special Points Processing History',
  ep_admin_points_subBu: 'Sub-BU',
  ep_admin_points_pointType: 'Points Type',
  ep_admin_points_giftName: 'Gift Name',
  ep_admin_points_giftType: 'Gift Type',
  ep_admin_points_shipType: 'Ship Type',
  ep_admin_points_isPublish: 'Is Publish',
  ep_admin_points_updateDate: 'Update Date',
  ep_admin_points_effectiveTime: 'Effective Time(Redeem)',
  ep_admin_user_warning: 'Warning',
  ep_admin_user_warningAboutInvitation: 'Warning About Invitation',
  ep_admin_user_checkInviteUsers:
    'The following users invite too many users, please check whether these users have illegal operation.',
  ep_admin_user_numberOfInvites: 'Number of invites',
  ep_admin_user_justThisTime: 'Just this time',
  ep_admin_user_deleteExistingQuantity: 'Delete existing quantity',
  ep_admin_user_emailExists: 'The email already exists in eParnter, confirm to create a new user?',
  ep_admin_user_getInfoFromCrm: 'Get Info From CRM',
  ep_admin_user_contactId: 'Contact Id',
  ep_admin_user_crmIdNotExist: 'This ID not exist in CRM system',
  ep_admin_user_distributorVisibleOnProject: 'Is this Distributor visible on Project Registration?',
  ep_admin_user_testCustomer: 'Is this a Test Customer?',
  ep_admin_user_distributorVisibleOnCustomer:
    'Is this Distributor visible on Customer Registration?',
  ep_admin_user_editB2BInfo: 'Edit B2B Info',
  ep_admin_user_reportUploadNotificationBusiness: 'Report Upload Notification Business',
  ep_admin_user_maximumOrderQuantity: 'Maximum Order Quantity',
  ep_admin_user_upperLimitAmountOfFreightCharge: 'Upper Limit Amount of Freight Charge',
  ep_admin_user_freightChargeRate: 'Freight Charge Rate',
  ep_admin_user_customerStock: 'Customer Stock',
  ep_admin_user_minimumOrderAmount: 'Minimum Order Amount',
  ep_admin_ewallet_change_notification_email: 'E-Wallet Change Notification Email',
  ep_admin_user_unselectedCountrys: 'Unselected countrys',
  ep_admin_user_selectedCountrys: 'Selected countrys',
  ep_admin_user_setSubsidiary: 'Set Subsidiary',
  ep_admin_user_toRight: 'to right',
  ep_admin_user_toLeft: 'to left',
  ep_admin_user_shareDiscountPool: 'Share discount pool',
  ep_admin_user_subsidiaryActivated:
    'Once you save the relationship, system will collect the discount pool amount of those subsidiary activated with share discount pool function into their parent company. Continue to save it?',
  ep_admin_user_Approve: 'Approve',
  ep_admin_user_Reject: 'Reject',
  ep_admin_user_approvedJoinCompany: 'This user is going to be approved and join the Company.',
  ep_admin_user_inputRejectReason: 'Please input reject reason',
  ep_admin_user_enterRejectReason: 'Please enter the reason for rejection',
  ep_admin_user_areYouSure: 'Are you sure?',
  ep_admin_user_resetPasswordEmail:
    'Are you sure that you need to reset the password for email {email}?',
  ep_admin_user_customerChangeAddress:
    'Are you sure to {aShowStatus} this customer to change address?',
  ep_admin_user_epProUpgradeStatus: 'Upgrade to ePartner Pro',
  ep_admin_user_setUserType: 'Set User Type',
  ep_admin_user_user: 'User',
  ep_admin_user_admin: 'Admin',
  ep_admin_user_legalPerson: 'Legal Person',
  // 'ep_admin_user_companyExport': 'Document has been sent to your email [{email}]',
  ep_admin_points_subBuId: 'Sub-BU',
  ep_admin_points_country: 'Country',
  ep_admin_points_status: 'Status',
  ep_admin_points_giftIdName: 'Gift ID/Name',
  ep_admin_points_storeIdName: 'Store Company ID / User OneHikID',
  ep_admin_points_redeemDate: 'Redeem Date',
  ep_admin_points_pickedDate: 'Picked Date',
  ep_admin_points_pickUpStore: 'Pick Up Store',
  ep_admin_points_pickId: 'Pick ID',
  ep_admin_points_pickIdFilter: 'Pick ID (Seperate with ";")',
  ep_admin_points_pickIdPlaceholder: 'Seperate with ";"',
  ep_admin_points_Region: 'Region',
  ep_admin_points_RedeemDate: 'Redeem Date',
  ep_admin_points_giftId: 'Gift ID',
  ep_admin_points_Quantity: 'Quantity',
  ep_admin_points_hikId: 'User OneHikID',
  ep_admin_points_userName: 'User Name',
  ep_admin_points_companyName: 'User Company Name',
  ep_admin_points_distributerCompanyId: 'Store Company ID',
  ep_admin_points_distributorCompanyName: 'Store Company Name',
  ep_admin_points_distributerHikId: 'Verifier ID',
  ep_admin_points_distributorName: 'Verifier Name',
  ep_admin_points_pickUpTime: 'Picked Date',
  ep_admin_points_operation: 'Operation',
  ep_admin_points_reject: 'Reject',
  ep_admin_points_pickUpStores: 'Pick Up Stores',
  ep_admin_points_giftPickupAvailableStores: 'Gifts Pickup Available Stores',
  ep_admin_points_companyAddress: 'Company Address',
  ep_admin_points_companyIdName: 'Company ID/Name',
  ep_admin_points_companyId: 'Company ID',
  ep_admin_points_CompanyName: 'Company Name',
  ep_admin_points_state: 'State',
  ep_admin_points_city: 'City',
  ep_admin_points_deleteData: 'Are you sure delete this data?',
  ep_admin_points_pointsReturn: 'Points Return',
  ep_admin_points_refundReason: 'Refund Reason',
  ep_admin_points_shipOffline: 'Hikvision Ship -- Offline',
  ep_admin_points_shipOnline: 'Hikvision Ship -- Online',
  ep_admin_points_noShipAccount: 'No Shipping Required -- Account',
  ep_admin_points_years: '{year} Year(s)',
  ep_admin_points_noSetting: 'No setting required',
  ep_admin_points_pointsExceeding:
    'Points exceeding the effective duration will be expired on December 31 each year',
  ep_admin_points_exceedingWarning: 'Exceeding this value will trigger an warning',
  ep_admin_points_questionTitle: 'Question Title',
  ep_admin_points_category: 'Category',
  ep_admin_points_questionType: 'Type',
  ep_admin_points_template: 'Template',
  ep_admin_points_downloadData: 'Download Data',
  ep_admin_points_importQuestion: 'Import Question',
  ep_admin_points_batchDelete: 'Batch Delete',
  ep_admin_points_questionId: 'Question ID',
  ep_admin_points_answersTips: 'Answers&Tips',
  ep_admin_points_points: 'Points',
  ep_admin_points_answered: 'Answered',
  ep_admin_points_correctRate: 'Correct rate',
  ep_admin_points_creationTime: 'Create Date',
  ep_admin_points_chosenItem: 'Has chosen {number} items',
  ep_admin_points_answers: 'Answers',
  ep_admin_points_tips: 'Tips',
  ep_admin_points_analysis: 'Analysis',
  ep_admin_points_uploadedSuccessfully: 'Uploaded successfully!',
  ep_admin_points_errorExcelData: 'error excel data',
  ep_admin_points_deleteItems: 'Do you want to delete [{number}] items?',
  ep_admin_points_questionsDetail: 'Questions Detail',
  ep_admin_points_pickUpInStore: 'Pick up in store',
  ep_admin_points_newGift: 'New Gift',
  ep_admin_points_giftEdit: 'Gift Edit',
  ep_admin_points_storeName: 'Store',
  ep_admin_points_storeAddress: 'Address',
  ep_admin_points_luckDrawIdName: 'Luck Draw ID/Name',
  ep_admin_points_creator: 'Creator',
  ep_admin_points_luckyDrawId: 'Lucky Draw ID',
  ep_admin_points_luckyDrawName: 'Lucky Draw Name',
  ep_admin_points_rewards: 'Rewards',
  ep_admin_points_customers: 'Customers',
  ep_admin_points_rules: 'Rules',
  ep_admin_points_dubmitDate: 'Submit date',
  ep_admin_points_terminate: 'Terminated',
  ep_admin_points_result: 'Result',
  ep_admin_points_reward: 'Reward',
  ep_admin_points_drawResult: 'Draw Result',
  ep_admin_points_spentEachTime: 'Points spent each time',
  ep_admin_points_maxTimes: 'Maximum Daily Draw Times',
  ep_admin_points_rulesOfLuckyDraw: 'Lucky Draw Rules',
  ep_admin_points_item: 'Item',
  ep_admin_points_rewardName: 'Reward Name',
  ep_admin_points_rewardType: 'Reward Type',
  ep_admin_points_probability: 'Probability',
  ep_admin_points_companyType: 'Company Type',
  ep_admin_points_step1title: 'Basic Settings',
  ep_admin_points_step1content: 'Define Lucky Draw information',
  ep_admin_points_step2title: 'Choose Customers',
  ep_admin_points_step2content: 'Select  activity target customers',
  ep_admin_points_step3title: 'Set Rewards',
  ep_admin_points_step3content: 'Define rewards',
  ep_admin_points_step4title: 'Summary',
  ep_admin_points_step4content: 'Check all information',
  ep_admin_points_luckyDrawImage: 'Lucky Draw Image(16:9)',
  ep_admin_points_customerSelection: 'Customer Selection',
  ep_admin_points_customerPreview: 'Customer Preview',
  ep_admin_points_selected: 'Selected',
  ep_admin_points_conditionalSelection: 'Conditional selection',
  ep_admin_points_uploadCustomerList: 'Upload customer list',
  ep_admin_points_allCustomers: 'All customers',
  ep_admin_points_selectStates: 'Select states',
  ep_admin_points_distributor: 'Distributor',
  ep_admin_points_reseller: 'Reseller',
  ep_admin_points_installer: 'Installer',
  ep_admin_points_systemIntegrator: 'System Integrator',
  ep_admin_points_endUser: 'End User',
  ep_admin_points_OEM: 'OEM',
  ep_admin_points_ARC: 'ARC',
  ep_admin_points_downloadTemplate: 'Download template',
  ep_admin_points_selectedAllCustomers: 'All customers will be selected !',
  ep_admin_points_selectState: 'Select State',
  ep_admin_points_checkFirst: 'Please check the data first!',
  ep_admin_points_rewardPoints: 'Reward Points',
  ep_admin_points_rewardImage: 'Reward Image(1:1)',
  ep_admin_points_setInProductPointsScan: 'Set In【Product Points-Scan】',
  ep_admin_points_setInProductPointsAddDevice: 'Set In【Product Points-Add Device】',
  ep_admin_points_noSettingRequired: 'No setting required',
  ep_admin_points_setInInLuckDraw: 'Set In【Luck Draw Management】',
  ep_admin_points_setInQuestions: 'Set In【Questions Management】',
  ep_admin_points_setInCheckIn: 'Set In【Daily Check In】',
  ep_admin_points_minimailstStyle: 'Minimailst style',
  ep_admin_points_giftsStyle: 'Gifts style',
  ep_admin_points_luckDrawId: 'Luck Draw ID',
  ep_admin_points_limitPerDay: 'Limit per day',
  ep_admin_points_selectCountry: 'Please select country first',
  ep_admin_points_selectPickUpStore: 'Please select Pick up store first',
  ep_admin_points_customer: 'Customer',
  ep_admin_points_customersSelected: 'Totally {totle} customers selected',
  ep_admin_points_rewardsDefined: 'Totally 8 rewards defined',
  ep_admin_points_checkDetails: 'Check Details',
  ep_admin_points_selectUsers: 'Please select lottery users',
  ep_admin_points_deleteLuckDraw: 'Do you want to delete this data?',
  ep_admin_points_terminateDraw: 'Do you want to Terminate this data?',
  ep_admin_points_customerDrawResult: 'Customer draw result',
  ep_admin_points_rewardQuantity: 'Reward quantity',
  ep_admin_points_customerIdName: 'Customer ID/Name',
  ep_admin_points_drawTime: 'Draw Time',
  ep_admin_points_luckDrawConfirm: 'Confirm to publish it?',

  ep_admin_export_exportNotice: 'Export Notice',
  ep_admin_export_getIt: 'I get it',
  ep_admin_export_successExporting:
    "Exporting,please don't repeat the download operation.System will sent email to you when exported,you can enter the download center to view the task.",
  // 'ep_admin_user_warningExport': 'Document has been sent to your email',

  // BannerManagement
  ep_admin_banner_publishTo: 'Publish To',
  ep_admin_banner_name: 'Banner Name',
  ep_admin_banner_countryId: 'Country',
  ep_admin_banner_displayTime: 'Display Time',
  ep_admin_banner_add: 'Add',
  ep_admin_banner_picture: 'Picture',
  ep_admin_banner_displayPlace: 'Display Place',
  ep_admin_banner_updateTime: 'Update Time',
  ep_admin_banner_sort: 'Sort',
  ep_admin_banner_allRegion: 'All Region Display',
  ep_admin_banner_publish: 'Publish',
  ep_admin_banner_Allowcustomerstoclose: 'Allow customers to close',
  ep_admin_banner_addBanner: 'Create Banner',
  ep_admin_banner_editBanner: 'Edit Banner',
  ep_admin_banner_countryRegion: 'Country / Region',
  ep_admin_banner_picLanguage: 'Picture & Language',
  ep_admin_banner_language: 'Language',
  ep_admin_banner_url: 'URL',
  ep_admin_banner_addLanguage: 'Add Language',
  ep_admin_banner_sortTip:
    'The smaller number, the higher sorting. The number must be greater than 1',
  ep_admin_banner_tips: 'Tips',
  ep_admin_banner_content: 'The size of the picture is not appropriate',
  ep_admin_banner_okText: 'Continue',
  ep_admin_banner_uploadError: "This type of file isn't allowed to be uploaded",
  ep_admin_banner_uploadSize: 'Image must smaller than 1MB!',
  ep_admin_banner_uploadSuccess: 'file uploaded successfully.',
  ep_admin_banner_formCountryTip: 'Please select country',
  ep_admin_banner_formDisplayTimeTip: 'Please select display time',
  ep_admin_banner_formUploadTip: 'Please upload picture',
  ep_admin_banner_formLanguageTip: 'Please select language',
  ep_admin_banner_formSortTip: 'Please input sort',
  ep_admin_banner_formDeviceTip: 'Please select device type',
  ep_admin_banner_formDisplayTip: 'Please select display place',
  ep_admin_banner_formBannerTip: 'Please input banner name',
  ep_admin_banner_homePage: 'Home Page',
  ep_admin_banner_adPage: 'AD Page',
  ep_admin_banner_edit: 'Edit',
  ep_admin_banner_view: 'View',
  ep_admin_banner_deleteTip: 'Are you sure delete it?',
  ep_admin_banner_delete_yes: 'Yes',
  ep_admin_banner_delete_no: 'No',
  ep_admin_banner_delete: 'Delete',
  ep_admin_banner_bu: 'Bu',
  ep_admin_banner_subBu: 'SubBu',
  ep_admin_user_userSameTip: 'Customer {userId} has the same email.Do you want to continue?',
  ep_admin_points_pointsType: 'Points Type',
  ep_admin_points_countryId: 'Country ID',
  ep_admin_points_deviceQTYLevel: 'Device QTY Level',
  ep_admin_points_specialDevices: 'Special Devices',
  ep_admin_points_deviceQTY: 'Device QTY',
  ep_admin_points_per_device: 'Points Per Device',
  ep_admin_points_please_select_country: 'Please select a country first',
  ep_admin_points_add_new_level: 'Add New Level',
  ep_admin_points_CanntBeEmpty: "Cann't be empty",
  ep_admin_points_companyMultiple: 'Company Multiple',
  ep_admin_points_multiple: 'Multiple',
  ep_admin_points_dailyCheckIn: 'Daily Check In',
  ep_admin_points_consecutiveDays: 'Consecutive days',
  ep_admin_points_checkInMenu:
    'The main switch of the check-in is in the menu 【Points Type Management】',
  ep_admin_tips_uploadError: 'Upload Error!',
  ep_admin_btn_custom: 'Custom',
  ep_admin_btn_back: 'Back',
  ep_admin_app_customApp: 'Customize the application management of the current country.',
  ep_admin_app_HQDefault: 'If not,the configuration of the HQ will be defaulted.',
  ep_admin_app_selectRegion: 'Select an effective region',
  ep_admin_app_region: 'Region',
  ep_admin_app_newApp: 'New Application',
  ep_admin_app_editApp: 'Edit Application',
  ep_admin_app_country: 'Country',
  ep_admin_app_customApplication: 'Custom Application',
  ep_admin_app_section: 'Section',
  ep_admin_app_applicationName: 'Application Name',
  ep_admin_app_link: 'Link',
  ep_admin_app_logo: 'Logo',
  ep_admin_app_accessLevel: 'Access Level',
  ep_admin_app_role: 'Role',
  ep_admin_app_publish: 'Publish',
  ep_admin_app_companyType: 'Company Type',
  ep_admin_app_deleteApp: 'Are you sure delete this application?',

  //ExportManagement
  ep_admin_export_menuType: 'Menu',
  ep_admin_export_timeSlot: 'Export Time',
  ep_admin_export_taskStatus: 'Status',
  ep_admin_export_download: 'Download',
  ep_admin_export_no: 'NO.',
  ep_admin_export_documentName: 'Document Name',
  ep_admin_export_exportConditions: 'Export Conditions',
  ep_admin_export_operation: 'Operation',
  ep_admin_points_filterExport: 'Filter out the list of buid and country to export!',
  ep_admin_user_searchComponyKeyWord: 'Company ID/Company Name/Company Email/SAP ID/CRM Account ID/PP Company ID/CRM Number/Partner Program Number',
  ep_admin_user_searchUserKeyWord:
    'OneHik ID/User Name/User Phone/User Email/User SAP ID/CRM Contact ID',
  ep_admin_ship_reject_upload_err_tips: 'Failed to return records with the following ID',
  ep_admin_user_hpcGateway: 'Data Center',

  // lottery-promotion
  ep_admin_lottery_promotionId: 'Promotion ID',
  ep_admin_lottery_lotteryName: 'Promotion Name',
  ep_admin_lottery_creationDate: 'Creation Date',
  ep_admin_lottery_lotteryDescription: 'Promotion Description',
  ep_admin_lottery_period: 'Period',
  ep_admin_lottery_promotionInfomation: 'Promotion Infomation',
  ep_admin_lottery_rules: 'Rules',
  ep_admin_lottery_boughtFrom: 'Bought From',
  ep_admin_lottery_rewardInfo: 'Reward Info',
  ep_admin_lottery_receiptApproval: 'Receipt Approval',
  ep_admin_lottery_lotteryTickets: 'Lottery Tickets',
  ep_admin_lottery_enter: 'Enter',
  ep_admin_lottery_select: 'Select',
  ep_admin_lottery_status: 'Status',
  ep_admin_lottery_oneHikID: 'OneHikID',
  ep_admin_lottery_companyName: 'Company Name',
  ep_admin_lottery_uploadDate: 'Upload Date',
  ep_admin_lottery_code: 'Code',
  ep_admin_lottery_toBeApproved: 'To be Approved',
  ep_admin_lottery_approved: 'Approved',
  ep_admin_lottery_reject: 'Reject',
  ep_admin_lottery_details: 'Details',
  ep_admin_lottery_receiptID: 'Receipt ID',
  ep_admin_lottery_amount: 'Amount',
  ep_admin_lottery_purchaseDate: 'Purchase Date',
  ep_admin_lottery_userName: 'User Name',
  ep_admin_lottery_tickets: 'Tickets',
  ep_admin_lottery_userEmail: 'User Email',
  ep_admin_lottery_userPhone: 'User Phone',
  ep_admin_lottery_creator: 'Creator',
  ep_admin_lottery_image: 'Image',
  ep_admin_lottery_issuedTickets: 'Issued Tickets',
  ep_admin_lottery_userInfomation: 'User Infomation',
  ep_admin_lottery_voucherInfomation: 'Voucher Infomation',
  ep_admin_lottery_voucherId: 'Voucher ID',
  ep_admin_lottery_remark: 'Remark',
  ep_admin_lottery_voucher: 'Voucher',
  ep_admin_lottery_aboutToBeApproved: 'This application is about to be approved.',
  ep_admin_lottery_pleaseInputNumber: 'Please input the number.',
  ep_admin_lottery_willBeRejected: 'This application will be rejected.',
  ep_admin_lottery_pleaseInputReason: 'Please input the reject reason.',
  ep_admin_lottery_oncePassed: 'Once passed, it cannot be modified.',
  ep_admin_lottery_addLotteryPromotion: 'Add Lottery Promotion',
  ep_admin_lottery_editLotteryPromotion: 'Edit Lottery Promotion',
  ep_admin_lottery_200words: 'Max 200 words',
  ep_admin_lottery_useSemicolon: 'Tips: use semicolon(;) to separate options',
  ep_admin_lottery_contactEmail: 'Contact E-mail',
  ep_admin_lottery_contactNumber: 'Contact Number',
  ep_admin_lottery_duplicationUsersInDifferentRewards:
    'Allow duplication users in different rewards',
  ep_admin_lottery_duplicationUsersInCurrentRewards: 'Allow duplication users in current rewards',
  ep_admin_lottery_reward: 'Reward',
  ep_admin_lottery_rewardName: 'Reward Name',
  ep_admin_lottery_description: 'Description',
  ep_admin_lottery_quantity: 'Quantity',
  ep_admin_lottery_rewardImage: 'Reward Image',
  ep_admin_lottery_addReward: 'Add Reward',
  ep_admin_lottery_mostSupport8Rewards: 'Most support 8 rewards.',
  ep_admin_lottery_allowDuplicationUsers: 'Allow duplication users',
  ep_admin_lottery_operation: 'Operation',
  ep_admin_lottery_result: 'Result',
  ep_admin_lottery_draw: 'Draw',
  ep_admin_lottery_rewardSetting: 'Reward Setting',
  ep_admin_lottery_drawTime: 'Draw Time',
  ep_admin_lottery_ready: 'Ready',
  ep_admin_lottery_start: 'START',
  ep_admin_lottery_buId: 'BU',
  ep_admin_lottery_subBuId: 'Sub-BU',
  ep_admin_lottery_country: 'Country',
  ep_admin_lottery_25words: 'Max 25 words',
  ep_admin_lottery_deleteLottery: 'Do you want to delete this item?',
  ep_admin_lottery_enterCorrectFormat: 'Please enter the correct format.',
  ep_admin_lottery_max99999: 'Max 99999',
  ep_admin_lottery_goBack: 'Go Back',
  ep_admin_lottery_currency: 'Currency',
  ep_admin_lottery_terminated: 'Do you want to terminate this item?',

  // Dpp Management
  ep_admin_dpp_level: 'Level',
  ep_admin_dpp_applyDate: 'Apply Date',
  ep_admin_dpp_signType: 'Sign Type',
  ep_admin_dpp_nameId: 'Company Name/ID',
  ep_admin_dpp_disNameId: 'Supplier Company Name/ID',
  ep_admin_dpp_serProgram: 'Set Program',
  ep_admin_dpp_agreement: 'Agreement',
  ep_admin_dpp_certificate: 'Certificate',
  ep_admin_dpp_resetTip: 'After resetting, this record will be deleted, and customers can reapply.',
  ep_admin_dpp_programName: 'Program Name',
  ep_admin_dpp_disCompanyId: 'Supplier Company ID',
  ep_admin_dpp_disCompanyName: 'Supplier Company Name',
  ep_admin_dpp_newProgram: 'New Program',
  ep_admin_dpp_lastTime: 'Last modified time',
  ep_admin_dpp_lastBy: 'Last modified by',
  ep_admin_dpp_deleteProgramTip: 'Confirm to delete this program?',
  ep_admin_dpp_newDpp: 'New DPP Program',
  ep_admin_dpp_editDpp: 'Edit DPP Program',
  ep_admin_dpp_detailTipOne:
    'Please confirm that you have used the ALR to manage the account level in esale.(ALR=Account Level Request)',
  ep_admin_dpp_detailTipTwo:
    'Please contact IT colleagues to confirm the certificate template and contract template first.',
  ep_admin_dpp_programAbb: 'Program Abbreviation',
  ep_admin_dpp_eSalesProgram: 'eSales Program',
  ep_admin_dpp_effType: 'Effective Period',
  ep_admin_dpp_CustomerType: 'Customer Company Type',
  ep_admin_dpp_setDis: 'Set Supplier',
  ep_admin_dpp_hikSignatory: 'Hik Signatory',
  ep_admin_dpp_setLevel: 'Fixed Levels',
  ep_admin_dpp_allowTime: 'Allow multiple applications at the same time',
  ep_admin_dpp_allowDis: 'Allow signing with multiple suppliers',
  ep_admin_dpp_signingOrder: 'Signing order',
  ep_admin_dpp_combineSignatures: 'Combine Signatures',
  ep_admin_dpp_programIntro: 'Program Introduction',
  ep_admin_dpp_programAgree: 'Program Agreement',
  ep_admin_dpp_certificateTemplate: 'Certificate template',
  ep_admin_dpp_calendarYear: 'Calendar year',
  ep_admin_dpp_oneYear: 'One year since sign',
  ep_admin_dpp_inParticular: 'In no particular order',
  ep_admin_dpp_customSort: 'Custom Sort',
  ep_admin_dpp_image: 'Image',
  ep_admin_dpp_state: 'State',
  ep_admin_dpp_annual: 'Annual',
  ep_admin_dpp_offline: 'Offline',
  ep_admin_dpp_display: 'Display',
  ep_admin_dpp_target: 'Target',
  ep_admin_dpp_rebate: 'Rebate',
  ep_admin_dpp_approved: 'To be Approved',
  ep_admin_dpp_pending: 'Pending signing',
  ep_admin_dpp_completed: 'Completed',
  ep_admin_dpp_rejected: 'Rejected',
  ep_admin_dpp_followed: 'To be followed up',
  ep_admin_dpp_saved: 'Saved',
  ep_admin_dpp_oaApproving: 'OAApproving',
  ep_admin_dpp_onGoing: 'Ongoing',
  ep_admin_dpp_oaRejected: 'OARejected',
  ep_admin_dpp_signOffline: 'Online Authentication (contract signed offline)',
  ep_admin_dpp_customerSide: 'e-Signature request from customer side',
  ep_admin_dpp_hikvisionSide: 'e-Signature request from Hikvision side',
  ep_admin_dpp_companyTip: 'Please input company ID',
  ep_admin_dpp_companyNameTip: 'Cannot add an unauthenticated customer',
  ep_admin_dpp_tableTip: 'Please fill in the form',
  ep_admin_dpp_uploadPdf: 'Only support pdf',
  ep_admin_dpp_uploadWord: 'Only support word',
  ep_admin_dpp_detailTip: 'Please upload program',
  ep_admin_dpp_regionTip: 'Please select region',
  ep_admin_dpp_nameTip: 'Please input program name',
  ep_admin_dpp_abbreTip: 'Please input program abbreviation',
  ep_admin_dpp_esalesTip: 'Please select eSales program',
  ep_admin_dpp_signTypeTip: 'Please select sign type',
  ep_admin_dpp_periodTip: 'Please select effective period type',
  ep_admin_dpp_customerTip: 'Please select customer company type',
  ep_admin_dpp_hikSignTip: 'Please input hik signatory',
  ep_admin_dpp_currencyTip: 'Please select currency',
  ep_admin_dpp_timeTip: 'Please select allow multiple applications at the same time',
  ep_admin_dpp_disTip: 'Please select allow signing with multiple distributers',
  ep_admin_dpp_orderTip: 'Please select signing order',
  ep_admin_dpp_certificateTip: 'Please upload certificate template',
  ep_admin_dpp_certificateUploadTip:
    'Please upload certificate template',
  ep_admin_dpp_exportTip: 'Export succeeded',
  ep_admin_btns_ExportList: 'Export List',
  ep_admin_dpp_ExportAgreements: 'Export Agreements',
  ep_admin_dpp_ExportCertificates: 'Export Certificates',
  ep_admin_dpp_exportSelectTip: 'Please select the checklists you want to export first',
  ep_admin_dpp_exportLimitTip: 'Export Limit Exceeded',
  ep_admin_dpp_exportLimitTipContent:
    'Single export cannot exceed 100 items. Please export in multiple batches.',
  ep_admin_dpp_exportProcessingTip: 'Processing, download results will be notified by email later.',
  ep_admin_app_application: 'Application',
  ep_admin_luckDraw_region: 'Region',

  //Keywords Management
  ep_admin_keywords_searchResult: 'Search Result',
  ep_admin_keywords_searchDate: 'Search Date',
  ep_admin_keywords_companyKeywords: 'Company Key Words',
  ep_admin_keywords_userKeywords: 'User Key Words',
  ep_admin_keywords_searchWords: 'Search Key Words',
  ep_admin_keywords_searchId: 'Search ID',
  ep_admin_keywords_oneHikId: 'OneHik ID',
  ep_admin_keywords_searchType: 'Search Type',
  ep_admin_keywords_searchLocation: 'Search Location',
  ep_admin_keywords_keyWords: 'Keywords',
  ep_admin_keywords_subBu: 'Sub Bu',
  ep_admin_keywords_operationTime: 'Operation Time',
  ep_admin_explore_contentId: 'Content ID',
  ep_admin_explore_title: 'Title',
  ep_admin_explore_isVideo: 'Is Video',
  ep_admin_explore_isVideo_y: 'Y',
  ep_admin_explore_isVideo_n: 'N',
  ep_admin_explore_hotSort: 'Hot/Sort',
  ep_admin_explore_sort_hot: 'Hot',
  ep_admin_explore_sort_medium: 'Medium',
  ep_admin_explore_sort_low: 'Low',
  ep_admin_explore_type: 'Type',
  ep_admin_explore_type_product: 'Product',
  ep_admin_explore_type_caseStudy: 'Case Study',
  ep_admin_explore_category: 'Category',
  ep_admin_explore_format: 'Format',
  ep_admin_explore_creationDate: 'Creation Date',
  ep_admin_explore_country: 'Country',
  ep_admin_explore_bu: 'BU',
  ep_admin_explore_hq: 'HQ',
  ep_admin_explore_coverImage: 'Cover Image',
  ep_admin_explore_status: 'Status',
  ep_admin_explore_sort: 'Sort',
  ep_admin_explore_style: 'Style',
  ep_admin_explore_accessLevel: 'Access Level',
  ep_admin_explore_region: 'Region',
  ep_admin_explore_publisher: 'Publisher',
  ep_admin_explore_showTime: 'Show Time',
  ep_admin_explore_lastModifyDate: 'Last Modify Date',
  ep_admin_explore_views: 'Views',
  ep_admin_explore_likes: 'Likes',
  ep_admin_explore_shares: 'Shares',
  ep_admin_explore_favourate: 'Favourate',
  ep_admin_explore_status_saved: 'Saved',
  ep_admin_explore_status_toBeApproved: 'To be Approved',
  ep_admin_explore_status_approved: 'Approved',
  ep_admin_explore_status_rejected: 'Rejected',
  ep_admin_explore_publish: 'Publish',
  ep_admin_explore_hot: 'Hot',
  ep_admin_btns_comments: 'Comments',
  ep_admin_explore_basicInformation: 'Basic Information',
  ep_admin_explore_maxLen2000: 'Maximum length 2000',
  ep_admin_explore_maxLen: "Maximum length",
  ep_admin_explore_countryRegion: 'Country / Region',
  ep_admin_explore_keyWords: 'KeyWords',
  ep_admin_explore_displayTime: 'Display Time',
  ep_admin_explore_customerType: 'Customer Type',
  ep_admin_explore_customerType_distributor: 'Distributor',
  ep_admin_explore_customerType_reseller: 'Reseller',
  ep_admin_explore_customerType_installer: 'Installer',
  ep_admin_explore_customerType_systemIntegrator: 'System Integrator',
  ep_admin_explore_customerType_endUser: 'End User',
  ep_admin_explore_customerType_OEM: 'OEM',
  ep_admin_explore_customerType_ARC: 'ARC',
  ep_admin_explore_maximum100k: 'The image size cannot exceed 500k',
  ep_admin_explore_video: 'Video',
  ep_admin_explore_videoType: 'Video Type',
  ep_admin_explore_link: 'Link',
  ep_admin_explore_accessLevel_all: 'All',
  ep_admin_explore_accessLevel_authorized: 'Authorized',
  ep_admin_explore_accessLevel_nonAuthorized: 'Non-Authorized',
  ep_admin_explore_accessLevel_maximum5keywords:
    'Maximum 5 keywords for the posts which will help users to easily search.',
  ep_admin_explore_accessLevel_maximum20Hot:
    'Maximum 20 HOT posts in a month, please un-tag the other HOT posts if it is over 20.',
  ep_admin_explorep_admin_explore_uploadFilese_accessLevel_sortTooltip:
    'Tag MEDIUM will be merged to LOW after 2 months automatically.',
  ep_admin_explore_accessLevel_coverImageTooltip1: 'Video Ratio: 16:9; 9:16',
  ep_admin_explore_accessLevel_coverImageTooltip2: 'Non-Video Ratio: 16:9; 9:16; 4:3; 3:4',
  ep_admin_explore_accessLevel_coverImageTooltip3: 'You will have to re-upload content when change content format.',
  ep_admin_explore_accessLevel_videoTooltip: 'Y means this video can viewed in HPP and will not jump to external links.',
  ep_admin_explore_videoType_localUpload: 'Local Upload',
  ep_admin_explore_videoType_videoLink: 'Video Link',
  ep_admin_explore_videoType_linkTooltip: 'Y means this content will jump to this link directly.',
  ep_admin_explore_videoType_unsupportedVideoFormat: 'Unsupported video format',
  ep_admin_explore_detail: 'Detail',
  ep_admin_explore_relatedProducts: 'Related Products',
  ep_admin_explore_associatedAttachments: 'Associated Attachments',
  ep_admin_explore_pushNotification: 'Push Notification',
  ep_admin_medal_pushNotification_content: 'The system auto-sends messages to eligible customers for medals. Are you sure to remind customers again?',
  ep_admin_explore_NO: 'NO',
  ep_admin_explore_productName: 'Product Name',
  ep_admin_explore_materialCode: 'Material Code',
  ep_admin_explore_Scenario: 'Scenario',
  ep_admin_explore_Operation: 'Operation',
  ep_admin_explore_selectProducts: 'Select Products',
  ep_admin_explore_selectCountryFirst: 'Please select a country first',
  ep_admin_explore_toBeSelected: 'To Be Selected',
  ep_admin_explore_selected: 'Selected',
  ep_admin_explore_uploadFile: 'Upload File',
  ep_admin_explore_addFile: 'Add File',
  ep_admin_explore_sendMessage: 'Send Message',
  ep_admin_explore_occurence: 'Occurence',
  ep_admin_explore_now: 'Now',
  ep_admin_explore_definiteTime: 'Definite Time',
  ep_admin_explore_timeZone: 'Time Zone',
  ep_admin_explore_productLine: 'Product Line',
  ep_admin_explore_series: 'Series',
  ep_admin_explore_offering: 'Offering',
  ep_admin_explore_attachments: 'Attachments',
  ep_admin_explore_comments: 'Comments',
  ep_admin_explore_hotAdjust: 'Hot Adjust',
  ep_admin_explore_deleteExplore: 'Are you sure to delete this data ?',
  ep_admin_explore_contentPublishPreview: 'Hik-Partner Pro Content-Publish Apply — Preview',
  ep_admin_explore_listPreview: 'List Display Preview',
  ep_admin_explore_basicInfomation: 'Basic Infomation',
  ep_admin_explore_isLink: 'Is Link',
  ep_admin_explore_howToDocument: 'How to Document',
  ep_admin_explore_document: 'Document',
  ep_admin_explore_howToVideo: 'How to Video',
  ep_admin_explore_enterDetails: 'Please Enter Details!',
  ep_admin_explore_supportExtensions: 'Support Extensions: .rar .zip .doc .docx .pdf .jpg...',
  ep_admin_explore_isHot_y: 'Y',
  ep_admin_explore_isHot_n: 'N',
  ep_admin_explore_isPushEpartnerMessage_y: 'Y',
  ep_admin_explore_isPushEpartnerMessage_n: 'N',
  ep_admin_explore_modifyAllClone: 'Modify all clone articles synchronously?',
  ep_admin_explore_createNotification2regionAdmin:
    'Do you want to create an notification to region administrators for the release of this new?',
  ep_admin_explore_notifyAdmins: 'Yes! Notify Admins!',
  ep_admin_explore_notNotify: 'Not Notify, Only Post!',
  ep_admin_explore_onlyThisOne: 'No! Only This One!',
  ep_admin_explore_modifyAll: 'Yes! Modify All!',
  ep_admin_explore_clonedBy: 'Have been cloned by',
  ep_admin_explore_countiries: 'countiries',
  ep_admin_explore_accessLevel_sortTooltip:
    'Tag MEDIUM will be merged to LOW after 2 months automatically.',
  ep_admin_explore_waituUploaded: 'Please wait for the file upload to complete!',
  ep_admin_explore_unTagHot: 'Maximum 20 HOT posts, please un-tag the other HOT posts first.',
  ep_admin_explore_unTagHotTip: 'Or you can choose to replace the earliest posted HOT content.',
  ep_admin_explore_definiteTimeTip: 'The content message only can be pushed during display period.',

  // event management
  ep_admin_event_name: 'Event ID / Name',
  ep_admin_event_publishTo: 'Publish To',
  ep_admin_event_type: 'Event Type',
  ep_admin_event_id: 'Event ID',
  ep_admin_event_tableName: 'Event Name',
  ep_admin_event_img: 'Image',
  ep_admin_event_lastTime: 'Last Modify Date',
  ep_admin_event_publisher: 'Publisher',
  ep_admin_event_member: 'Member',
  ep_admin_event_app: 'HPP APP',
  ep_admin_event_portal: 'HPP Portal',
  ep_admin_event_appAndPortal: 'HPP Portal & HPP APP',
  ep_admin_event_checkInStatus: 'Check In Status',
  ep_admin_event_oneHikName: 'One Hik ID/User Name',
  ep_admin_event_approving: 'Approving',
  ep_admin_event_approved: 'Approved',
  ep_admin_event_rejected: 'Rejected',
  ep_admin_event_checkIn: 'Check In',
  ep_admin_event_checkIn_1: 'Checked-in',
  ep_admin_event_checkIn_2: 'Checked-in Unregistered',
  ep_admin_event_resendEmail: 'Resend Email',
  ep_admin_event_timeZone: 'Time Zone',
  ep_admin_event_linkId: 'Link ID',
  ep_admin_event_linkWeb: 'Link Web',
  ep_admin_event_linkapp: 'Link APP',
  // ep_admin_event_webLink: 'Webinar Link',
  // ep_admin_event_webNumber: 'Webinar Number',
  // ep_admin_event_webPassword: 'Webinar Password',
  ep_admin_event_registerTime: 'Register Time',
  ep_admin_event_cover: 'Banner',
  ep_admin_event_location: 'Event Location',
  ep_admin_event_time: 'Event Time',
  ep_admin_event_maxNum: 'Max Capacity',
  ep_admin_event_remainNum: 'Remaining Capacity',
  ep_admin_event_selection: 'Public Invitation by HPP',
  ep_admin_event_customerType: 'Customer Type',
  ep_admin_event_accessLevel: 'Access Level',
  ep_admin_event_role: 'Role',
  ep_admin_event_nameTip: 'Please input event name',
  ep_admin_event_publishTip: 'Please select publish to',
  ep_admin_event_timeZoneTip: 'Please select time zone',
  ep_admin_event_eventTypeTip: 'Please select event type',
  ep_admin_event_categoryTip: 'Please select event category',
  ep_admin_event_webLinkTip: 'Please input Online Url',
  ep_admin_event_maxCapacityTip: 'Please input max capacity',
  ep_admin_event_linkIdTip: 'Please input link ID',
  ep_admin_event_registerTimeTip: 'Please select register time',
  ep_admin_event_locationTip: 'Please input location',
  ep_admin_event_eventTimeTip: 'Please select event time',
  ep_admin_event_imgTip: 'Please upload cover image',
  ep_admin_event_customerSelectionTip: 'Please select customer selection',
  ep_admin_event_customerTypeTip: 'Please select customer type',
  ep_admin_event_accessLevelTip: 'Please select access level',
  ep_admin_event_roleTip: 'Please select role',
  ep_admin_event_basicInfo: 'Basic Information',
  ep_admin_event_clickUpload: 'Click to Upload',
  ep_admin_event_clear: 'clear',
  ep_admin_event_remainTip: 'Must be larger than registered',
  ep_admin_banner_coverTip: 'Ratio: 3.14: 1',

  //Complement Management
  ep_admin_complement_application_date: 'Application Date',
  ep_admin_complement_application_number: 'Application Number',
  ep_admin_complement_sap_id: 'SAP ID',
  ep_admin_complement_project_number: 'Project Number',
  ep_admin_complement_project_type: 'Project Type',
  ep_admin_complement_project_name: 'Project Name',
  ep_admin_complement_registration_number: 'Registration Number',
  ep_admin_complement_end_user: 'End User',
  ep_admin_complement_close_date: 'Closed Date',
  ep_admin_complement_project_supporter: 'Project Supporter',
  ep_admin_complement_applier: 'Applier',
  ep_admin_complement_compensation_method: 'Compensation Method',
  ep_admin_complement_qty: 'Qty',
  ep_admin_complement_stock_fob_price: 'Stock FOB Price',
  ep_admin_complement_crm_fob_price: 'CRM FOB Price',
  ep_admin_complement_actual_sales_price: 'Actual Sales Price',
  ep_admin_complement_landing_cost: 'Landing Cost',
  ep_admin_complement_margin: 'Margin',
  ep_admin_complement_actual_fob_price: 'Actual FOB Price',
  ep_admin_complement_crm_fob_discounted_price: 'CRM FOB Discounted Price',
  ep_admin_complement_attachment: 'Attachment',
  ep_admin_complement_operation_history: 'Operation History',
  ep_admin_complement_compensation_amount: 'Compensation Amount',
  ep_admin_complement_product_information: 'Product Information',
  ep_admin_complement_total_compensation_amount: 'Total Compensation Amount',
  ep_admin_complement_basic_information: 'Basic Information',
  ep_admin_complement_application_no: 'Application No.',
  ep_admin_complement_project_no: 'Project No.',
  ep_admin_complement_create_time: 'Create time',
  ep_admin_complement_create_by: 'Create by',
  ep_admin_complement_no_data: 'No Data',
  ep_admin_complement_OA: 'OA',
  ep_admin_complement_projects_applied: 'Projects Applied',
  ep_admin_complement_projects_waiting_applicate: 'Projects Waiting For Application',
  ep_admin_complement_exchange_rate: 'Exchange Rate',

  // admin Home
  ep_admin_home_welcome: 'Welcome',
  ep_admin_home_notice: 'Notice',
  ep_admin_home_history: 'History Usage Menu',
  ep_admin_home_faq: 'FAQ',
  ep_admin_home_document: 'Document',
  ep_admin_home_link: 'Quick Link To',
  ep_admin_home_viewMore: 'View More',
  ep_admin_home_type: 'Type:',
  ep_admin_home_more: 'More',
  ep_admin_home_noticeContent: 'Content',
  ep_admin_home_noticeModifier: 'Modifier',
  ep_admin_home_noticeTop: 'Top',
  ep_admin_home_typeTip: 'Please select type',
  ep_admin_home_contentTip: 'Please input content',
  ep_admin_home_urlTip: 'Please input URL',
  ep_admin_home_addNotice: 'Add EP Admin Home Notice',
  ep_admin_home_editNotice: 'Edit EP Admin Home Notice',
  ep_admin_home_faqQuestion: 'Question',
  ep_admin_home_faqAnswer: 'Answer',
  ep_admin_home_questionTip: 'Please input question',
  ep_admin_home_answerTip: 'Please input answer',
  ep_admin_home_addFaq: 'Add Question',
  ep_admin_home_editFaq: 'Edit Question',
  ep_admin_home_downloadTimes: 'Download Times',
  ep_admin_home_documentTip: 'Please upload file',
  ep_admin_home_addDocument: 'Add Document',
  ep_admin_home_editDocument: 'Edit Document',
  ep_admin_home_clickUpload: 'Click to Upload',
  ep_admin_home_clickUpload1: 'Click to add Link',
  ep_admin_home_uploadTip: 'A single file cannot exceed 50MB',
  ep_admin_home_addTip: 'Add successful',
  ep_admin_home_editTip: 'Edit successful',
  ep_admin_home_uploadSize: 'File must smaller than 50MB!',
  ep_admin_companyMerge_companyInfo: 'Company Info',
  ep_admin_companyMerge_operationTime: 'Operation Time',
  ep_admin_companyMerge_countryId: 'Country',
  ep_admin_companyMerge_hpcGateway: 'Data Center',
  ep_admin_companyMerge_companyIdBeMerge: 'Company ID',
  ep_admin_companyMerge_companyIdBeMerge_tip: 'Inactive after merging',
  ep_admin_companyMerge_companyNameBeMerge: 'Company Name',
  ep_admin_companyMerge_companyNameBeMerge_tip: 'Inactive after merging',
  ep_admin_companyMerge_companyIdToMerge: 'Company ID',
  ep_admin_companyMerge_companyIdToMerge_tip: 'Active after merging',
  ep_admin_companyMerge_companyNameAfterMerge: 'Company Name',
  ep_admin_companyMerge_companyNameAfterMerge_tip: 'Active after merging',
  ep_admin_companyMerge_operation: 'Operation',
  ep_admin_companyMerge_detail: 'Detail',
  ep_admin_companyMerge_property: 'Property',
  ep_admin_companyMerge_companyBeMerge: 'Company (Inactive after merging)',
  ep_admin_companyMerge_companyAfterMerge: 'Company (Active after merging)',
  ep_admin_companyMerge_companyName: 'Company Name',
  ep_admin_companyMerge_companyAdmin: 'Company Admin',
  ep_admin_companyMerge_companyAddress: 'Company Address',
  ep_admin_companyMerge_companyType: 'Company Type',
  ep_admin_companyMerge_companyEmail: 'Company Email',
  ep_admin_companyMerge_companyPhone: 'Company Phone',
  ep_admin_companyMerge_totalPoint: 'Total Points After Merging',
  ep_admin_companyMerge_point: 'Point',
  ep_admin_user_userNotUpgradedCompanyUpgraded:
    'Only search user not upgraded but company upgraded.',
  ep_admin_companyMerge_companyType_installer: 'Installer',
  ep_admin_companyMerge_companyType_systemIntegrator: 'System Integrator',
  ep_admin_companyMerge_companyType_alarmReceivingCenter: 'Alarm Receiving Center',
  ep_admin_companyMerge_companyType_endUser: 'End User',
  ep_admin_companyMerge_companyType_ITStaff: 'IT Staff',
  ep_admin_companyMerge_companyType_other: 'Other',
  ep_admin_companyMerge_companyType_distributor: 'Distributor',
  ep_admin_companyMerge_companyType_reseller: 'Reseller',
  ep_admin_companyMerge_companyType_OEM: 'OEM',
  ep_admin_companyMerge_status: 'Status',
  ep_admin_companyMerge_status_initiateMerger: 'Initiate Merger',
  ep_admin_companyMerge_status_merging: 'Merging',
  ep_admin_companyMerge_status_mergeFailed: 'Merge Failed',
  ep_admin_companyMerge_status_cancellationOfTheMergedCompany: 'Cancellation of the merged company',
  ep_admin_companyMerge_status_FailedMergedCompany: 'Failed to cancel the merged company',
  ep_admin_companyMerge_status_success: 'Success',
  ep_admin_companyMerge_status_invalid: 'Invalid',
  ep_admin_explore_maximum200M: 'The file size cannot exceed 200M',
  ep_admin_explore_maximum300M: 'The file size cannot exceed 300M',

  ep_admin_gift_meterialCode: 'Material Code',
  ep_admin_shipManage_countryStateCity: 'Country/State/City',
  ep_admin_companyMerge_status_companyAccount1: 'Company Account 1',
  ep_admin_companyMerge_status_companyAccount1_tip: 'Inactive after merging',
  ep_admin_companyMerge_status_companyAccount2: 'Company Account 2',
  ep_admin_companyMerge_status_companyAccount2_tip: 'Active after merging',

  ep_admin_home_valid: 'Valid',
  ep_admin_home_invalid: 'Invalid',
  ep_admin_home_documentDelete: 'The document has been downloaded. Whether to delete it',

  ep_admin_event_linkWebTip: 'Please input link web',
  ep_admin_event_linkAppTip: 'Please input link app',
  ep_admin_adpage_time_zone: 'Time Zone',
  ep_admin_adpage_duration: 'Duration (Unit is Seconds)',
  ep_admin_adpage_link_type: 'Link Type',
  ep_admin_adpage_link_id: 'Link ID',
  ep_admin_adpage_link_web: 'Link-Web',
  ep_admin_adpage_link_app: 'Link-APP',
  ep_admin_adpage_advertise_image: 'Advertisement Image',
  ep_admin_adpage_advertise_image_tips:
    'Please confirm that the key information of the advertising page should be displayed in the security area, and the boundary area will be cut when adapting to the screen of various proportions; Please fill solid color or non critical information in the unsafe area.',
  ep_admin_adpage_advertise_allowClose_tips: 'If select “Yes”, the customer can close current AD page and it will never be displayed again. If select “No”, the customer cannot turn it off manually.',
  ep_admin_explore_companyInformation: 'Company Information',
  ep_admin_explore_userInformation: 'User Information',
  ep_admin_explore_generalType: 'General',
  ep_admin_explore_replace: 'Replace',
  ep_admin_explore_replaceTip: 'Replacement succeeded',
  ep_admin_explore_tinymceUploadTip:
    'Please note that the image size has exceeded 5M. The smaller the image size, the faster the user loads it.',
  ep_admin_btns_setting: 'Setting',
  ep_admin_dpp_validityPeriod: 'Validity Period',
  ep_admin_dpp_agreementSource: 'Agreement Source',
  ep_admin_dpp_validityPeriodTip: 'Please select validity period',
  ep_admin_dpp_agreementSourceTip: 'Please select agreement source',
  ep_admin_dpp_refresh: 'Refresh',
  ep_admin_dpp_repush: 'Re-push',
  ep_admin_customer_setSign: 'Set Signatories(Partner Program)',
  ep_admin_dpp_refreshTip: 'Refresh success',
  ep_admin_dpp_repushTip: 'Re-push success',
  ep_admin_dpp_terminateTip: 'Are you sure to terminate it?',
  ep_admin_dpp_terminateSuccess: 'Terminate success',
  ep_admin_dpp_resetSuccessTip: 'Reset success',
  ep_admin_user_signatoryTip: 'Please select signatory',
  ep_admin_user_submitSuccess: 'Set signatory success',
  ep_admin_user_epCompanyId: 'EP Company ID',
  ep_admin_user_hpcCompanyId: 'HPC Company ID (short)',
  ep_admin_user_epUserId: 'EP User ID',
  ep_admin_user_hpcUserId: 'HPC User ID',
  ep_admin_user_cnpjNumber: 'CNPJ Number',
  ep_admin_event_export: 'Event Export',
  ep_admin_screenshot_of_scan: 'Screenshot of scan',
  ep_admin_scan_warning: 'Scan Warning',
  ep_admin_scan: 'Scan',
  ep_admin_scan_consecutive_sn: 'consecutive SN to lock account',
  ep_admin_scan_sn_in: 'SN in',
  ep_admin_scan_lock_account: 'minutes to lock account',
  ep_admin_scan_image_capture: 'Scan Image Capture',
  ep_admin_lottery_contact_email: 'Contact E-mail',
  ep_admin_lottery_contact_number: 'Contact Number',
  ep_admin_description_user_visible: 'Description(User Visible)',

  //message Record
  ep_admin_messageRecord_sentTime: 'Sent Time',
  ep_admin_messageRecord_userAccount: 'User Account',
  ep_admin_messageRecord_userEmail: 'User Email',
  ep_admin_messageRecord_areaCode: 'Area Code',
  ep_admin_messageRecord_emailRecord: 'Email Record',
  ep_admin_messageRecord_smsRecord: 'SMS Record',
  ep_admin_messageRecord_companyInfo: 'Company Info',
  ep_admin_messageRecord_companyName: 'Company Name',
  ep_admin_messageRecord_sapId: 'SAP ID',
  ep_admin_messageRecord_email: 'Email',
  ep_admin_messageRecord_template: 'Template',
  // 'ep_admin_banner_product': 'product',

  //purchaseDemand management
  ep_admin_purcharse_demand_product_info: 'Product Info',
  ep_admin_purcharse_demand_mark: 'Mark',
  ep_admin_purcharse_demand_time_period: 'Time Period',
  ep_admin_purcharse_demand_goods_name: 'Goods Name',
  ep_admin_purcharse_demand_desired_quantity: 'Desired Quantity',
  ep_admin_purcharse_demand_avail_stock: 'Avail.Stock',
  ep_admin_purcharse_demand_mark_as: 'Mark as',
  ep_admin_purcharse_demand_in_transit: 'In Transit',
  ep_admin_purcharse_demand_in_retired: 'Retired',
  ep_admin_purcharse_demand_in_unprocessed: 'Unprocessed',

  //exchangeRate management
  ep_admin_exchange_rate_from: 'From',
  ep_admin_exchange_rate_to: 'To',
  ep_admin_exchange_rate: 'Exchange Rate',
  ep_admin_exchange_buy_out: 'Buy Out',
  ep_admin_exchange_rate_start_time: 'Start Time',
  ep_admin_exchange_rate_end_time: 'End Time',
  ep_admin_exchange_rate_add_rate: 'Add Exchange Rate',
  ep_admin_exchange_rate_tip: 'Please refer to the last maintenance rate:',
  ep_admin_exchange_rate_currency_from: 'Currency From',
  ep_admin_exchange_rate_currency_to: 'Currency To',
  ep_admin_exchange_rate_oa_name: 'OA Name',
  ep_admin_exchange_rate_last_rate: 'Last Exchange Rate',
  ep_admin_exchange_rate_ratio: 'Exchange Rate Ratio',
  ep_admin_exchange_tatio: 'Ratio',
  ep_admin_exchange_log: 'Log',
  ep_admin_exchange_log_modify_date: 'Modified Date',
  ep_admin_exchange_log_modify_name: 'Modified Name',
  ep_admin_exchange_log_new_value: 'New Value',
  ep_admin_exchange_log_modal_title: 'Modified History',
  ep_admin_exchange_rate_add_exchange_rate_ratio: 'Add Exchange Rate Ratio',
  'ep_admin_exchange_rate_add_exchange_rate_exceeds_5%':
    'Exchange rate changes must not exceed 5% of the previous exchange rate value!',
  'ep_admin_exchange_rate_add_exchange_rate_lessthan_5%':
    'Please confirm that the exchange rate will take effect！（Your Exchange Rate：{rate}）',
  ep_admin_exchange_rate_table_tip:
    'The exchange rate ratio indicates the ratio of the source currency to the target currency, and the default ratio is 1:1. For example, if the exchange rate of the actual source currency USD:target currency COP is 4825, and the exchange rate ratio is set to 1000, you need to maintain the exchange rate to 4.8250.',
  ep_admin_exchange_rate_add_success:
    'The effective exchange rate is{rate},Click submit to take effect',
  ep_admin_exchange_rate_enter_four_decimal: 'Please enter eight decimal places',
  ep_admin_exchange_rate_enter_positive_integer: 'Please enter a positive integer',
  ep_admin_exchange_rate_delete_ratio: 'Are you sure to delete this Exchange Ratio?',
  ep_admin_exchange_rate_terminate_ratio:
    'Are you sure you want to terminate this rate? Users will not be able to switch to this rate from Protal. ',

  ep_admin_eCoupons_coupon_status: 'Status',
  ep_admin_eCoupons_coupon_status_Ongoing: 'Ongoing',
  ep_admin_eCoupons_coupon_status_Finished: 'Finished',
  ep_admin_eCoupons_coupon_status_Saved: 'Saved',
  ep_admin_eCoupons_coupon_status_Not_Start: 'Not Start',
  ep_admin_eCoupons_coupon_status_Terminated: 'Terminated',
  ep_admin_eCoupons_coupon_keyword: 'eCoupon Keyword',
  ep_admin_eCoupons_creation_date: 'Creation Date',
  ep_admin_eCoupons_country: 'Country',
  ep_admin_eCoupons_eCoupon_id: 'eCoupon ID',
  ep_admin_eCoupons_icon: 'Icon',
  ep_admin_eCoupons_eCoupon_name: 'eCoupon Name',
  ep_admin_eCoupons_eCoupon_decription: 'eCoupon Decription',
  ep_admin_eCoupons_eCoupon_decription_tip:
    'Please specify the use of the voucher in the voucher description to avoid any compliance risk.',
  ep_admin_eCoupons_qty: 'QTY',
  ep_admin_eCoupons_total_qty: 'Issued Qty',
  ep_admin_eCoupons_validity_period: 'Effective Period',
  ep_admin_eCoupons_daily_limit: 'Daily Limit',
  ep_admin_eCoupons_daily_limit_amount: 'Amount',
  ep_admin_eCoupons_daily_limit_quantity: 'Quantity',
  ep_admin_eCoupons_tax: 'Tax',
  ep_admin_eCoupons_creator: 'Creator',
  ep_admin_btns_terminate: 'Terminate',
  ep_admin_eCoupons_basic_info: 'Basic Settings',
  ep_admin_eCoupons_define_coupon: 'Define basic information',
  ep_admin_eCoupons_release_management: 'Usage Range',
  ep_admin_eCoupons_define_release_rules: 'Select Usage range',
  ep_admin_eCoupons_summary: 'Summary',
  ep_admin_eCoupons_please_check_info: 'Check all information',
  ep_admin_eCoupons_50words: 'Max 50 words',
  ep_admin_eCoupons_country_region: 'Region',
  ep_admin_eCoupons_600words: 'Max 600 words',
  ep_admin_eCoupons_254words: 'Max 254 words',
  ep_admin_eCoupons_eCoupon_icon: 'eCoupon Icon(1:1)',
  ep_admin_eCoupons_eCoupon_icon_tip: 'Ratio: 1:1, Maximum < 500k.',
  ep_admin_eCoupons_image_size: 'The image size cannot exceed 500k',
  ep_admin_eCoupons_contact_us: 'Contact Us',
  ep_admin_eCoupons_oa_number: 'OA Number',
  ep_admin_eCoupons_oa_number_check: 'Please input right OA Number',
  ep_admin_eCoupons_release_mechanism: 'Release Mechanism',
  ep_admin_eCoupons_release_mechanism_automatic_distribution: 'Automatic Distribution',
  ep_admin_eCoupons_release_mechanism_manual_collection: 'Manual Collection',
  ep_admin_eCoupons_per_person: 'Per Person',
  ep_admin_eCoupons_per_person_tip: 'Default quantity is 1, Maximum is 99.',
  ep_admin_eCoupons_coupon_qty: 'Coupon Qty',
  ep_admin_eCoupons_coupon_qty_tip: 'No maximum quantity by default.',
  ep_admin_eCoupons_single_limit: 'Single Limit',
  ep_admin_eCoupons_single_limit_tip: 'Default quantity is 1, Maximum is 99.',
  ep_admin_eCoupons_eCoupon_type: 'eCoupon Type',
  ep_admin_eCoupons_eCoupon_type_voucher: 'Voucher',
  ep_admin_eCoupons_eCoupon_type_cash: 'Cash',
  ep_admin_eCoupons_eCoupon_condition: 'eCoupon	Condition',
  ep_admin_eCoupons_eCoupon_condition_amount: 'Amount',
  ep_admin_eCoupons_eCoupon_discount: 'Discount',
  ep_admin_eCoupons_eCoupon_discount_discountAmount: 'Quota',
  ep_admin_eCoupons_eCoupon_discount_discountRatio: 'Ratio',
  ep_admin_eCoupons_face_value: 'Face Value',
  ep_admin_eCoupons_currency: 'Currency',
  ep_admin_eCoupons_tax_y: 'Y',
  ep_admin_eCoupons_tax_n: 'N',
  ep_admin_eCoupons_company_id: 'EP Company ID',
  ep_admin_eCoupons_company_name: 'Company Name',
  ep_admin_eCoupons_company_address: 'Company Address',
  ep_admin_eCoupons_set_provider: 'Set Provider:',
  ep_admin_eCoupons_set_customer: 'Set Customer:',
  ep_admin_eCoupons_input_company_id: 'Please Input Company ID',
  ep_admin_eCoupons_condition_selection: 'Condition Selection',
  ep_admin_eCoupons_upload_customer_list: 'Upload Customer List',
  ep_admin_eCoupons_customer_type: 'Customer Type',
  ep_admin_eCoupons_customer_type_reseller: 'Reseller',
  ep_admin_eCoupons_customer_type_system_integrator: 'System Integrator',
  ep_admin_eCoupons_customer_type_installer: 'Installer',
  ep_admin_eCoupons_customer_type_distributor: 'Distributor',
  ep_admin_eCoupons_customer_type_arc: 'ARC',
  ep_admin_eCoupons_customer_type_oem: 'OEM',
  ep_admin_eCoupons_provider_hide: 'Hide',
  ep_admin_eCoupons_provider_display: 'Display',
  ep_admin_eCoupons_customer: 'Customer',
  ep_admin_eCoupons_provider: 'Provider',
  ep_admin_eCoupons_selected: '{totle} Selected',
  ep_admin_eCoupons_submit_tip:
    '{customerSetNum} Customer will receive {eCouponsNum} eCoupon,still to submit?',
  ep_admin_eCoupons_terminated_eCoupons:
    'Once terminated, customers will not be able to collect the eCoupons, but the issued eCoupons will still be valid. Still to terminate?',
  ep_admin_eCoupons_delete_eCoupons: 'Sure to delete it?',
  ep_admin_eCoupons_added_provider: 'The company has been added as a provider.',
  ep_admin_eCoupons_provider_empty: 'Provider list is empty.',
  ep_admin_eCoupons_customer_empty: 'Customer list is empty',
  ep_admin_eCoupons_eCoupon_information: 'eCoupon information',
  ep_admin_eCoupons_period: 'Period',
  ep_admin_eCoupons_discount: 'eCoupon Discount',
  ep_admin_eCoupons_qrcode: 'eCoupon QR-Code',
  ep_admin_eCoupons_link: 'eCoupon Link',
  ep_admin_eCoupons_eCoupon_code: 'eCoupon Code',
  ep_admin_eCoupons_eCoupon_provider_company_id: 'Provider Company ID',
  ep_admin_eCoupons_eCoupon_status: 'Status',
  ep_admin_eCoupons_eCoupon_status_used: 'Used',
  ep_admin_eCoupons_eCoupon_status_invalid: 'Invalid',
  ep_admin_eCoupons_eCoupon_status_Received: 'Received',
  ep_admin_eCoupons_eCoupon_customer_company_id: 'Customer Company ID',
  ep_admin_eCoupons_eCoupon_customer_id: 'Customer OneHikID',
  ep_admin_eCoupons_eCoupon_received_date: 'Received Date',
  ep_admin_eCoupons_eCoupon_used_date: 'Used Date',
  ep_admin_eCoupons_eCoupon_OneHikID: 'OneHikID',
  ep_admin_eCoupons_eCoupon_user_name: 'User Name',
  ep_admin_eCoupons_eCoupon_email: 'Email',
  ep_admin_eCoupons_eCoupon_phone: 'Phone',
  ep_admin_eCoupons_eCoupon_provider_company_name: "Provider's Company Name",
  ep_admin_eCoupons_eCoupon_provider_name: 'Provider Name',
  ep_admin_eCoupons_city: 'City',
  ep_admin_eCoupons_company_type: 'Company Type',
  ep_admin_eCoupons_step2_tip:
    'The company cannot be a eCoupon user while it has been added as a provider. The system will remove it from customer list authomatically.',
  ep_admin_eCoupons_max_20: 'Max 20',
  ep_admin_eCoupons_eCoupon_currency_tip:
    'All eCoupons for this country will be displayed in the currency unit which was set for first eCoupon when the country was first created. The currency is for displaying to customer only and does not perform automatic exchange rate conversion.',
  ep_admin_complement_compensation_qty: 'Compensation Qty',
  ep_admin_complement_si_installer: 'SI/Installer',
  ep_admin_complement_project_document: 'Project Document',
  ep_admin_complement_compensation_notifcaiton_email: 'Compensation Notifcaiton Email',
  ep_admin_user_userOverview: 'User Overview',
  ep_admin_user_manage_project: 'Manage Project(ND)',
  ep_admin_user_partner_program_signature: 'Partner Program Signature',
  ep_admin_user_manage_project_tips: '可接收分享给ND或转派给ND的商机的通知并管理这些商机',
  ep_admin_user_admin_tips: '公司管理员，某些功能只有管理员才有权限',
  ep_admin_user_legal_person_tips: '公司法人,一个公司下只能有一个法人',
  ep_admin_user_scan_permission_tips: '扫码权限开启或关闭',
  ep_admin_user_user_active_tips: '员工账号激活或冻结',
  ep_admin_user_parnter_program_tips: 'DPP/VASP等协议签约人',
  ep_admin_user_sap_id_login_tips:
    '是否能以SAP ID作为账号登陆，只针对B2B客户，且一家公司下只允许一个员工以SAP ID作为账号登陆',
  ep_admin_banner_product: 'Product',

  ep_admin_verificate_addTitle: 'Create Verification Project',
  ep_admin_verificate_editTitle: 'Edit Verification Project',
  ep_admin_verificate_fileType: 'File Type',
  ep_admin_verificate_buyFrom: 'Bought From',
  ep_admin_verificate_email: 'Contact us e-mail',
  ep_admin_verificate_tel: 'Contact us number',
  ep_admin_verificate_receipt: 'Receipt',
  ep_admin_verificate_projectKeywords: 'Project Keywords',
  ep_admin_verificate_projectId: 'Project ID',
  ep_admin_verificate_projectDesc: 'Project Description',
  ep_admin_verificate_notstart: 'Not Start',
  ep_admin_verificate_projectinfo: 'Project Infomation',
  ep_admin_verificate_rejectOne:
    'This application will be rejected. Please input the reject reason.',
  ep_admin_verificate_rejectSecond: 'Once rejected, it cannot be modified.',
  ep_admin_verificate_uploadId: 'Upload ID',
  ep_admin_verificate_documents: 'Documents',
  ep_admin_verificate_userName: 'User Name',
  ep_admin_verificate_companyKeywords: 'Company Keywords',
  ep_admin_verificate_userKeywords: 'User Keywords',
  ep_admin_verificate_uploadInfo: 'Upload Information',
  ep_admin_verificate_finished: 'Finished',
  ep_admin_verificate_300words: 'Max 300 words',
  ep_admin_verificate_100words: 'Max 100 words',
  ep_admin_verificate_emailWords: 'Max 177 words',
  ep_admin_verificate_phoneWords: 'Max 15 words',
  ep_admin_verificate_deleteTip: 'Delete success',
  ep_admin_verificate_phoneTip: 'Incorrect phone format',
  ep_admin_verificate_downloadFailed: 'File download failed',
  ep_admin_verificate_uploadFailed: 'File upload failed',

  ep_admin_banner_single: 'Single Promotion',
  ep_admin_banner_clearance: 'Clearance',
  ep_admin_banner_samrtTry: 'Smart Try',
  ep_admin_banner_combo: 'Combo Discounts',
  ep_admin_banner_agingStock: 'Aging Stock Promotion',
  ep_admin_banner_viewBanner: 'View Banner',
  //FullboxManagement
  ep_admin_fullbox_with_product: 'Fullbox With Product',
  ep_admin_fullbox_with_customer: 'Fullbox With Customer',
  ep_admin_fullbox_with_price_group: 'Fullbox With Price Group',
  ep_admin_fullBox: 'Full Box',
  ep_admin_fullBox_mandatory: 'Mandatory Fullbox',
  ep_admin_fullBox_optional: 'Optional Fullbox',
  ep_admin_fullBox_upload: 'Batch Upload',
  ep_admin_fullBox_download_prdtmp: 'Download Product Fullbox Template',
  ep_admin_fullBox_download_csmtmp: 'Download Customer Fullbox Template',
  ep_admin_fullBox_price_group: 'Download Price Group Template',
  ep_admin_fullBox_open_minorder: 'Open Mandatory Fullbox',
  ep_admin_fullBox_open_option: ' Open Option Fullbox',
  ep_admin_fullBox_close_minorder: 'Close Mandatory Fullbox',
  ep_admin_fullBox_close_option: 'Close Option Fullbox',
  'ep_admin_points_ingetergt=0': 'Ingeter >= 0',
  ep_admin_points_ingetergt0: 'Ingeter > 0',
  ep_admin_points_product_share: 'Product-Share',
  ep_admin_points_product_share_tip: 'Set the point value that can be earned by share product',
  ep_admin_points_product_attachment_download: 'Product-Attachment Download',
  ep_admin_points_product_attachment_download_tip:
    'Set the point value that can be earned by download product attachments',
  ep_admin_points_product_category_first: 'Product Category First',
  ep_admin_points_select_product_category: 'Select Product Category',
  ep_admin_companyMerge_status_mergedCompanyReject: 'Vice-Company Rejected',
  ep_admin_companyMerge_status_mainCompanyReject: 'Main-Company Rejected',
  ep_admin_companyMerge_status_propertyprocessing: 'Property Processing',

  ep_admin_event_materialCode: 'Material Code',
  ep_admin_event_materialName: 'Material Name',
  ep_admin_event_materialPrice: 'Price',
  ep_admin_event_materialVat: 'VAT',
  ep_admin_event_surveyUrl: 'Survey URL',
  ep_admin_event_unpaid: 'Unpaid',
  ep_admin_event_checkout: 'Check Out',
  ep_admin_event_paid: 'Paid',
  ep_admin_event_materialTipTip: 'Please input material code',
  ep_admin_content_topic: 'Topic',
  ep_admin_content_topic_add: 'Add Item',
  ep_admin_content_topic_add_desc: 'Up to 10, please delete first if you need to add',
  ep_admin_content_topic_del_desc:
    'The topic will be hidden on APP&PC filter section after deletion. Continue to delete?',
  ep_admin_content_parent_id: 'Parent Id',
  ep_admin_user_editCrmAccountId: 'Edit CRM Account ID',
  ep_admin_user_unboundCRM: "Make sure you don't have a CRM ID bound to it",
  ep_admin_user_companyCombination: 'Company Combination',
  ep_admin_user_selectMergedCompany: 'Select Merged Company',
  ep_admin_user_note: 'Note',
  ep_admin_user_note_can_be_merged: 'Mergeable',
  ep_admin_user_note_not_upgraded: 'Unupgraded',
  ep_admin_user_note_can_not_be_merged: 'Unmergeable',
  ep_admin_user_note_complete: 'Complete',
  ep_admin_user_note_parallel: 'Parallel',
  ep_admin_user_no_company_be_selected: 'No company be selected.',
  ep_admin_companyMerge_status_EPAdminmergestart: 'Vice-Company Agreed',
  ep_admin_companyMerge_status_EPAdminWithdraw: 'Terminated',
  ep_admin_companyMerge_source: 'Source',
  ep_admin_companyMerge_source_eSales: 'eSales',
  ep_admin_companyMerge_source_EPAdmin: 'EP Admin',
  ep_admin_companyMerge_source_HPP: 'HPP',
  ep_admin_companyMerge_project: 'Project',
  ep_admin_companyMerge_project_regeistNumber: 'Registration Number',
  ep_admin_companyMerge_project_projectName: 'Project Name',
  ep_admin_companyMerge_project_companyName: 'Company Name',
  ep_admin_companyMerge_terminateCompanyMerge: 'Are you sure to terminate this company merge?',
  ep_admin_user_user_approval: 'User Approval',
  ep_admin_user_set_hpp_role: 'Set HPP Role',
  ep_admin_user_reject_reason: 'Reject Reason',
  ep_admin_user_rejectJoinCompany: 'Are you sure to reject this user to join this company?',

  ep_admin_addPage_sortTip: 'Drag the applications to sort it',
  ep_admin_addPage_appVersion: 'APP Version Limition',

  //MaxOQ Management
  ep_admin_maxoq_tab1: 'Max QTY for each order',
  ep_admin_maxoq_tab2: 'Max QTY for each customer',
  ep_admin_maxoq_shipForm: 'Ship From',
  ep_admin_maxoq_customerName: 'Customer Name',
  ep_admin_maxoq_maxQty: 'Max Qty',
  ep_admin_maxoq_productNameAndCode: 'Product Name/Code',
  ep_admin_maxoq_userId: 'User ID',
  ep_admin_maxoq_order_upload: 'Batch Upload Max Each Order',
  ep_admin_maxoq_order_export: 'Export Max Each Order',
  ep_admin_maxoq_order_download: 'Download Max Each Order Template',
  ep_admin_maxoq_customer_download: ' Download Max With Customer Template',
  ep_admin_maxoq_customer_upload: 'Batch Upload Max With Customer',
  ep_admin_maxoq_customer_export: 'Export Max With Customer',
  ep_admin_maxoq_start_date: 'Start Date',
  ep_admin_maxoq_end_date: 'End Date',
  ep_admin_maxoq_is_internation: 'isInternation',
  ep_admin_eCoupons_releaseLevel: 'Release Level',
  ep_admin_eCoupons_releaseLevel_all: 'All Customers',
  ep_admin_eCoupons_releaseLevel_authorized: 'Authorized',
  ep_admin_eCoupons_clone_tip1: 'Please check cloned information.',
  ep_admin_eCoupons_clone_tip2: 'Please check the release range.',

  ep_admin_addPage_snycBtn: 'SYNC All Regions',
  ep_admin_addPage_deleteTip:
    'This application will be deleted/removed from all areas. Do you want to continue?',
  // 积分任务新增
  ep_admin_points_eventResiter: 'Event Registration',
  ep_admin_points_eventCheckin: 'Event Check-in',
  ep_admin_points_eventRegisterTip:
    'Set the point value that can be earned by any events registration',
  ep_admin_points_eventCheckinTip: 'Set the point value that can be earned by any events check-in',
  ep_admin_points_applications: 'Open Any Applications',
  ep_admin_points_applicationsTip:
    'Set the point value that can be earned by open applications. Each application and user can only earn points once a day',
  ep_admin_points_purchase: 'Purchase value-added Services',
  ep_admin_points_purchaseTip:
    'Set the point value that can be earned by purchase value-added services',
  ep_admin_points_activate: 'Activate Hik-Central Connect',
  ep_admin_points_activateTip:
    'Set the point value that can be earned by activate Hik-Central Connect',
  ep_admin_points_purchaseHealth: 'Health Monitoring',
  ep_admin_points_purchaseCo: 'Co-Branding',
  ep_admin_points_purchaseEmploy: 'Employee Account',
  ep_admin_points_purchaseCloud: 'Cloud Storage',
  ep_admin_points_purchaseTraffic: '4G Traffic',
  ep_admin_points_purchaseHCC: 'HCC',
  ep_admin_points_balanceExpire: 'About to Expire',
  ep_admin_points_elearn: 'Elearning',
  ep_admin_points_supportCase: 'Support Case',
  ep_admin_points_chatbot: 'Chatbot',
  ep_admin_points_quotation: 'Quotation',
  ep_admin_points_sapd: 'SADP',
  ep_admin_points_tutor: 'Tutorial Center',
  ep_admin_points_service: 'Service Market',

  // event峰会
  ep_admin_event_shareH5Code: 'Share H5 QR code',
  ep_admin_event_emailConfig: 'Email Config',
  ep_admin_event_customerPosition: 'Customer Position',
  ep_admin_event_industry: 'Industry',
  ep_admin_event_invitationReasons: 'Invitation Reasons',
  ep_admin_event_heop: 'HEOP Workshop Attendee',
  ep_admin_event_salesOaName: 'OA Name of Sales',
  ep_admin_event_uploadTip: 'You can only upload Excel files!',
  ep_admin_event_inviteTitle: 'Invite Customer List',
  ep_admin_event_viewTitle: 'View Customer List',
  ep_admin_event_pushTitle: 'Send Push Message',
  ep_admin_event_emailContent: 'Email Content',
  ep_admin_event_pushTip: 'Click on the message to default to the details page',
  ep_admin_event_pushData: 'Push Message Data',
  ep_admin_event_memberUncheck: 'Non-checkin',
  ep_admin_event_customerTitle: 'Customer List',
  ep_admin_event_openLink: 'Open link',
  ep_admin_event_copyTip: 'Copy successful',
  ep_admin_event_sendEmailTip: 'Email sent successfully',
  ep_admin_event_emailTip1:
    '1. This email will be sent to each email address only once. Even if you edit this email content, the edited email will NOT be sent to the addresses to which you already sent the email before editing.',
  ep_admin_event_emailTip2:
    '2. Before sending this email, the system will save all the email settings first (including the settings of other email templates).',
  ep_admin_event_emailTip3:
    '3.Please make sure you already know the above two pieces of information, and then click OK to send the email.',
  ep_admin_gift_image_tip: 'Cover Image（Length&Width<2048, File Size<5M）',

  //Payment Management
  ep_admin_payment_paymentId: 'Payment ID',
  ep_admin_payment_order_number: 'Order Number',
  ep_admin_payment_3rd_transactionid: '3RD Transaction ID',
  ep_admin_payment_payer_email: 'Payer Email',
  ep_admin_payment_payer_name: 'Payer Name',
  ep_admin_payment_pay_time: 'Pay Time',
  ep_admin_payment_create_time: 'Create Time',
  ep_admin_payment_pay_method: 'Pay Method',
  ep_admin_payment_business: 'Business',
  ep_admin_payment_finalized_time: 'Finalized Time',
  ep_admin_payment_iva: 'IVA',
  ep_admin_payment_consumption_tax: 'Consumption Tax',
  ep_admin_payment_3rd_paymentod: '3RD Pay Method',
  ep_admin_payment_telephone: 'Telephone',
  ep_admin_payment_payid_card: 'Pay ID Card',
  ep_admin_payment_wompi_id: 'Wompi Transaction ID',
  ep_admin_payment_wompiid_reference: 'Payment ID',
  ep_admin_payment_created_at: 'Created At',
  ep_admin_payment_finalized_at: 'Finalized At',
  ep_admin_payment_full_name: 'Full Name',
  ep_admin_payment_billing_data: 'ID Card',
  ep_admin_payment_pay: 'Pay',
  ep_admin_payment_commission: 'Commission',
  ep_admin_payment_commission_avt: 'Commission VAT',
  ep_admin_payment_extra: 'Extra',
  ep_admin_payment_status_paying: 'Paying',
  ep_admin_payment_status_approved: 'Approved',
  ep_admin_payment_status_voided: 'Voided',
  ep_admin_payment_status_declined: 'Declined',
  ep_admin_payment_status_error: 'Error',
  ep_admin_payment_status_timeout: 'Timeout',
  ep_admin_payment_pay_method_card: 'CARD',
  ep_admin_payment_pay_method_nequi: 'NEQUI',
  ep_admin_payment_pay_method_pse: 'PSE',
  ep_admin_payment_pay_method_other: 'Other',
  ep_admin_payment_business_type: 'Business Type',
  ep_admin_user_payment_term: 'Domestic Payment Term',
  ep_admin_user_paymentterm_tip: 'Please input Domestic Payment Term',

  ep_admin_index_permission_tips: '您没有管理权限！',
  ep_admin_index_permission_title:
    '您当前只有首页只读权限，如要获取管理权限，请参考以下SOP进行申请',
  ep_admin_index_know: '知道了',
  ep_admin_content_hide_tips: 'Are you sure to hide this data ?',
  ep_admin_content_display_tips: 'Are you sure to display this data ?',
  ep_admin_content_batch_settings: 'Batch Settings',
  ep_admin_content_display_comments_tips:
    'You only can display the comments which pass the sensitive detection. Please noted that the comment number here not contains the deleted comment by users.',
  ep_admin_content_check_comments_tips:
    'The content is under review, please contact your regional Explore content leader for any questions.',
  //2023/10/08新增
  ep_admin_user_stock_list_download: 'Stock List Download',
  ep_admin_user_userStockStatus_open:
    'Are you sure to open permission for user to download Stock List?',
  ep_admin_user_userStockStatus_close:
    'Are you sure to close the permission for user to download Stock List?',
  ep_admin_customer_excel_error_msg: 'Excel Error Message',
  'menu.product.remain': 'Remain',
  ep_admin_user_distributor: 'Distributor',
  ep_admin_user_reseller: 'Reseller',
  ep_admin_user_installer: 'Installer',
  ep_admin_user_systemIntegrator: 'System Integrator',
  ep_admin_user_endUser: 'End User',
  ep_admin_user_OEM: 'OEM',
  ep_admin_user_ARC: 'ARC',
  ep_admin_user_In_Authorize: 'In Authorize',
  ep_admin_user_Authorized: 'Authorized',
  ep_admin_user_Authorized_by_Code: 'Authorized by Code',
  ep_admin_user_Refused: 'Refused',
  ep_admin_user_Non_Authorized: 'Non-Authorized',
  ep_admin_user_Waiting_to_add_device: 'Waiting to add device',
  ep_admin_user_No_integration_with_CRM: 'No integration with CRM',
  ep_admin_user_Customer_integrated_with_CRM: 'Customer integrated with CRM',
  ep_admin_user_Customer_integrated_with_SAP: 'Customer integrated with SAP',
  ep_admin_user_map_preview_map: 'Map Preview',
  ep_admin_user_map_Company_ID: 'Company ID',
  ep_admin_user_map_Company_Name: 'Company Name',
  ep_admin_user_map_Company_Type: 'Company Type',
  ep_admin_user_map_Country: 'Country',
  ep_admin_user_map_State: 'State',
  ep_admin_user_map_City: 'City',
  ep_admin_user_map_Applicant_email: 'Applicant email',
  ep_admin_user_map_Company_phone: 'Company phone',
  ep_admin_user_map_SAP_ID: 'SAP ID',
  ep_admin_user_map_Status: 'Status',
  ep_admin_user_map_Tag_Config: 'Tag Config',
  ep_admin_user_map_searchComponyKeyWord:
    'Company ID/Company Name/SAP ID/CRM Account ID/Store Name',
  ep_admin_user_map_Add_Customer_Map: 'Add Customer Map',
  ep_admin_user_map_Select_Map_Range: 'Select Map Range',
  ep_admin_user_map_Region_Name: 'Region Name',
  ep_admin_user_map_Tag: 'Tag',
  ep_admin_user_map_Contact_Phone: 'Contact Phone',
  ep_admin_user_map_Store_Address: 'Address',
  ep_admin_user_map_Contact_Email: 'Contact Email',
  ep_admin_user_map_Website: 'Company Website',
  ep_admin_user_map_Layer: 'Layer',
  ep_admin_user_map_Add_New_Tag: 'Add New Tag',
  ep_admin_user_map_Tag_Name: 'Tag Name',
  ep_admin_user_map_Tag_Background: 'Tag Background',
  ep_admin_user_map_Tag_Preview: 'Preview',
  ep_admin_user_map_Tag_Logo: 'Logo',
  ep_admin_user_map_Tag_Photo: 'Photo',
  ep_admin_user_map_status_Saved: 'Saved',
  ep_admin_user_map_status_To_be_Confirmed: 'To be Confirmed',
  ep_admin_user_map_status_To_be_Approved: 'To be Approved',
  ep_admin_user_map_status_Approved: 'Approved',
  ep_admin_user_map_status_Rejected: 'Rejected',
  ep_admin_user_map_status_Customer_Rejected: 'Customer Rejected',
  ep_admin_user_map_status_Unpublished: 'Unpublished',
  ep_admin_user_unmerageable_reson_property: 'Property',
  ep_admin_user_unmerageable_reson_if_existed: 'If Existed',
  ep_admin_user_unmerageable_reson_Device: 'Device',
  ep_admin_user_unmerageable_reson_Site: 'Site',
  ep_admin_user_unmerageable_reson_Unupgrade: 'Unupgrade',
  ep_admin_user_unmerageable_reson_HCC_Account: 'HCC Account',
  ep_admin_user_unmerageable_reson_HC: 'HC Account',
  ep_admin_user_unmerageable_reson_ARC: 'ARC Account',
  ep_admin_user_unmerageable_reson_HCB: 'HCB Account',
  ep_admin_user_unmerageable_reson_B2B: 'B2B Account',
  ep_admin_user_unmerageable_reson_Syscom: 'Syscom Account',
  ep_admin_user_unmerageable_reson_Order: 'Order',
  ep_admin_user_unmerageable_reson_third_party: 'Third-party intergration',
  ep_admin_user_unmerageable_reson_third_party_tip: '(API key/HCRG key/HCP key)',
  ep_admin_user_unmerageable_reson_In_Merging: 'In Merging',
  ep_admin_user_set_role_HPP_Role_type: 'HPP Role Type',
  ep_admin_user_set_role_EP_Role_type: 'EP Role Type',
  ep_admin_user_unmerageable_reson: 'Unmergeable Reson',

  ep_admin_points_luck_draw_maxWinningLimit: 'Maximum Winning Limit',
  ep_admin_points_singleLimit: 'Single Limit',
  ep_admin_points_rewardNo: 'Reward NO.',
  ep_admin_points_select_company_type: 'Please select company type.',
  ep_admin_points_view_more: 'View More',
  ep_admin_points_rewards_list: 'Rewards List',
  ep_admin_gift_shipReview: 'Ship Review',
  ep_admin_gift_sapTitle: 'SAP Information',
  ep_admin_points_sort: 'Sort',
  ep_admin_points_pointTask: 'Points Task',
  ep_admin_points_value: 'Points Value',
  ep_admin_points_Category: 'Category',
  ep_admin_points_Current_Region: 'Current Region:',
  ep_admin_points_SYNC_Other_Regions: 'SYNC Up To Other Regions',
  ep_admin_points_Main_Controls: 'Main Controls',
  ep_admin_points_Points_Task_List: 'Points Task List',
  ep_admin_points_Points_Consumption: 'Points Consumption',
  ep_admin_points_Limit_per_day: 'Limit per day/per person',
  ep_admin_points_Limit_per_month: 'Limit per month/per person',
  ep_admin_points_Limit_per_company: 'Limit per day/per company',
  ep_admin_points_Only_Legal_Person: 'Only Legal Person',
  ep_admin_points_Only_Exchange_Value_Currency: 'Exchange Value ({Currency})',
  ep_admin_points_Please_input_Lucky_Draw_ID: 'Please input right Lucky Draw ID.',
  ep_admin_points_Please_select_HomePage_points_entrance: 'Please select HomePage Points Entrance.',
  ep_admin_points_Please_input_Exchange_Rate: 'Please input Exchange Rate.',
  ep_admin_points_Please_input_effective_point: 'Please input Effective Duration of Points.',
  ep_admin_points_Exchange_Rate_value: '{monetaryValue} {currency} = {point} Points',
  ep_admin_points_only_legal_Y: 'Y',
  ep_admin_points_only_legal_N: 'N',
  ep_admin_btns_Configure: 'Configure',
  ep_admin_points_scan_restrictions: 'Scan Restrictions',
  ep_admin_points_Open_Any_Applications_Configure:
    'Which applications can be opened to earn points',
  ep_admin_points_New_Points_Task_Configure: 'Which eLearning exam qualifies customers for points',
  ep_admin_points_458_at_least_one: 'Please select at least one option for Exam Type or eLearning Type',
  ep_admin_points_458_exam_type_required: 'Please select at least one Exam Type',
  ep_admin_points_458_elearning_type_required: 'Please select at least one eLearning Type',
  ep_admin_points_458_online_exam_required: 'Please select at least one Exam Format (Online Exam or Onsite Exam)',
  ep_admin_points_458_certification_required: 'Please select at least one eLearning Type (Certification or Non-Certification)',
  ep_admin_points_456_Configure: 'Homepage Points Entrance Configuration',
  ep_admin_points_457_Configure: 'Lucky Draw Configuration',
  ep_admin_points_459_Configure: 'Membership Calculation Configuration',
  ep_admin_points_Qualifies_Customers_Configure:
    'Which eLearning exam qualifies customers for points',
  ep_admin_points_Purchase_value_added_services_Configure:
    'Which services-purchase can be earned points',
  ep_admin_exam_type: 'Exam Type',
  ep_admin_online_exam: 'Online Exam',
  ep_admin_onsite_exam: 'Onsite Exam',
  ep_admin_eleaning_type: 'eLearning Type',
  ep_admin_certification: 'Certification',
  ep_admin_non_certification: 'Non-Certification',
  ep_admin_points_SYNC_Other_Regions_title: 'Same Configurations SYNC Up To Other Regions',
  ep_admin_points_select_Regions: 'Select Regions',
  ep_admin_points_drag_tip:
    "Drag the points task title to sort（Except for 'Check In' and 'Add Device'）",
  ep_admin_points_type_416_tip:
    'Master switch of Points Program. Customers will see the points module within 10 mins after you turning this on.',
  ep_admin_points_type_417_tip:
    'Master switch of Points Program Authentication. Only authenticated customers can earn points after you turning this on.',
  ep_admin_points_type_9_tip:
    'Master switch of points effective duration. Customer points are only valid within the period of validity you have configured (unit:year).',
  ep_admin_points_type_436_tip:
    'Master switch of the points mall entrance on the home page. Customers will see the entrance to the points module on the home page after you turning this on. You should set the entrance style.',
  ep_admin_points_type_446_tip:
    'The points amount will be converted to your currency after you configure the exchange rate.',
  ep_admin_points_type_447_tip:
    'Upper limit of daily company points: Customers can only earn the quantity of points you set within a day.',
  ep_admin_points_type_408_tip:
    'Master switch of the lucky draw entrance. Please make sure the configured Lucky Draw ID is valid.',
  ep_admin_points_type_1_tip:
    'Master switch of checking in to earn points. Please set the tier points values in【Daily Check In】.',
  ep_admin_points_type_2_tip:
    'Master switch of addding device to earn points. Please set the tier points values in【Product Points - Add Device】.',
  ep_admin_points_type_400_tip:
    'Master switch of scanning product SN codes to earn points . Please set the points value of different products in【Product Points - Scan】.',
  ep_admin_points_type_4_tip:
    'Set the points value that can be obtained by completing authentication. This task is valid once and only for Installer Admin accounts.',
  ep_admin_points_type_403_tip:
    'Set the points value that can be obtained by inviting friends. This task is valid every time a friend is invited.',
  ep_admin_points_type_5_tip:
    'Set the points value that can be obtained by inviting staff. This task is valid once and only for Installer Admin accounts.',
  ep_admin_points_type_406_tip:
    'Master switch of answering questions to earn points. Please set the points value of products in【Questions Management】.',
  ep_admin_points_type_413_tip:
    'Set the points value that can be earned by browsing 【Feeds/TechZone Contents】.',
  ep_admin_points_type_414_tip:
    'Set the points value that can be earned by liking【Feeds/TechZone Contents】.',
  ep_admin_points_type_415_tip:
    'Set the points value that can be earned by sharing 【Feeds/TechZone Contents】.',
  ep_admin_points_type_437_tip:
    'Set the points value that can be earned by sharing products via HPP APP.',
  ep_admin_points_type_438_tip:
    'Set the points value that can be earned by downloading product attachments via HPP APP.',
  ep_admin_points_type_439_tip:
    'Set the points value that can be earned by any event registration.',
  ep_admin_points_type_440_tip: 'Set the points value that can be earned by any event check-in.',
  ep_admin_points_type_441_tip:
    'Set the points value that can be earned by opening applications. Each application and user can only earn points once a day.',
  ep_admin_points_type_442_tip:
    'Set the points value that can be earned by purchasing value-added services.',
  ep_admin_points_type_443_tip:
    'Set the point value that can be earned by activating HikCentral Connect.',
  ep_admin_points_type_433_tip:
    'Set the points value earned by finish and submit the survey',
  ep_admin_points_type_444_tip: 'Set the points value that can be earned by closing cases.',
  ep_admin_points_type_445_tip: 'Set the points value that can be earned by sharing quotations.',
  ep_admin_points_441_442_select_tip: 'Please select last one.',
  ep_admin_points_452_tip: 'Set the points value that can be obtained by inviting friends to join in community. This task is valid every time a friend is invited.',
  ep_admin_points_456_tip: 'Customers will get points after registering for eLearning and passing the review. To stop abnormal point farming, please set a point cap.',
  ep_admin_points_457_tip: 'Customers will get points after checking in eLearning. To stop abnormal point farming, please set a point cap.',
  ep_admin_points_458_tip: 'Customers will get points after passing the exam of eLearning. To stop abnormal point farming, please set a point cap.',
  ep_admin_points_459_tip: 'Customers will get points after getting certifications. To stop abnormal point farming, please set a point cap.',
  ep_admin_points_value_required: 'Point value is required.',
  ep_admin_points_Daily_larger_Point: 'Daily limit must larger than "Point value".',
  ep_admin_points_Monthly_larger_Daily: 'Monthly limit must larger than Daily Limit.',
  ep_admin_points_Monthly_larger_Point: 'Monthly limit must larger than "Point value"',
  ep_admin_points_company_larger_Daily: 'Company limit must larger than Daily Limit.',
  ep_admin_points_company_larger_Point: 'Company limit must larger than "Point value"',

  ep_admin_contact_layer: 'Layer',
  ep_admin_contact_region_id: 'Region ID',
  ep_admin_contact_configuration: 'Configuration',
  ep_admin_contact_tech_support_contact: 'Tech Support Contact',
  ep_admin_contact_exchage_rate_currency: 'Exchage Rate && Currency',
  ep_admin_contact_value: 'Value',
  ep_admin_contact_others: 'Others',
  ep_admin_contact_email_correct_tips: 'Please enter the correct email format',
  ep_admin_exchange_reference_rate: 'M3 Rate',
  ep_admin_exchange_m3: 'M3',
  ep_admin_exchange_reminder: 'Control Rule',
  ep_admin_exchange_greater_than_m3: 'Exchange Rate < M3',
  ep_admin_exchange_less_than_m3: 'Exchange Rate > M3',
  ep_admin_complement_advance_payment_ratio: 'Advance Payment Rate',
  ep_admin_complement_payment_ratio_tip:
    'Number must be greater than or equal to 0, with a maximum of 4 decimal places retained.',
  ep_admin_preorder_order_no: 'Pre-order No.',
  ep_admin_fuzzy_stock_list: 'Fuzzy Stock List',
  ep_admin_preorder_customer_po: 'Customer PO',
  ep_admin_preorder_sap_no: 'SAP No.',
  ep_admin_preorder_shopping_mehtod: 'Internaitional Shipping Method',
  ep_admin_preorder_total_neto: 'Total Neto',
  ep_admin_preorder_advance_payment: 'Advance Payment',
  ep_admin_preorder_final_payment: 'Final Payment',
  ep_admin_preorder_total_amount: 'Total Amount',
  ep_admin_preorder_item_id: 'Item ID',
  ep_admin_preorder_freight_charge: 'International Freight Charge',
  ep_admin_preorder_product_price: 'Product Price',
  ep_admin_preorder_customerId: 'Customer ID',
  ep_admin_preorder_sap_error: 'SAP Error',
  ep_admin_preorder_street: 'Street',
  ep_admin_preorder_receiving_address: 'Receiving address',
  ep_admin_preorder_modify_price: 'Modify Price',
  ep_admin_preorder_sync_sap: 'Sync From SAP',
  ep_admin_preorder_submit_agin: 'Submit Again',
  ep_admin_preorder_calc_price: 'Calculate Order Price',
  ep_admin_preorder_confirm_tip:
    'The price can only be modified once. After submission. the price will be sent to SAP and cannot be modified again later.',
  ep_admin_preorder_sap_update_success: 'SAP updates successfully!',
  ep_admin_preorder_sap_update_fail: 'SAP updates failed!',
  ep_admin_preorder_sap_error_fail: 'Fail',
  ep_admin_preorder_in_synchronous: 'In synchronous',
  ep_admin_preorder_please_select: 'Please Select',
  ep_admin_preorder_opertion_success: 'The item has been operated successfully',
  ep_admin_preorder_no: 'No.',
  ep_admin_preorder_ifc_rate: 'IFC Rate',
  ep_admin_preorder_ifc_unit: 'Unit IFC',
  ep_admin_preorder_unit_price: 'Unit Price',
  ep_admin_preorder_net_amount: 'Net Amount',
  ep_admin_preorder_total_freight_charge: 'Total International Freight Charge',
  'ep_admin_preorder_download': 'Preorder Download',
  ep_admin_company_detail: 'Company Detail Information',
  ep_admin_company_website: 'Company Website',
  ep_admin_company_establishment_time: 'Company Esftablishment Time',
  ep_admin_company_occupation: 'Occupation',
  ep_admin_company_products_for_sale: 'Products for Sale',
  ep_admin_company_number_of_employees: 'Number of Employees',
  ep_admin_company_annual_security_revenue: 'Annual Security Revenue',
  ep_admin_company_state_province_region: 'State/Province/Region',
  ep_admin_company_annual_revenue_in_ccty_rroducts: 'Annual Revenue in CCTV Products',
  ep_admin_company_primary_vertical_industry: 'Primary Vertical Industry',
  ep_admin_company_postal_code: 'Postal Code',
  ep_admin_company_distributor_from_whom_you_purchase_devices:
    'Distributor from Whom You Purchase Devices',
  ep_admin_company_photo_as_evidence: 'Photo as Evidence',
  ep_admin_company_company_phone_number: 'Company Phone Number',
  ep_admin_company_recommended_sales: 'Recommended Sales',
  ep_admin_company_vAT_number: 'VAT Number',
  ep_admin_company_approval_type: 'Approval Type',
  ep_admin_company_platform: 'Platform',
  ep_admin_company_approval: 'Approver',
  ep_admin_company_approval_link: 'Approval Link',
  ep_admin_company_current_company_name: 'Current Company Name',
  ep_admin_company_Current_company_type: 'Current Company Type',
  ep_admin_company_vat_number: 'VAT Number',
  ep_admin_company_current_vat_number: 'Current VAT Number',
  ep_admin_company_current_city: 'Current City',
  ep_admin_company_current_state_province_region: 'Current State/Province/Region',
  ep_admin_company_current_address: 'Current Address',
  ep_admin_company_authentication: 'Authentication',
  ep_admin_company_company_info_change: 'Company Info Change',
  ep_admin_company_cloud_admin: 'Cloud Admin',
  ep_admin_company_auth_company_detail: 'Authentication Company Detail',
  ep_admin_company_modify_company_detail: 'Company Info Change',
  ep_admin_company_auth_cnic_number: 'CNIC Number',
  ep_admin_dpp_basic_information: 'Basic information',
  ep_admin_dpp_max_200: 'Max 200',
  ep_admin_dpp_max_10: 'Max 10',
  ep_admin_dpp_T_R: 'T/R',
  ep_admin_dpp_q1: 'Q1',
  ep_admin_dpp_q2: 'Q2',
  ep_admin_dpp_q3: 'Q3',
  ep_admin_dpp_q4: 'Q4',
  ep_admin_dpp_contracting_parties: 'Contracting Parties',
  ep_admin_dpp_contracting_parties_Customer: 'Customer',
  ep_admin_dpp_contracting_parties_Supplier: 'Supplier',
  ep_admin_dpp_contracting_parties_Hikvision: 'Hikvision',
  ep_admin_dpp_Customer_Type: 'Customer Type',
  ep_admin_dpp_Customer_State: 'Customer State',
  ep_admin_dpp_Suppliers_Display: 'Suppliers Display',
  ep_admin_dpp_suppliersDisplay_y: 'Y',
  ep_admin_dpp_suppliersDisplay_N: 'N',
  ep_admin_dpp_multipleSuppliersSelection_y: 'Y',
  ep_admin_dpp_multipleSuppliersSelection_N: 'N',
  ep_admin_dpp_Multiple_Suppliers_Selection: 'Multiple Suppliers Selection',
  ep_admin_dpp_Upper_limit: 'Upper limit',
  ep_admin_dpp_Supplier_Notification: 'Supplier Notification',
  ep_admin_dpp_Supplier_Notification_y: 'Y',
  ep_admin_dpp_Supplier_Notification_N: 'N',
  ep_admin_dpp_Contract_Information_Configuration: 'Contract Information Configuration',
  ep_admin_dpp_Sequence_of_esales_review: 'Sequence of esales review',
  ep_admin_dpp_Sequence_of_esales_review_BeforSign: 'Before Sign',
  ep_admin_dpp_Sequence_of_esales_review_AfterSign: 'After Sign',
  ep_admin_dpp_Sequence_of_esales_review_NoNeedForReview: 'No Need for Review',
  ep_admin_dpp_Permanentlyvalid: 'Permanently valid',
  // ep_admin_dpp_distributorTip: 'Sorry,you can only sign contract with one supplier.',
  ep_admin_dpp_Level_timeliness: 'Level timeliness',
  ep_admin_dpp_Level_timeliness_Fixed_Level: 'Fixed Level',
  ep_admin_dpp_Level_timeliness_Dynamic_Level: 'Dynamic Level',
  ep_admin_dpp_Contract_and_certificate_configuration: 'Contract and certificate configuration',
  ep_admin_dpp_Certificate_Method: 'Certificate Method',
  ep_admin_dpp_Certificate_Method_same: 'Same Certificate for Different Levels',
  ep_admin_dpp_Certificate_Method_Different: 'Different Certificates for Different Levels',
  ep_admin_dpp_Initial_Level: 'Initial Level',
  ep_admin_dpp_Growth_Levels: 'Growth Levels',
  ep_admin_dpp_operate: 'Operate',
  ep_admin_dpp_Welcome_Letter: 'Welcome Letter',
  ep_admin_dpp_Badge: 'Badge',
  ep_admin_dpp_Contract_Parties: 'Contract Parties',
  ep_admin_dpp_user_companyId: 'Customer Company ID',
  ep_admin_dpp_user_companyName: 'Customer Company Name',
  ep_admin_dpp_Complete_Date: 'Complete Date',
  ep_admin_dpp_Expire_Date: 'Expire Date',
  ep_admin_dpp_Permanently_valid: 'Permanently valid',
  ep_admin_dpp_Supplier: 'Supplier',
  ep_admin_dpp_Customer: 'Customer',
  ep_admin_dpp_Hikvision: 'Hikvision',
  ep_admin_dpp_Agreement_List: 'Agreement List',
  ep_admin_dpp_upload_tip_5MB: 'Max 5MB',
  ep_admin_dpp_upload_tip_10MB: 'Max 10MB',
  ep_admin_dpp_upload_tip_100MB: 'Max 100MB',
  ep_admin_member_Current_Region: 'Current Region:',
  ep_admin_member_SYNC_Other_Regions: 'SYNC Up To Other Regions',
  ep_admin_member_SYNC_Other_Regions_title: 'Same Configurations SYNC Up To Other Regions',
  ep_admin_member_select_Regions: 'Select Regions',
  ep_admin_member_Membership_Cycle: 'Membership Cycle',
  ep_admin_member_Membership_Cycle_3_months: '3 months',
  ep_admin_member_Membership_Cycle_6_months: '6 months',
  ep_admin_member_Membership_Cycle_1_year: '1 year',
  ep_admin_member_Cycle_Start_Date: 'Cycle Start Date',
  ep_admin_member_Calculation_mode: 'Calculation mode',
  ep_admin_member_MemberShip_Publish: 'Membership Publish',
  ep_admin_member_MemberShip_Levels: 'Membership Levels',
  ep_admin_member_MemberShip_Publish_Notice_title: 'Membership Publish Notice',
  ep_admin_member_MemberShip_Publish_Notice_value1:
    'Your regional membership program will be executed according to the membership cycle and start date you currently set up.',
  ep_admin_member_MemberShip_Publish_Notice_value2:
    'The membership cycle and cycle start date is not allowed to be modified and closed after it is turned on.',
  ep_admin_member_MemberShip_Publish_Notice_value3: 'Continue to turn on the membership program?',
  ep_admin_member_level: 'Level',
  ep_admin_member_levelCard_Background: 'Card Background',
  ep_admin_member_level_Conditions: 'Level Conditions',
  ep_admin_member_Points_Multiple: 'Points Multiple',
  ep_admin_member_VAS_Disc: 'VAS Disc.',
  ep_admin_member_VAS_Disc_Health_Monitoring: 'Health Monitoring',
  ep_admin_member_VAS_Disc_Co_Branding: 'Co-Branding',
  ep_admin_member_VAS_Disc_Employee_Account: 'Employee Account',
  ep_admin_member_VAS_Disc_Cloud_storage: 'Cloud Storage',
  ep_admin_member_VAS_Disc_HCC: 'HCT',
  ep_admin_member_Modify_Date: 'Modify Date',
  ep_admin_member_Company_Qty_Ratio: 'Company Qty/Ratio',
  ep_admin_member_Authorized: 'Authorized',
  ep_admin_member_points: 'Points',
  ep_admin_member_Level_Change_Rules: 'Level Change Rules',
  ep_admin_member_Level_Change_Rules_tip:
    'The rule will be visible to customers on the client app. Better be adjust to local language.',
  ep_admin_member_turn_off_Calculation: 'Please turn off the Calculation Mode.',
  ep_admin_member_Benefit: 'Benefits:',
  ep_admin_member_B_Points_Multiple: 'Points Multiple',
  ep_admin_member_Service_Disc: 'Value Added Service Disc.',
  ep_admin_member_Member_Day: 'Member Day',
  ep_admin_member_Benefit_Points_Multiple: 'Key Benefit -- Points Multiple',
  ep_admin_member_Benefit_Service_Disc: 'Key Benefit -- Value Added Service Disc.',
  ep_admin_member_Benefit_Member_Day: 'Key Benefit -- Member Day',
  ep_admin_member_Local_Benefits: 'Local Benefits',
  ep_admin_member_New_Benefit: 'New Benefit',
  ep_admin_member_Edit_Benefit: 'Edit Benefit',
  ep_admin_member_benefit_name: 'Benefit Name',
  ep_admin_member_benefit_icon: 'Icon',
  ep_admin_member_benefit_portal_link: 'Portal Link',
  ep_admin_member_benefit_app_link: 'App Link',
  ep_admin_member_benefit_type: 'Benefit Type',
  ep_admin_member_benefit_level1: 'Level 1',
  ep_admin_member_benefit_level2: 'Level 2',
  ep_admin_member_benefit_level3: 'Level 3',
  ep_admin_member_benefit_level4: 'Level 4',
  ep_admin_member_benefit_level5: 'Level 5',
  ep_admin_member_benefit_type_discount: 'Discount',
  ep_admin_member_benefit_type_number: 'Number',
  ep_admin_member_benefit_type_normal: 'Normal',
  ep_admin_member_benefit_number_tip: 'Please input the number between {min} and {max}',
  ep_admin_member_benefit_icon_tip: 'Image size does not exceed 200KB',
  ep_admin_member_benefit_level_tip: 'The value of the high level should be greater than the low level',
  ep_admin_member_Sort_Benefit: 'Sort Benefits',
  ep_admin_member_drag_sort: 'Drag to sort',
  ep_admin_member_Benefit_Local_Benefits: 'Key Benefit -- Local Benefits',
  ep_admin_member_Publish: 'Publish:',
  ep_admin_member_Points_Multiple_Daily: 'Points Multiple Daily',
  ep_admin_member_Disc: 'Disc.',
  ep_admin_member_Set_Member_Day: 'Set Member Day',
  ep_admin_member_Points_Multiple_on_Memberday: 'Points Multiple on Memberday',
  ep_admin_member_Points_Multiple_on_Memberday_tip:
    'You can set the Memberday as Weekly or Monthly. Customers will get points bonus after you setting the Points Multiples of each level. At the Memberday，customer should enjoy the higher rate between Memberday multiple and Daily multiple.',
  ep_admin_member_Monthly: 'Monthly',
  ep_admin_member_Monthly_1: 'Each 1st',
  ep_admin_member_Monthly_2: 'Each 2nd',
  ep_admin_member_Monthly_3: 'Each 3rd',
  ep_admin_member_Monthly_4: 'Each 4th',
  ep_admin_member_Monthly_5: 'Each 5th',
  ep_admin_member_Monthly_6: 'Each 6th',
  ep_admin_member_Monthly_7: 'Each 7th',
  ep_admin_member_Monthly_8: 'Each 8th',
  ep_admin_member_Monthly_9: 'Each 9th',
  ep_admin_member_Monthly_10: 'Each 10th',
  ep_admin_member_Monthly_11: 'Each 11th',
  ep_admin_member_Monthly_12: 'Each 12th',
  ep_admin_member_Monthly_13: 'Each 13th',
  ep_admin_member_Monthly_14: 'Each 14th',
  ep_admin_member_Monthly_15: 'Each 15th',
  ep_admin_member_Monthly_16: 'Each 16th',
  ep_admin_member_Monthly_17: 'Each 17th',
  ep_admin_member_Monthly_18: 'Each 18th',
  ep_admin_member_Monthly_19: 'Each 19th',
  ep_admin_member_Monthly_20: 'Each 20th',
  ep_admin_member_Monthly_21: 'Each 21st',
  ep_admin_member_Monthly_22: 'Each 22nd',
  ep_admin_member_Monthly_23: 'Each 23rd',
  ep_admin_member_Monthly_24: 'Each 24th',
  ep_admin_member_Monthly_25: 'Each 25th',
  ep_admin_member_Monthly_26: 'Each 26th',
  ep_admin_member_Monthly_27: 'Each 27th',
  ep_admin_member_Monthly_28: 'Each 28th',
  ep_admin_member_Weekly: 'Weekly',
  ep_admin_member_Weekly_Monday: 'Every Monday',
  ep_admin_member_Weekly_Tuesday: 'Every Tuesday',
  ep_admin_member_Weekly_Wednesday: 'Every Wednesday',
  ep_admin_member_Weekly_Thursday: 'Every Thursday',
  ep_admin_member_Weekly_Friday: 'Every Friday',
  ep_admin_member_Weekly_Saturday: 'Every Saturday',
  ep_admin_member_Weekly_Sunday: 'Every Sunday',
  ep_admin_member_Region: 'Region',
  ep_admin_member_Company_Type: 'Company Type',
  ep_admin_member_company_Key_Word: 'Company Key Word',
  ep_admin_member_legal_person_Key_Word: 'Legal Person Key Word',
  ep_admin_member_level_Change_Type: 'Level Change Type',
  ep_admin_member_distributor: 'Distributor',
  ep_admin_member_reseller: 'Reseller',
  ep_admin_member_installer: 'Installer',
  ep_admin_member_systemIntegrator: 'System Integrator',
  ep_admin_member_endUser: 'End User',
  ep_admin_member_OEM: 'OEM',
  ep_admin_member_ARC: 'ARC',
  ep_admin_member_set_Membership_Level_conditions: 'Please set the Membership Level conditions',
  ep_admin_member_EP_Company_ID: 'EP Company ID',
  ep_admin_member_Company_Name: 'Company Name',
  ep_admin_member_Legal_Person_One_HikID: 'Legal Person One HikID',
  ep_admin_member_Legal_Person_Name: 'Legal Person Name',
  ep_admin_member_legalPersonEmail: 'Legal Person Email',
  ep_admin_member_legalPersonPhone: ' Legal Person Phone',
  ep_admin_member_Company_Available_Points_Balance: 'Company Available Points Balance',
  ep_admin_member_Points_Budget: 'Points Budget',
  ep_admin_member_Points_Value_Current_Cycle: 'Points Value Current Cycle',
  ep_admin_member_Points_Value_Previous_Cycle: 'Points Value Previous Cycle',
  ep_admin_member_Next_cycle_date: 'Next cycle date',
  ep_admin_member_Last_Update_Date: 'Last Update Date',
  ep_admin_member_System_Automatic: 'System Automatic',
  ep_admin_member_Admin_Adjust: 'Admin Adjust',
  ep_admin_member_Initial_level: 'Initial level',
  ep_admin_member_Level_Adjust: 'Level Adjust',
  ep_admin_member_Current_Level: 'Current Level',
  ep_admin_member_Adjusted_Level: 'Adjusted Level',
  ep_admin_member_Points_Balance_When_Change: 'Points Balance When Change',
  ep_admin_member_Level_Before: 'Level Before',
  ep_admin_member_Level_After: 'Level After',
  ep_admin_member_Change_Type: 'Change Type',
  ep_admin_member_Date: 'Date',
  ep_admin_points_History: 'History',
  ep_admin_points_special_disable_re_submit_tip: 'You cannot resubmit a process created by others.',
  ep_admin_exchange_rate_currency_From: 'Currency From',
  ep_admin_exchange_rate_currency_To: 'Currency To',
  ep_admin_exchange_rate_From: 'From',
  ep_admin_exchange_rate_Exchange_Rate: 'Exchange Rate',
  ep_admin_exchange_rate_To: 'To',
  ep_admin_exchange_rate_Create_By: 'Create By',
  ep_admin_exchange_rate_Modify_By: 'Modify By',
  ep_admin_exchange_rate_Update_Time: 'Update Time',
  ep_admin_exchange_rate_Add_Exchange_Rate: 'Add Exchange Rate',
  ep_admin_exchange_rate_Edit_Exchange_Rate: 'Edit Exchange Rate',
  ep_admin_exchange_rate_delete_tip: 'Please confirm the deletion again.',
  ep_admin_contact_region: 'Region',
  ep_admin_dpp_Map: 'Map',
  ep_admin_user_map_unpublish_tip: 'Are you sure you want to Unpublish this Store?',
  ep_admin_user_map_delete_tip: 'Are you sure you want to Delete this Store?',
  ep_admin_user_map_approve_tip:
    'Once approved, the store will be displayed on the map,Please confirm you want to display this store.',
  ep_admin_user_map_Reject: 'Reject',
  ep_admin_user_map_Reject_Reason: 'Reject Reason',
  ep_admin_user_map_Reject_tip1: 'Please confirm you want to reject the store',
  ep_admin_user_map_Reject_tip2: 'application from customer.',
  ep_admin_user_map_Store_Name: 'Store Name',
  ep_admin_user_map_Edit_Customer_Map: 'Edit Customer Map',
  ep_admin_user_map_Approve_Customer_Map: 'Approve Customer Map',
  ep_admin_user_map_Customer_Map_Detail: 'Customer Map Detail',

  ep_admin_hq_permission_uri: 'Uri',
  ep_admin_hq_permission_uri_id: 'Uri Id',
  ep_admin_hq_permission_uri_method: 'Uri Method',
  ep_admin_hq_permission_menu_name: 'Menu Name',
  ep_admin_hq_permission_add_edit: 'Add/Edit',
  ep_admin_hq_permission_post: 'Post',
  ep_admin_hq_permission_get: 'Get',
  ep_admin_hq_permission_delete_reason: 'Please select the reason for delete:',
  ep_admin_hq_permission_common_interface: 'Common Interface',
  ep_admin_hq_permission_other_menu: 'Other Menus',
  ep_admin_hq_permission_other_reasons: 'Other Reasons',
  ep_admin_hq_permission_menu_id: 'Menu Id',
  ep_admin_hq_permission_download_tmp: 'Download Template',
  ep_admin_event_creater: 'Creater',
  ep_admin_event_Create_Event_Information: 'Create Event Information',
  ep_admin_event_Event_Detail: 'Event Detail',
  ep_admin_event_step_title_1: 'Basic Info',
  ep_admin_event_step_title_2: 'Date & Time',
  ep_admin_event_step_title_3: 'Customer Selection',
  ep_admin_event_step_title_4: 'Completed',
  ep_admin_event_type_type: 'Type',
  ep_admin_event_type_Event: 'Event',
  ep_admin_event_type_Activity: 'Activity',
  ep_admin_event_banner_cover_tip: 'Support format：jpg、png、jpeg、webp，Ratio: 3.14:1',
  ep_admin_event_online_Type_Online: 'Online',
  ep_admin_event_online_Type_Onsite: 'Onsite',
  ep_admin_event_Session_Time: 'Date&Time',
  ep_admin_event_Session_Time_Single_Session: 'Single',
  ep_admin_event_Session_Time_Multiple_Session: 'Session',
  ep_admin_event_Session_Time_Multiple_Session_tip:
    'When the version of HPP APP is earlier than 2.6.160, session event is not display.',
  ep_admin_event_Session_Name: 'Session Name',
  ep_admin_event_Online_Url: 'Online Url',
  ep_admin_event_Region: 'Region',
  ep_admin_event_Session: 'Session {index}',
  ep_admin_event_Add_Session: 'Add Session',
  ep_admin_event_Multiple_Session_single_tip:
    'Only one session is added,please switch to single mode.',
  ep_admin_event_Registeration_Requires_Review: 'Registeration Requires Review',
  ep_admin_event_Import_Email: 'Import Email',
  ep_admin_event_Download_Template: 'Download template',
  ep_admin_event_Event_Invite_User_tip: 'Only supports excel.',
  ep_admin_event_Event_Registration_is_limited_to_invitation_list_only:
    'Registration is limited to invitation list only',
  ep_admin_event_Invite_for_email: 'Private Invitation by Email',
  ep_admin_event_Import_List: 'Import List',
  ep_admin_event_APP_H5: 'APP/H5',
  ep_admin_event_Portal: 'Portal',
  ep_admin_event_Click_to_Preview: 'Click to Preview >>',
  ep_admin_event_detail_deadline: 'Registration Deadline',
  ep_admin_event_detail_event_time: 'Event Time',
  ep_admin_event_detail_title: 'Detail',
  // ep_admin_event_detail_register: 'Register',
  ep_admin_event_session_banner_cover_tip: 'Only supports. png format, Ratio: 1: 1',
  ep_admin_event_Preview_for_PC: 'Preview for PC',
  ep_admin_event_Preview_for_APP: 'Preview for APP',
  ep_admin_event_Preview_for_APP_Open_In_APP: 'Open In APP',
  ep_admin_event_Remaining_Capacity: 'Remaining / Capacity:{Remaining} / {Capacity}',
  ep_admin_event_The_actual_time_is_based_on_the_specific_session:
    'The actual time is based on the specific session.',
  ep_admin_event_Preview_for_PC_Session: 'Session',
  ep_admin_event_Preview_for_PC_Sign_Up: 'Sign Up',
  ep_admin_event_Preview_for_PC_Deadline: 'Deadline:',
  ep_admin_event_Preview_for_PC_Remaining_Capacity:
    'Remaining / Capacity : {Remaining} / {Capacity}',
  ep_admin_event_Successfully_Created_Event: 'Created successfully',
  ep_admin_event_event_info_back_list_to_see: 'Below is the H5 address and sign-in QR code.',
  ep_admin_event_event_view_all: 'View all ({number})',
  ep_admin_event_Share_H5_QR_code: 'Share H5 QR code',
  ep_admin_event_Sign_in_QR_code: 'Sign-in QR code(HPP)',
  ep_admin_event_Return_to_List: 'Return to List',
  ep_admin_event_Category: 'Category',
  ep_admin_event_Publisher: 'Publish',
  ep_admin_event_status: 'Status',
  ep_admin_event_notice_Send_Email_to_new_customer: 'send To new customer',
  ep_admin_event_notice_Send_Email_to_all_customer: 'send To all  customer',
  ep_admin_event_Share_Link: 'Share Link',
  ep_admin_event_Sign_in_QR_code_new: 'Sign-in QR code(H5)',
  ep_admin_event_Save_draft_successed: 'Save draft successed',
  ep_admin_event_H5_register: 'Private Invitation by H5 QR Code',
  ep_admin_event_Select_qrCode_language: 'Select the language for downloading/sharing events',
  ep_admin_event_status_Draft: 'Draft',
  ep_admin_event_status_Saved: 'Saved',
  ep_admin_event_status_Published: 'Published',
  ep_admin_event_status_To_be_Approved: 'To be Approved',
  ep_admin_event_status_Rejected: 'Rejected',
  ep_admin_event_status_Approved: 'Approved',
  ep_admin_event_Share_QR_Code: 'Share QR Code',
  ep_admin_event_Display: 'Display',
  ep_admin_event_Invitation_by_HPP_tip:
    'Only customers who meet the following criteria can view the Event in HPP and register.',
  ep_admin_event_Invitation_by_H5_tip:
    'Please go to Operation-Share H5 QR Code to obtain the QR code.',
  ep_admin_event_Invitation_by_H5_waring:
    'This Event is not public, and registration is limited to those who meet the "Public Invitation by HPP" Selected.',
  ep_admin_event_Invitation_by_email_tip:
    "Send targeted invitation emails to the imported customers' email addresses, so that they can sign up directly through the invitation link in the email. To edit and send the targeted invitation email, please go to Event List-Operation-Email Config to do it manually.",
  ep_admin_event_please_upload_email: 'please upload email',
  ep_admin_event_enable_HPP_first: 'Please enable "Public Invitation by HPP" first.',
  ep_admin_event_download_qrcode_tip: 'If the QR code is blank, you can also download it.',
  ep_admin_event_maxCapacity_tip: 'The max capacity is show or not',

  ep_admin_operation_record_client: 'Client',
  ep_admin_operation_record_search_type: 'Operator',
  ep_admin_opration_record_business_tags: 'Business Tags',
  ep_admin_opration_record_business_data: 'Business Data',
  ep_admin_opration_record_trace_id: 'Trace Id',
  ep_admin_opration_record_application: 'Application',
  ep_admin_opration_record_class: 'Class',
  ep_admin_opration_record_method: 'Method',
  ep_admin_opration_record_is_error: 'Is Error',
  ep_admin_opration_record_id: 'Id',
  ep_admin_opration_record_display_time: 'Operation Time',
  ep_admin_opration_record_content: 'Content',
  ep_admin_opration_record_client_type: 'Client Type',
  ep_admin_opration_record_duration: 'Duration(ms)',
  ep_admin_hpp_web: 'HPP Web',
  ep_admin_hpp_ios: 'HPP IOS',
  ep_admin_hpp_android: 'HPP Android',
  ep_admin_hiklink: 'HikLink',
  ep_admin_job: 'Job',
  ep_admin_admin_id: 'Admin ID',
  ep_admin_user_hik_id: 'User Hik ID',
  ep_admin_ep_user_id: 'EP User ID',
  ep_admin_ep_company_id: 'EP Company ID',
  ep_admin_user_sap_id: 'User SAP ID',
  ep_admin_user_upper_limit_amount: 'Please input Upper Limit Amount of Freight Charge',
  ep_admin_user_freight_charge_rate: 'Please input Freight Charge Rate',
  ep_admin_user_minimum_order_quantity: 'Please input Minimum Order Amount',
  ep_admin_please_input_key: 'Please input Key',
  ep_admin_please_input_value: 'Please input Value',
  ep_admin_request: 'Request',
  ep_admin_client_ip: 'Client Ip',
  ep_admin_header: 'Header',
  ep_admin_url: 'Url',
  ep_admin_user_agent: 'User Agent',
  ep_admin_trace_id: 'Trace Id',
  ep_admin_identity: 'Identity',
  ep_admin_args: 'Args',
  ep_admin_result: 'Result',
  ep_admin_exception: 'Exception',
  ep_admin_stack_trace: 'Stack Trace',
  ep_admin_qr_code: 'QR Code',
  ep_admin_status_message: 'Status Message',
  ep_admin_transaction_fee: 'Transaction_fee',
  ep_admin_transaction_fee_vat: 'Transaction_fee_vat',
  ep_admin_total_amount_sent: 'Total amount sent (request amount)',
  ep_admin_total_success_sent: 'Total successful sent',
  ep_admin_total_fail_sent: 'Total fail sent',
  ep_admin_total_success_rate: 'Total successful Rate',
  ep_admin_success_rate: 'Successful Rate',
  ep_admin_sms_channel: 'Channel',
  ep_admin_sms_parameter: 'Parameter',
  ep_admin_sms_result_notes: 'Result Notes',
  ep_admin_send_date: 'Send Date',
  ep_admin_sms_function: 'Function',
  ep_admin_sms_id: 'ID',
  ep_admin_sms_request: 'Request',
  ep_admin_sms_sent: 'Sent',
  ep_admin_sms_fail: 'Fail',
  ep_admin_sms_max_minute: 'Maximum number of SMS sent to each Phone in 60s',
  ep_admin_sms_max_hour: 'Maximum number of SMS sent to each Phone in 1 hour',
  ep_admin_sms_max_day: 'Maximum number of SMS sent to each Phone in 1 day',
  ep_admin_sms_preDayRemindCount: 'For one day,the total number of SMS exceeds',
  ep_admin_sms_remind_email: 'reminded,Email list',
  ep_admin_sms_stop_sending: 'stop sending',
  ep_admin_sms_alarmCount: 'Alarm condition: The cumulative sending volume of each Phone reaches',
  ep_admin_sms_blacklistCount:
    'Blacklist condition: The cumulative sending volume of each Phone reaches',
  ep_admin_free_exchange: 'Free Exchange',
  ep_admin_explore_event_Publish_Preview: 'Hik-Partner Pro Event-Publish Apply — Preview',
  ep_admin_event_description: 'Description',
  ep_admin_user_PP_Company_ID: 'PP Company ID',
  ep_admin_Log_Changed_Type: 'Changed Type',
  ep_admin_Log_Changed_By: 'Changed By',
  ep_admin_Log_Changed_at: 'Changed at',
  ep_admin_Log_Changed_to_value: 'Changed to value',
  ep_admin_user_Log_Log: 'Log',
  ep_admin_user_Company_Log: 'Company Log',
  ep_admin_user_User_Log: 'User Log',

  ep_admin_user_map_Download_Customer_Store: 'Download Customer Store',
  ep_admin_eCoupons_eCoupon_Rules: 'eCoupon Rules',
  ep_admin_eCoupons_Set_eCoupon_rules: 'Set eCoupon rules',
  ep_admin_eCoupons_Collect_period: 'Collect Period',
  ep_admin_eCoupons_Same_as_Collect_Period: 'Same as Collect Period',
  ep_admin_eCoupons_pop_Up_Details_Page_Status: 'Pop-up on eCoupon Details Page',
  ep_admin_eCoupons_Used_for_Rewards_Store: 'Used for Rewards Store',
  ep_admin_eCoupons_Used_for_Rewards_Store_Y: 'Y - This Coupon will be used as points gift',
  ep_admin_eCoupons_Used_for_Rewards_Store_N: 'N - This eCoupon will not be used as points gift',
  ep_admin_eCoupons_Push_Notification: 'Push Notification',
  ep_admin_eCoupons_Push_Notification_Y: 'Y - Push Message',
  ep_admin_eCoupons_Push_Notification_N: 'N - Not Push Message',
  ep_admin_eCoupons_Allow_To_Superposition: 'Allow To Superposition',
  ep_admin_eCoupons_Allow_To_Superposition_Y: 'Y - This eCoupon can be used with other eCoupon',
  ep_admin_eCoupons_Allow_To_Superposition_N: 'N - This eCoupon cannot be used with other eCoupon',
  ep_admin_eCoupons_SN_Records: 'SN Records',
  ep_admin_eCoupons_SN_Records_y: 'Y',
  ep_admin_eCoupons_SN_Records_n: 'N',
  ep_admin_eCoupons_eCoupon_Condition_Type: 'eCoupon Condition Type',
  ep_admin_eCoupons_eCoupon_Condition_Type_No_Condition: 'No Condition',
  ep_admin_eCoupons_eCoupon_Condition_Type_Order_Amount: 'Order Amount',
  ep_admin_eCoupons_eCoupon_Condition_Type_Product_Quantity: 'Product Quantity',
  ep_admin_eCoupons_eCoupon_Condition: 'eCoupon Condition',
  ep_admin_eCoupons_eCoupon_Discount_Type: 'eCoupon Discount Type',
  ep_admin_eCoupons_eCoupon_Discount_Type_Quota: 'Quota',
  ep_admin_eCoupons_eCoupon_Discount_Type_Ratio: 'Ratio',
  ep_admin_eCoupons_eCoupon_Discount_Type_Face_Value: 'Face Value',
  ep_admin_eCoupons_eCoupon_Discount: 'eCoupon Discount',
  ep_admin_eCoupons_Daily_Limit_Type: 'Daily Limit Type',
  ep_admin_eCoupons_Daily_Limit_Type_Total_Discount_Amount: 'Total Discount Amount',
  ep_admin_eCoupons_Daily_Limit_Type_eCoupon_Quantity: 'eCoupon Quantity',
  ep_admin_eCoupons_Information_Collection: 'Information Collection',
  ep_admin_eCoupons_Information_Collection_Order_Number: 'Order Number',
  ep_admin_eCoupons_Information_Collection_Order_Amount: 'Order Amount',
  ep_admin_eCoupons_Information_Collection_Upload_Files: 'Upload Files',
  ep_admin_eCoupons_Information_Collection_Product_Quantity: 'Product Quantity',
  ep_admin_eCoupons_Information_Collection_Remark: 'Remark',
  ep_admin_eCoupons_Information_Collection_Others: 'Others',
  ep_admin_eCoupons_Information_Collection_Tip:
    'Order Number and Upload Files must be selected one.',
  ep_admin_eCoupons_set_customer_Tip:
    'When there are multiple filters, the customer range will be the intersection of the selected filters. But if you don’t select non-required filter such as Company Authorization Date, system will skip this filter.',
  ep_admin_eCoupons_Membership_Level: 'Membership Level',
  ep_admin_eCoupons_Membership_Level_1: 'Level 1',
  ep_admin_eCoupons_Membership_Level_2: 'Level 2',
  ep_admin_eCoupons_Membership_Level_3: 'Level 3',
  ep_admin_eCoupons_Membership_Level_4: 'Level 4',
  ep_admin_eCoupons_Membership_Level_5: 'Level 5',
  ep_admin_eCoupons_Partner_Program: 'Partner Program',
  ep_admin_eCoupons_time_tip:
    'The available time starting point cannot be earlier than the available time starting point, and the available time ending point cannot be earlier than the available time ending point',
  ep_admin_eCoupons_customer_selected: 'Totally {totle} customers selected',
  ep_admin_eCoupons_provider_selected: 'Totally {totle} providers selected',
  ep_admin_eCoupons_view_more: 'View More',
  ep_admin_eCoupons_coupon_status_Releasing: 'Releasing',
  ep_admin_eCoupons_Verified_qty: 'Verified Qty',
  ep_admin_eCoupons_customer_type_tip: 'Issue this coupon for specific company types',
  ep_admin_eCoupons_Membership_Level_tip: 'Issue this coupon for specific membership levels',
  ep_admin_eCoupons_Partner_Program_tip: 'Distribute this coupon to specific contracted users',
  ep_admin_explore_HQ: 'HQ',
  ep_admin_account_name: 'Account Name',
  ep_admin_generated_by: 'Generated By',
  ep_admin_generated_url: 'Generate URL',
  ep_admin_generate: 'Generate ',
  ep_admin_hpc_portal: 'Hpc Portal',
  ep_admin_hpc_app: 'Hpc App',
  ep_admin_copy_url: 'Copy URL',
  ep_admin_open_url: 'Open URL',
  ep_admin_authorization_code: 'Please enter the authorization code',
  ep_admin_event_Hikshield_check_tips:
    'The event is under second Hikshield review, the historically approved events can be conducted as normal.',
  ep_admin_event_OA_check_tips:
    'The event is under second review, the historically approved events can be conducted as normal.',
  ep_admin_event_OA_check_reject_tips:
    'The event has been rejected during second review, the historically approved events can be conducted as normal.',
  ep_admin_event_description_tip:
    'The edition of Event name and description will trigger Approval process and will not take effect immediately. Please leave some time buffer.',
  ep_admin_generate_company_keywords: 'Company Keywords',
  ep_admin_generate_user_keywords: 'User Keywords',
  ep_admin_generate_company_keywords_placeholder: 'EP Company ID/Name',
  ep_admin_generate_user_keywords_placeholder: 'EP User ID/E-mail',
  ep_admin_es_User_ID: 'User ID',
  ep_admin_es_Meterial_Code: 'Meterial Code',
  ep_admin_es_Product_Name: 'Product Name',
  ep_admin_es_Goods_Name: 'Goods Name',
  ep_admin_es_HOT: 'HOT',
  ep_admin_es_NEW: 'NEW',
  ep_admin_es_On_Demand: 'On Demand',
  ep_admin_es_Country: 'Country',
  ep_admin_es_EOL: 'EOL',
  ep_admin_es_B2B_EOL: 'B2B EOL',
  ep_admin_es_Is_Internation: 'isInternation',
  ep_admin_es_Modification_Date: 'Modification Date',
  ep_admin_es_ID: 'ID',
  ep_admin_es_Product_Group: 'Product Group',
  ep_admin_es_Price_Group: 'Price Group',
  ep_admin_es_Purchasable: 'Purchasable',
  ep_admin_es_Category1: 'Category1',
  ep_admin_es_Category2: 'Category2',
  ep_admin_es_Unit_Price: 'Unit Price',
  ep_admin_es_Currency: 'Currency',
  ep_admin_es_ZPM2_Currency: 'ZPM2 Currency',
  ep_admin_es_ZPM2: 'ZPM2',
  ep_admin_es_Start_Date: 'Start Date',
  ep_admin_es_End_Date: 'End Date',
  ep_admin_es_Last_Update_Date: 'Last Update Date',
  ep_admin_es_search_oprions_y: 'Y',
  ep_admin_es_search_oprions_n: 'N',
  ep_admin_es_purchasable_Locked: 'Locked',
  ep_admin_es_purchasable_Product_hitelist: 'Product Whitelist',
  ep_admin_es_purchasable_Product_Delist_Blacklist: 'Product Delist Blacklist',
  ep_admin_es_purchasable_ECCN: 'ECCN',
  ep_admin_es_purchasable_EOL: 'EOL',
  ep_admin_es_purchasable_DEA: 'DEA',
  ep_admin_es_purchasable_expiredPrice: 'Expired Price',
  ep_admin_es_Resource_Group: 'Resource Group',
  ep_admin_es_Black_List: 'Black List',

  ep_admin_member_MemberShip_Configure: 'Membership Configure',
  ep_admin_member_DPP_Included: 'DPP Included',
  ep_admin_member_VASP_Included: 'VASP Included',
  ep_admin_member_turn_it_on_tip:
    'You must set Member Ship Cycle,Cycle Start Date,and Levels Condition before you turn it on.',
  ep_admin_banner_Allow_customers_to_close: 'Allow customers to close',
  ep_admin_banner_Allow_customers_to_close_tip:
    'If select “Yes”, the customer can close the banner and the banner will never be displayed again. If select “No”, the customer cannot turn it off manually.',
  ep_admin_region_Structural_adjustment: 'Structural adjustment',
  ep_admin_region_add_region: 'Add Bu/Subbu/Country',
  ep_admin_region_Layer: 'Layer',
  ep_admin_region_Bu_ID: 'Bu ID',
  ep_admin_region_Bu_Code: 'Bu Code',
  ep_admin_region_Bu_Name: 'Bu Name',
  ep_admin_region_Bu: 'Bu',
  ep_admin_region_Sub_Bu_ID: 'Sub Bu ID',
  ep_admin_region_Sub_Bu_Code: 'Sub Bu Code',
  ep_admin_region_Sub_Bu_Name: 'Sub Bu Name',
  ep_admin_region_Sub_Bu: 'Sub Bu',
  ep_admin_region_Country_ID: 'Country ID',
  ep_admin_region_Country_Code: 'Country Code',
  ep_admin_region_Country_Name: 'Country Name',
  ep_admin_region_Country: 'Country',
  ep_admin_region_Region_Log: 'Region Log',
  ep_admin_region_Contact_Configuration: 'Contact Configuration',
  ep_admin_region_Delete_region_tip: 'All data including customer data will be deleted,Please confirm that you want to delete this region?',
  ep_admin_region_Edit_Subbu_Bu_tip: 'Please confirm that you want to move this region from "{oldBuName}" to "{buName}".',
  ep_admin_region_Edit_Country_Subbu_Bu_tip: 'Please confirm that you want to move this region from "{oldBuName}-{oldSubBuName}" to "{buName}-{subBuName}".',
  ep_admin_region_Customer_Configuration: 'Customer Configuration',
  ep_admin_region_Customer_Configuration_tip: 'Limitation on Employee per company',
  ep_admin_region_Customer_type: 'Customer type',
  ep_admin_region_Employee_Number_Limit: 'Employee Number Limit',
  ep_admin_points_BuId: 'BU',
  ep_admin_explore_Display_Area: 'Display Area',
  ep_admin_explore_BC: 'BC',
  ep_admin_explore_Comments_Display_Status: 'Display Status',
  ep_admin_explore_Comments_Display_Status_All: 'All',
  ep_admin_explore_Comments_Display_Status_Displayed: 'Displayed',
  ep_admin_explore_Comments_Display_Status_Hide: 'Hide',
  ep_admin_explore_Comments_Reply_Status: 'Reply Status',
  ep_admin_explore_Comments_Reply_Status_All: 'All',
  ep_admin_explore_Comments_Reply_Status_Replied: 'Replied',
  ep_admin_explore_Comments_Reply_Status_Unreplied: 'Unreplied',
  ep_admin_explore_Comments_Delete_Status: 'Delete Status',
  ep_admin_explore_Comments_Delete_Status_All: 'All',
  ep_admin_explore_Comments_Delete_Status_Available: 'Available',
  ep_admin_explore_Comments_Delete_Status_Deleted: 'Deleted',
  ep_admin_explore_Comments_Delete_tip: 'This comment had been deleted by customer.',
  ep_admin_solution_name: 'Solution Name',
  ep_admin_solution_catalogue: 'Catalogue',
  ep_admin_solution_scenario: 'Scenario',
  ep_admin_dpp_upload_tip_500K: 'Max 500K',

  ep_admin_form_matrix_rows: 'Add New Martirx Row',
  ep_admin_form_scoring_items: 'Add New Scording',
  ep_admin_form_drag_sort: 'Reordering',
  ep_admin_form_option: 'Option',
  ep_admin_form_other_option: 'Add "Other Option"',
  ep_admin_form_preview_tip: 'Preview will only be displayed when all required fields are completed',
  ep_admin_form_field: 'Field',
  ep_admin_form_fields: 'Fields',
  ep_admin_form_fields_name: 'Fields Name',
  ep_admin_form_field_name: 'Field Name',
  ep_admin_form_field_type: 'Field Type',
  ep_admin_form_group: 'Group',
  ep_admin_form_group_name: 'Group Name',
  ep_admin_form_upload_instructions: 'Note',
  ep_admin_form_character_limit: 'Character Limit',
  ep_admin_form_only_for_numeric_types: 'Number Only',
  ep_admin_form_max_files_limit: 'Max Files Limit',
  ep_admin_form_close: 'Close',
  ep_admin_form_rule: 'Rule',
  ep_admin_form_displayFormat: '(Display Format)',
  ep_admin_form_used_in: 'Appears On',
  ep_admin_form_member_of_fields: 'Member Of Fields',
  ep_admin_form_maximum10M: 'Image must be smaller than 10 MB',
  ep_admin_form_emailTips: 'Please enter a valid email address.',
  ep_admin_form_registerForm: 'Registration Form',
  ep_admin_form_registerFormTip: 'Once the event is registered, the custom form cannot be modified.',
  ep_admin_form_selectForm: 'Select Form',
  ep_admin_event_registrationConfiguration: 'Registration Configuration',
  ep_admin_event_registrationType: 'Registration',
  ep_admin_event_registrationType_required: 'Registration required',
  ep_admin_event_noRegistrationRequired: 'No registration required',
  ep_admin_event_redirectThirdPartyLink: 'Redirect to a third-party link',
  ep_admin_event_thirdPartyLink: 'Link',
  ep_admin_event_thirdPartyLink_required: 'Please enter third-party link',
  ep_admin_event_thirdPartyLink_placeholder: 'Enter third-party link',
  ep_admin_form_launch_preview: 'Exit Preview',
  ep_admin_form_preview_tip1: 'This is a preview page; any content entered will not be saved',
  ep_admin_form_app: 'Mobile',
  ep_admin_form_pc: 'Desktop',
  ep_admin_form_app_tip: 'Please operate on a mobile device.',
  ep_admin_form_result_tip1: 'Payment Completed',
  ep_admin_form_result_tip2: 'Please note system will shortly confirm the order. Please kindly check your order status in my order.',
  ep_admin_form_create_form: 'Create Form',
  ep_admin_form_select_field: 'Select Field',
  ep_admin_form_tip: 'Click or drag a filed into the form.',
  ep_admin_form_preset_fields: 'Default',
  ep_admin_form_custom: 'Creat New',
  ep_admin_form_input_field: 'Please input',
  ep_admin_form_base_info: 'Basic Information',
  ep_admin_form_form_name: 'Form Name',
  ep_admin_form_form_id: 'Form ID',
  ep_admin_form_dropdown_tip: 'No permission, please contact the publisher to apply for permission',
  ep_admin_form_survey: 'Survey',
  ep_admin_form_hievent: 'HiEvent',
  ep_admin_form_form_configuration: 'Set up your form now',
  ep_admin_form_set_cover_image: 'Upload Banner',
  ep_admin_form_img_tip: 'Only supports JPEG, PNG, JPG, and GIF formats, with a size of 1000*200px and less than 10MB.',
  ep_admin_form_title_name: 'Title',
  ep_admin_form_subtitle_name: 'Subtitle',
  ep_admin_form_required: 'Required',
  ep_admin_form_edit_disclaimer: 'Edit Disclaimer',
  ep_admin_form_logic_tip: 'This feature allows you to set up different logic worflows, such as skipping or hiding selected questions.',
  ep_admin_form_then_display: 'Display',
  ep_admin_form_add_Logical: 'Add New Logic',
  ep_admin_form_logic_title: 'Set up Logic',
  ep_admin_form_share_title: 'Share H5 QR Code',
  ep_admin_form_share_tip: 'The blank QR code will not affect the download. You can still download it for further use.',
  ep_admin_form_copy_link: 'Copy Link',
  ep_admin_form_downLoad: 'DownLoad',
  ep_admin_form_share: 'Share',
  ep_admin_form_logic: 'Set up Logic',
  ep_admin_form_please_input_option: 'Please Input [Option]',
  ep_admin_form_option_repetition: 'Duplicate Options',
  ep_admin_form_type1: 'Single-Line Text',
  ep_admin_form_type2: 'Multi-Line Text',
  ep_admin_form_type3: 'Single Radio',
  ep_admin_form_type4: 'Single Dropdown',
  ep_admin_form_type5: 'Multiple Checkboxes',
  ep_admin_form_type6: 'Date Picker',
  ep_admin_form_type7: 'Scoring',
  ep_admin_form_type8: 'Matrix Scoring',
  ep_admin_form_type9: 'Picture',
  ep_admin_form_type10: 'File',
  ep_admin_form_single_line: 'Single-Line',
  ep_admin_form_multi_line: 'Multi-Line',
  ep_admin_form_radio: 'Radio',
  ep_admin_form_dropdown_select: 'Dropdown',
  ep_admin_form_checkboxes: 'Checkboxes',
  ep_admin_form_text: 'Text',
  ep_admin_form_move_group_to: 'Move Group To',
  ep_admin_form_move_group: 'Move Group',
  ep_admin_home_select_slae_organize_tip: 'Please Select saleOrganize',
  ep_admin_home_Failed_get_login_tip: 'Failed to get login user information !',
  ep_admin_home_Hik_Partner_Pro: 'Hik-Partner Pro',
  ep_admin_export_tip_title: 'Warning',
  ep_admin_export_tip_content: 'The exported document may contain sensitive customer information. Please be careful of its usage and preventing information leakage.',
  ep_admin_sms_backfill: 'Backfill',
  ep_admin_sms_backfill_rate: 'Backfill rate',
  ep_admin_user_editCrmContactId: 'Edit CRM Contact Id',
  ep_admin_login_select_country_tip: 'Please select to obtain the corresponding authority',
  ep_admin_login_select_salesOrgnizes_tip: 'Please select the sales organization',
  ep_admin_login_Guest_Mode: 'Guest Mode',


  ep_admin_apiCustomer_accessKey: 'AccessKey',
  ep_admin_apiCustomer_sapId: 'SAP ID',
  ep_admin_apiCustomer_email: 'Email',
  ep_admin_apiCustomer_type: 'Type',
  ep_admin_apiCustomer_salesOrgnazation: 'SalesOrgnazation',
  ep_admin_apiCustomer_createDate: 'Create Date',
  ep_admin_apiCustomer_apiName: 'API Name',
  ep_admin_apiCustomer_operationName: 'Operation Name',
  ep_admin_apiCustomer_originalRecord: 'Original Record',
  ep_admin_apiCustomer_newRecord: 'New Record',
  ep_admin_apiCustomer_operateTime: 'Operate Time',
  ep_admin_apiCustomer_operateBy: 'Operate By',
  ep_admin_apiCustomer_activeStatus: 'Active status',
  ep_admin_apiCustomer_maximumNumberIn60s: 'Maximum number in 60s',
  ep_admin_apiCustomer_maximumNumber1Day: 'Maximum number 1 Day',
  ep_admin_apiCustomer_logDebug: 'Log Debug',
  ep_admin_apiCustomer_logDebugTip: 'Only enabled when troubleshooting. After enabling, the response data will be stored in the log.',
  ep_admin_apiCustomer_tip: 'The API current limit quantity cannot be empty',
  ep_admin_apiCustomer_skipIpWhiteListCheck: 'Skip IP Whitelist Check',
  ep_admin_apiCustomer_sftpAccount: 'SFTP Account',
  ep_admin_apiCustomer_sftpFieldMapping: 'SFTP Field Mapping',
  ep_admin_apiCustomer_virtualStatus: 'Virtual Status',
  ep_admin_api_add_title: 'Add API Endpoint',
  ep_admin_api_edit_title: 'Edit API Endpoint',
  ep_admin_api_name: 'Name',
  ep_admin_api_log_period: 'Log Retention Period',
  ep_admin_api_apply_type: 'Apply Type',
  ep_admin_api_is_external: 'Is External',
  ep_admin_api_creation_time: 'Creation Time',
  ep_admin_api_modification_time: 'Modification Time',
  ep_admin_api_target_url: 'Target URL',
  ep_admin_messageRecord_emailSendChannel: 'Send Channel',
  ep_admin_messageRecord_emailSendChannel_HIKVISION: 'HIKVISION',
  ep_admin_messageRecord_emailSendChannel_AWS_SES: 'AWS SES',
  ep_admin_companyMerge_BU: 'BU',
  ep_admin_companyMerge_Sub_BU: 'Sub BU',
  ep_admin_user_BU: 'BU',
  ep_admin_user_Sub_BU: 'Sub BU',
  ep_admin_user_Search_tip: 'You must select Data center or country to proceed',
  ep_admin_permit_Resller_Permit_Approval_Status: 'Reseller Permit Approval Status',
  ep_admin_permit_Customer_upgraded: 'Customer upgraded',
  ep_admin_permit_Customer_upgraded_Y: 'Y',
  ep_admin_permit_Customer_upgraded_N: 'N',
  ep_admin_permit_EP_Company_ID: 'EP Company ID',
  ep_admin_permit_HPC_Company_ID: 'HPC Company ID',
  ep_admin_permit_Company_Name: 'Company Name',
  ep_admin_permit_Company_Type: 'Company Type',
  ep_admin_permit_Country: 'Country',
  ep_admin_permit_State: 'State',
  ep_admin_permit_City: 'City',
  ep_admin_permit_Company_Email: 'Company Email',
  ep_admin_permit_Company_Phone: 'Company Phone',
  ep_admin_permit_Approval_Status: 'Approval Status',
  ep_admin_permit_Approval_Status_To_be_Approved: 'To Be Approved',
  ep_admin_permit_Approval_Status_Approved: 'Approved',
  ep_admin_permit_Approval_Status_Rejected: 'Rejected',
  ep_admin_permit_Approval_Status_Expired: 'Expired',
  ep_admin_permit_Resller_Permit_Approval: 'Reseller Permit Approval',
  ep_admin_permit_Resller_Permit_Approval_Detail: 'Reseller Permit Approval Detail',
  ep_admin_permit_Uploader_Name: 'Uploader Name',
  ep_admin_permit_Uploader_Email: 'Uploader Email',
  ep_admin_permit_Uploader_Time: 'Upload Time',
  ep_admin_permit_Resller_Permit_Document_Detail: 'Reseller Permit Document Detail',
  ep_admin_permit_Approval_Opinions: 'Approval Opinions',
  ep_admin_permit_Approval_Opinions_Approve: 'Approve',
  ep_admin_permit_Approval_Opinions_Reject: 'Reject',
  ep_admin_permit_Valid_Until: 'Valid Until',
  ep_admin_permit_Reject_Reson: 'Reject Reson',
  ep_admin_permit_Reject_Comment: 'Reject Comment',

  ep_admin_gift_ship_type_Offline: 'Hikvision Ship – Offline',
  ep_admin_gift_ship_type_Distributers: 'Pick-up in store',
  ep_admin_gift_ship_type_Online: 'Hikvision Ship – Online',
  ep_admin_gift_ship_type_No_Shipping: 'No Shipping Required – Account',
  ep_admin_gift_Gift_Information: 'Gift Information',
  ep_admin_gift_Pick_Up_Setting: 'Pick-Up Setting',
  ep_admin_gift_Customer_Selection: 'Customer Selection',
  ep_admin_gift_Completed: 'Completed',
  ep_admin_gift_Create_Gift: 'Create Gift',
  ep_admin_gift_Return_to_List: 'Return to List',
  ep_admin_gift_gift_name: 'Gift Name',
  ep_admin_gift_gift_Type_Hikvision_products: 'Hikvision products',
  ep_admin_gift_gift_Type_EGift_Card: 'eGift Card',
  ep_admin_gift_gift_Type_Non_Hikvision_brand_gifts: 'Non-Hikvision Brand Gifts',
  ep_admin_gift_gift_Type_Others: 'Others',
  ep_admin_gift_gift_Type_Value_added_services: 'Value-added Services',
  ep_admin_gift_gift_Type_Coupons: 'eCoupons',
  ep_admin_gift_gift_Type_SAP_Order: 'SAP Order',
  ep_admin_gift_modify_Time: 'Modify Time',
  ep_admin_gift_Effective_Redeem_Time: 'Effective Redeem Time',
  ep_admin_gift_sort_tip: 'The gift order will prior in the gift list when your input the larger number.',
  ep_admin_gift_Regular_Stock_Renewal: 'Regular Stock Renewal',
  ep_admin_gift_Regular_Stock_Renewal_None: 'None',
  ep_admin_gift_Regular_Stock_Renewal_1Week: '1 Week',
  ep_admin_gift_Regular_Stock_Renewal_1Month: '1 Month',
  ep_admin_gift_Regular_Stock_Renewal_3Months: '3 Months',
  ep_admin_gift_Regular_Stock_Renewal_6Months: '6 Months',
  ep_admin_gift_Regular_Stock_Renewal_1Year: '1 Year',
  ep_admin_gift_Regular_Stock_Renewal_tip: 'The gift stock will be reset to the original quantity based on your options.',
  ep_admin_gift_Regular_Limitaion_Renewal: 'Regular Limitation Renewal',
  ep_admin_gift_Regular_Limitaion_Renewal_None: 'None',
  ep_admin_gift_Regular_Limitaion_Renewal_Daily: 'Daily',
  ep_admin_gift_Regular_Limitaion_Renewal_Weekly: 'Weekly',
  ep_admin_gift_Regular_Limitaion_Renewal_Monthly: 'Monthly',
  ep_admin_gift_Regular_Limitaion_Renewal_3Months: '3 Months',
  ep_admin_gift_Regular_Limitaion_Renewal_6Months: '6 Months',
  ep_admin_gift_Regular_Limitaion_Renewal_1Year: '1 Year',
  ep_admin_gift_Regular_Limitaion_Renewal_tip: 'The gift redeem limitation will be reset to the original quantity based on your options.',
  ep_admin_gift_unit_price: 'Unit Price',
  ep_admin_gift_Pricing_Method: 'Pricing Method',
  ep_admin_gift_Pricing_Method_Uniform_Price: 'Uniform Price',
  ep_admin_gift_Pricing_Method_Tiered_Pricing: 'Tiered Pricing',
  ep_admin_gift_Unit_Price_for_Level: 'Unit Price for Level {level}',
  ep_admin_gift_Gift_Value: 'Gift Value (For Display)',
  ep_admin_gift_gift_image: 'Gift Images',
  ep_admin_gift_gift_image_up_to_9: '(up to 9)',
  ep_admin_gift_gift_image_dec: 'Ratio:1080*540,File Size<2M,Format:JPG、PNG',
  ep_admin_gift_gift_image_dec1: 'Only PNG or JPG format images can be uploaded!',
  ep_admin_gift_gift_image_massageImg: 'Message Image',
  ep_admin_gift_gift_image_tip: 'The first image you upload will be used as the gift cover image. Only supports. jpg&png format, size<2048*2048px, Ratio: 1:1,File Size<2M.',
  ep_admin_gift_gift_image_upload_tip: 'This image exceeds maximum size.',
  ep_admin_gift_gift_image_upload_tip_2: 'You can only upload JPG/PNG file!',
  ep_admin_gift_Add_Customized_Field: 'Add Customized Field',
  ep_admin_gift_Add_Customized_Field_num: '({num})',
  ep_admin_gift_Add_Customized_Field_tip: 'You can set the customized fields as supplementary of gift information. Up to 5.',
  ep_admin_gift_Add_Customized_Field_Field_Name: 'Field Name',
  ep_admin_gift_Add_Customized_Field_Field_Type: 'Field Type',
  ep_admin_gift_Add_Customized_Field_Field_Type_Fill_in_Text: 'Fill-in Text',
  ep_admin_gift_Add_Customized_Field_Field_Type_Single_Choice: 'Single Choice',
  ep_admin_gift_Add_Customized_Field_Field_Type_Single_Choice_tip: "Please use ';' to separate options",
  ep_admin_gift_Add_Customized_Field_Options: 'Options',
  ep_admin_gift_Message_Push: 'Message Push',
  ep_admin_gift_eGift_card_upload_tip: "Please Upload eGift Cards information. System will send the information to customer's account automatically after redeeming.",
  ep_admin_gift_eGift_card_upload_item_num: '{num} items',
  ep_admin_gift_eCoupon_ID: 'eCoupon ID',
  ep_admin_gift_Service_Type: 'Service Type',
  ep_admin_gift_Material_Code: 'Material Code',
  ep_admin_gift_Ship_Review: 'Ship Review',
  ep_admin_gift_Ship_Review_Y: 'Y',
  ep_admin_gift_Ship_Review_N: 'N',
  ep_admin_gift_limitation_num_tip: 'This limitation should not exceed the eCoupon Single Limit.',
  ep_admin_gift_stock_tip: 'This Stock should not exceed the eCoupon Quantity.',
  ep_admin_gift_Successfully_Created_Gift: 'Successfully Created Gift',
  ep_admin_gift_Pick_Up_Points: 'Pick-Up Points',
  ep_admin_gift_Pick_Up_Points_num: '({num})',
  ep_admin_gift_Company_ID: 'Company ID',
  ep_admin_gift_Store_Name: 'Store Name',
  ep_admin_gift_Store_Address: 'Store Address',
  ep_admin_gift_pick_Up_Points_Stock: 'Stock',
  ep_admin_gift_pick_Up_Points_Stock_tip1: 'For pick up store, this is a required field. If you wish to display store inventory information to your customers, please fill in the inventory data for all stores. Note that this quantity is for reference and you can make a manual adjustment if it is not correct.',
  ep_admin_gift_pick_Up_Points_Stock_tip2: 'If you have set up regular inventory updates, then the store inventory will be updated accordingly.',
  ep_admin_gift_Add_Pick_Up_Point: 'Add Pick-up Stores',
  ep_admin_gift_customer_Condition_Type_Conditional_Filtering: 'Conditional Filtering',
  ep_admin_gift_customer_Condition_Type_EP_Company_ID_Filtering: 'EP Company ID Filtering',
  ep_admin_gift_customer_type: 'Customer Type',
  ep_admin_gift_Membership_Level: 'Membership Level',
  ep_admin_gift_Partner_Program: 'Partner Program',
  ep_admin_gift_uploadedSuccessfully: 'Uploaded successfully!',
  ep_admin_gift_Customer_Selection_tip: 'Only Customers who meet the following criteria can redeem the Points Gifts in HPP Gift Center.',
  ep_admin_gift_eCoupon_Customer_Selection_tip: 'Only Customers who meet the following criteria can redeem the Points Gifts in HPP Gift Center. Please make sure you configure your customer range to be within the eCoupon collection range.',
  ep_admin_gift_SAP_no_config_tip: 'Please configure the key SAP information first.',
  ep_admin_gift_SAP_no_config_tip_go_now: 'Go Now >>',
  ep_admin_gift_SAP_Information: 'SAP Information',
  ep_admin_gift_SAP_Information_num: '({num})',
  ep_admin_gift_Upload_Items: 'Upload Items',
  ep_admin_gift_eGift_Card_Name: 'eGift Card Name',
  ep_admin_gift_eGift_Card_Company: 'eGift Card Company',
  ep_admin_gift_eGift_Cards_Number: 'eGift Cards Number',
  ep_admin_gift_Password: 'Password',
  ep_admin_gift_Effective_Time: 'Effective Time',
  ep_admin_gift_Sales_Organization: 'Sales Organization',
  ep_admin_gift_Distribution_Channel: 'Distribution Channel',
  ep_admin_gift_Customer_NO: 'Customer NO.',
  ep_admin_gift_Plant: 'Plant',
  ep_admin_gift_Storage: 'Storage',
  ep_admin_gift_Please_input_valid_eCoupon_ID: 'Please input valid eCoupon ID.',
  ep_admin_gift_eCoupon_Time_tip: 'Please ensure that the gift is redeemed within the timeframe that you have configured for the coupon to be available for collection.',
  ep_admin_gift_customer_empty: 'Customer list is empty',
  ep_admin_gift_Tiered_Pricing_Need_Price: 'Unit price is required when using tiered pricing with tag customer.',
  ep_admin_gift_Membership_Level_Empty: 'The price cannot be empty.',
  ep_admin_gift_effectiveTime_tip: 'The start time should be later than system time.',
  ep_admin_gift_Receiver: 'Receiver',
  ep_admin_gift_Chosen_Gift: 'Chosen Gift',
  ep_admin_gift_stock_fill_all_stores:
    'If you wish to display store inventory information to your customers, please fill in the inventory data for all stores.',

  ep_admin_apiLog_ip: 'IP',
  ep_admin_apiLog_requestTime: 'Request Time',
  ep_admin_apiLog_statusCode: 'Status Code',
  ep_admin_apiLog_executionTime: 'Execution Time(ms)',
  ep_admin_apiLog_consumeIP: 'Consume IP',
  ep_admin_apiLog_responseTime: 'Response Time',
  ep_admin_apiLog_requestInfo: 'Request Info',
  ep_admin_apiLog_headerInfo: 'Header Info',
  ep_admin_apiLog_responseInfo: 'Response Info',
  ep_admin_apiLog_close: 'Close',
  ep_admin_apiLog_api: 'API',
  ep_admin_apiLog_apiDetail: 'API Los Detail',
  ep_admin_apiLog_secretKey: 'Secret Key',
  ep_admin_apiLog_apiManagement: 'API Management',
  ep_admin_product_maximum2M: 'The image size cannot exceed 2M',
  ep_admin_product_categoryNumber: 'Category Number',
  ep_admin_product_categoryName: 'Category Name',
  ep_admin_product_parentCategoryNumber: 'Parent Category Number',
  ep_admin_product_level: 'Level',
  ep_admin_product_categoryPath: 'Category Path',
  ep_admin_product_sortNum: 'Sort Num',
  ep_admin_product_categoryImage: 'Category Image',
  ep_admin_product_imageTip: 'Only supports. png format, size reference 1:1,File size not exceed 2M.',
  ep_admin_product_specFilterData: 'Spec Filter Data',
  ep_admin_product_inActive: 'InActive',
  ep_admin_gift_Ship_IDs: 'Ship IDs(Seperate with ";")',
  ep_admin_system_Role_Name: 'Role Name',
  ep_admin_system_Role_System: 'Role System',
  ep_admin_system_Add_Role: 'Add Role',
  ep_admin_system_ID: 'ID',
  ep_admin_system_Role_Desc: 'Role Desc',
  ep_admin_system_Key_Information: 'Key Information',
  ep_admin_system_Add_Time: 'Add Time',
  ep_admin_system_Creator: 'Creator',
  ep_admin_system_Update_Time: 'Update Time',
  ep_admin_system_Last_Modify: 'Last Modify',
  ep_admin_system_User: 'User',
  ep_admin_system_Roles_Details: 'Roles Details',
  ep_admin_system_Edit_Role: 'Edit Role',
  ep_admin_system_Name: 'Name',
  ep_admin_system_Email: 'Email',
  ep_admin_system_Owner_Approval_Required: 'Owner Approval Required',
  ep_admin_system_Role_Menu: 'Role Menu',
  ep_admin_system_Expland_All: 'Expland All',
  ep_admin_system_Collapse_All: 'Collapse All',
  ep_admin_system_delete_confirm_Tip: 'Do you want to delete this data?',

  ep_admin_explore_Upload_Content_Cover_Image: 'Upload Content Cover Image',
  ep_admin_explore_detail_tip: 'The font in the preview is different from the front page. We have set the font page display font to OPEN SANS.',
  ep_admin_scan_Fake_Probability_Start: 'Fake Probability Start Value(%)',
  ep_admin_scan_Fake_Probability_End: 'Fake Probability End Value(%)',
  ep_admin_scan_Fake_Reset_History: 'Fake Reset History',
  ep_admin_scan_Fake_Probability: 'Fake Probability',
  ep_admin_scan_Fake_Reset: 'Fake&Reset',
  ep_admin_scan_Fake_Code: 'Fake Code',
  ep_admin_scan_Other_Reason: 'Other Reason',
  ep_admin_scan_Reset_Date: 'Reset Date',
  ep_admin_scan_Reset_Reason: 'Reset Reason',
  ep_admin_scan_Batch_Reset_tip: 'We added fake code detection by algorithm, please specify your reason for reset.',
  ep_admin_scan_Fake: 'Fake',
  ep_admin_scan_Other: 'Other',
  ep_admin_point_Scan_HCL: 'Scan HCL(Hik-Central Light)',
  ep_admin_point_Action: 'Action',
  ep_admin_gift_gift_Type_Hikvision_Software_License: 'Hikvision Software License',
  ep_admin_point_software_type_Create_HCL_System: 'Create HCL System',
  ep_admin_point_software_type_Add_Channel: 'Add Channel',
  ep_admin_points_type_448_tip: 'Master switch of adding software to earn points. Please set the tier points values in【Rewards Management - Add Software】.',
  ep_admin_gift_HCL_stock_tip: 'The current stock of this gift. If stock is 0, the gift is not allowed to be redeemed.',
  ep_admin_explore_pin: 'Pin',
  ep_admin_explore_pin_tip: 'Only two top Content IDs are allowed to Pin.',
  ep_admin_member_eCoupon_Release: 'eCoupon Release',
  ep_admin_member_eCoupon_Release_Number_Month: 'eCoupon Release Number / Month',
  ep_admin_member_Benefit_eCoupon_Release: 'Key Benefit -- eCoupon Release',
  ep_admin_member_Set_eCoupon_Activity_ID: 'Set eCoupon Activity ID',
  ep_admin_member_eCoupon_Release_on_Level_day_Monthly: 'eCoupon Release on Level day Monthly',
  ep_admin_member_eCoupon_Release_on_Level_day_Monthly_tip: 'Each person obtain eCoupon at his Level day (E.g. 5th). You need to create an eCoupon Activity ID prior to publish it.',
  ep_admin_member_eCoupon_Id_tip: 'The ID must exist and be of the membership program type.',
  ep_admin_eCoupons_Membership_Program: 'Membership Program',
  ep_admin_eCoupons_Membership_Program_tip: 'Link eCoupon activity to preconfigured membership benefits to automate eCoupon release.',
  ep_admin_eCoupons_Membership_Program_Yes: 'Yes',
  ep_admin_eCoupons_Membership_Program_No: 'No',
  ep_admin_eCoupons_Membership_Distribution_Method: 'Membership Distribution Method',
  ep_admin_eCoupons_Distribute_eCoupon_at_each_Level_day_monthly: 'Distribute eCoupon at each Level day monthly',
  ep_admin_eCoupons_go_to_membership_setting: 'Go to Membership Setting',
  ep_admin_eCoupons_Currency_not_set_tip: 'Currency is not set yet, please go to Region Configure for setting',
  ep_admin_eCoupons_eCoupon_name_tip: 'Define meaningful eCoupon activity name to reflect holiday, campaign type etc. 50 Characters limited.',
  ep_admin_eCoupons_country_region_tip: 'Usually it is country name.',
  ep_admin_eCoupons_State_Province: 'State/Province',
  ep_admin_eCoupons_State_Province_tip: 'Set eCoupon to be in specific state/province.',
  ep_admin_eCoupons_Displaying_Tag: 'Displaying Tag',
  ep_admin_eCoupons_Displaying_Tag_tip: 'This tag is to specify campaign type (or other purpose). It will be displayed to customers & suppliers if it has value.',
  ep_admin_eCoupons_Collect_period_tip: 'Specify available time period for customer to clip eCoupon.',
  ep_admin_eCoupons_validity_period_tip: 'Specify available time period for customer to use eCoupon.',
  ep_admin_eCoupons_oa_number_tip: 'Please put OA number of promotion scheme for this eCoupon activity.',
  ep_admin_eCoupons_Used_for_Rewards_Store_tip: 'Specify whether eCoupon will be issued as point gift in Rewards store. Precondition is rewards store operation was turned on.',
  ep_admin_eCoupons_Push_Notification_tip: 'Whether to send message to customer message box.',
  ep_admin_eCoupons_Allow_To_Superposition_tip: 'Specify whether  eCoupon activity can be superpositioned with others.',
  ep_admin_eCoupons_contact_us_tip: 'Regional contact info such as support email or phone number etc.',
  ep_admin_eCoupons_releaseLevel_tip: 'Issue to authorized company or all companies.',
  ep_admin_eCoupons_SN_Records_tip: 'Collect the necessary information during eCoupon Verification process if choosing Y.',
  ep_admin_eCoupons_tax_tip: 'Display whether price include tax on customer UI.',
  ep_admin_eCoupons_release_mechanism_tip: 'Automatic distribution to customer or let customer clip the eCoupon.',
  ep_admin_eCoupons_per_person_label_tip: 'Limited number of eCoupon that each user receive.',
  ep_admin_eCoupons_coupon_qty_label_tip: 'Limited total number of eCoupon for customer in this activity.',
  ep_admin_eCoupons_single_limit_label_tip: 'Limited number of eCoupon for each user.',
  ep_admin_eCoupons_eCoupon_Condition_Type_tip: 'Please refer to user manual.',
  ep_admin_eCoupons_eCoupon_Condition_tip: 'Please refer to user manual.',
  ep_admin_eCoupons_eCoupon_Discount_Type_tip: 'Please refer to user manual.',
  ep_admin_eCoupons_eCoupon_Discount_tip: 'Please refer to user manual.',
  ep_admin_eCoupons_Daily_Limit_Type_tip: 'Daily limited type during eCoupon verification process.',
  ep_admin_eCoupons_daily_limit_tip: 'Daily limited number during eCoupon verification process.',
  ep_admin_eCoupons_Information_Collection_tip: 'Specify which information fields expect to be collected during eCoupon verification process.',
  ep_admin_eCoupons_New_Tag: 'New Tag',
  ep_admin_eCoupons_provider_province_tip: 'This line of state is not consistent with eCoupon state, please check.',
  ep_admin_gift_Edit_Gift: 'Edit Gift',
  ep_admin_gift_Gift_img_radio_tip: 'Please check you image format, size and ratio. All of these should match expectation.',
  ep_admin_export_tip_content_2: '! If you need to reimport the document into HPP Admin, you need to remove the access restriction first before import.',
  ep_admin_dpp_Display: 'Display',
  ep_admin_dpp_Display_Program_not_visible_before_initiation_of_contracting: 'Program not visible before initiation of contracting',
  ep_admin_dpp_Display_The_customer_can_see_the_Program_and_initiate_a_contract: 'The customer can see the Program and initiate a contract',
  ep_admin_dpp_allowcustomersDis: 'Allow customers to initiate contracting',
  ep_admin_user_Display_range: 'Display range',
  ep_admin_eCoupons_Membership_Program_Customer_tip: 'It is not eligible to set customer list as it is a Membership binded eCoupon activity.',
  ep_admin_eCoupons_Membership_Program_Customer_Num: 'N/A',
  ep_admin_explore_detail_pdf_tip: 'The pages of the PDF will automatically be fully displayed on the front end.',
  ep_admin_explore_Display_PDF: 'Display PDF',
  ep_admin_explore_maximum10M: 'The file size cannot exceed 10M',
  ep_admin_btns_reset_only: 'Reset Only',
  ep_admin_explore_Upload_Gift_Cover_Image: 'Upload Gift Cover Image',
  ep_admin_gift_Pick_up_In_Store_stock_tip: 'If Ship type is Pick-up in Store, this stock represents sum of each store’s inventory quantity.',
  ep_admin_event_Sign_Up: 'Sign Up',
  ep_admin_event_Sign_Up_Register_directly_in_H5_without_HPP_App: 'Register directly in H5 without HPP App',
  ep_admin_event_Sign_Up_Registeration_Requires_Download_HPP_App: 'Registeration Requires Download HPP App',
  ep_admin_user_map_Workday: 'Workday',
  ep_admin_user_map_Add_Workday: 'Add Workday',
  ep_admin_user_map_workday_Monday: 'Monday',
  ep_admin_user_map_workday_Tuesday: 'Tuesday',
  ep_admin_user_map_workday_Wednesday: 'Wednesday',
  ep_admin_user_map_workday_Thursday: 'Thursday',
  ep_admin_user_map_workday_Friday: 'Friday',
  ep_admin_user_map_workday_Saturday: 'Saturday',
  ep_admin_user_map_workday_Sunday: 'Sunday',
  ep_admin_user_map_Opening_hours: 'Opening hours',
  ep_admin_region_buy_from_company_type_tip: 'Customer Types displayed on 【Buy From】for Authorization',
  ep_admin_region_buy_from_company_type: 'Customer Type',
  ep_admin_region_buy_from_Regex_phone: 'Regex for phone checking',
  ep_admin_explore_content_has_been_cloned_in: 'This content has been cloned in {clonedCountryNames}',
  ep_admin_explore_Cloned_Content: 'Cloned Content',

  ep_admin_case_tabs_title1: 'Configuration',
  ep_admin_case_tabs_title2: 'System notification configuration',
  ep_admin_case_type1: 'Device Unbind',
  ep_admin_case_type2: 'Device Password Reset',
  ep_admin_case_type3: 'Hardware product',
  ep_admin_case_type4: 'Software product',
  ep_admin_case_type5: 'Hik-Partner Pro',
  ep_admin_case_type6: 'VIP case',
  ep_admin_case_type7: 'Contact Technical Support',
  ep_admin_case_table_title1: 'Case type',
  ep_admin_case_table_title2: 'Auto-case Service Level Agreement',
  ep_admin_case_table_title3: 'Manual-case Service Level Agreement',
  ep_admin_case_table_title4: 'Register account',
  ep_admin_case_table_title5: 'Authorized account',
  ep_admin_case_table_title6: 'Company in whitelist',
  ep_admin_case_table_title7: 'Account in whitelist',
  ep_admin_case_table_title8: 'HPP Case',
  ep_admin_case_table_title9: 'Flow Info',
  ep_admin_case_table_title10: 'WhiteList-case Service Level Agreement',
  ep_admin_case_support_config_button1: 'Configure by BU',
  ep_admin_case_support_config_button2: 'Configure by Sub-BU',
  ep_admin_case_support_config_modal_title1: 'Batch Configuration',
  ep_admin_case_support_config_modal_title2: 'Please select the batch configuration template:',
  ep_admin_case_support_config_modal_title3: 'Batch configuration for below countries:',
  ep_admin_case_support_config_modal_title4: 'Confirm to save the configuration content',
  ep_admin_case_support_config_modal_content: 'The configuration for the country of {val} will be uniformly adjusted.',
  ep_admin_case_support_config_tip: 'The country of {val} is not exist, please input correct country name.',
  ep_admin_case_global_config_title: 'System maintenance notice configuration',
  ep_admin_case_global_config_title2: 'Pre-notice start time- Pre-notice end time',
  ep_admin_case_global_config_title3: 'System maintenance pre-notification detail',
  ep_admin_case_global_config_title4: 'System maintenance start time- System maintenance end time',
  ep_admin_case_global_config_title5: 'System maintenance notification',
  ep_admin_case_global_config_placeholder: 'Autosize height based on content lines',
  ep_admin_case_global_config_modal_title: 'Confirm to close the System maintenance notification configuration',
  ep_admin_case_white_modal_tip: 'Please Do Not Add Duplicates',
  ep_admin_explore_In_site_Video: 'In-site Video',
  ep_admin_explore_Link: 'Link',
  ep_admin_banner_Customer_Type: 'Customer Type',
  ep_admin_scan_Exceed: 'Exceed',
  ep_admin_scan_Fake_Code_Processing: 'Fake Code Processing',
  ep_admin_scan_Fake_Process_by_AI: 'Fake Process by AI',
  ep_admin_scan_Fake_Process_by_AI_tip: 'If it is on, system will mark it as fake and reset automatically.',
  ep_admin_scan_Email_Notification_for_Manual_Process: 'Email Notification for Manual Process',
  ep_admin_scan_Email_Notification_for_Manual_Process_tip: 'If it is on, system will send email to country admin.',
  ep_admin_scan_Email_Notification_for_Manual_Process_on_tip: 'Please make sure Default Country Admin has been configured.',
  ep_admin_scan_Fake_Marked_By: 'Fake Marked By',
  ep_admin_scan_Fake_Marked_By_tip: 'Specific name means record processed by operator; AI Robot means processed by system AI algorithm automatically.',
  ep_admin_scan_Reset_Only_History: 'Reset Only History',
  ep_admin_scan_Human_Being: 'Human Being',
  ep_admin_scan_AI_Robot: 'AI Robot',
  ep_admin_scan_fake_Result: 'Fake Result',
  ep_admin_scan_fake_Result_Not_Handle: 'Not Handle',
  ep_admin_scan_fake_Result_Fake: 'Fake',
  ep_admin_scan_fake_Result_True: 'True',
  ep_admin_scan_True_Code: 'True Code',
  ep_admin_scan_Exceed_Warning: 'Exceed Warning ({num})',
  ep_admin_scan_delete_task: 'Are you sure delete this task?',
  ep_admin_scan_delete_task_Just_this_time: 'Just this time',
  ep_admin_scan_delete_task_Delete_existing_quantity: 'Delete existing quantity',
  ep_admin_scan_Exceed_Warning_tip: 'The number of successful SN scanning of the following users on the same day exceeds the warning limit, please check whether these users have illegal operation',
  ep_admin_scan_Fake_Warning: 'Fake Warning ({num})',
  ep_admin_scan_Fake_Warning_tip: 'You need to manually process the suspected fake code in this part.',
  ep_admin_user_hppUserStatus: 'User Limitation',
  ep_admin_user_hppUserStatus_Limited: 'Limited',
  ep_admin_user_hppUserStatus_Normal: 'Normal',
  ep_admin_user_map_Batch_Invite: 'Batch Invite',
  ep_admin_user_map_downloadTemplate: 'Download template',
  ep_admin_user_map_Batch_upload_textual_store_information: 'Batch upload textual store information',
  ep_admin_user_map_status_User_Saved: 'User Saved',

  ep_admin_region_customer_Site_Custom_Function: 'Custom Function',
  ep_admin_region_customer_Site_Function_Name: 'Function Name',
  ep_admin_region_customer_Site_Link: 'Link',
  ep_admin_region_customer_Site_Logo: 'Logo',
  ep_admin_region_customer_Site_Logo_maximum200k: 'The image size cannot exceed 200k',
  ep_admin_toolkit_customToolkit: 'Customize the toolkit management of the current country.',
  ep_admin_toolkit_HQDefault: 'If not,the configuration of the HQ will be defaulted.',
  ep_admin_toolkit_custom_Toolkit: 'Custom Toolkit',
  ep_admin_toolkit_sortTip: 'Drag the toolkits to sort it, each section can display 8 toolkits or groups at most in APP.',
  ep_admin_toolkit_New_Toolkit: 'New Toolkit',
  ep_admin_toolkit_Edit_Toolkit: 'Edit Toolkit',
  ep_admin_toolkit_Group: 'Group',
  ep_admin_toolkit_New_Group: 'New Group',
  ep_admin_toolkit_Edit_Group: 'Edit Group',
  ep_admin_toolkit_Group_Name: 'Group Name',
  ep_admin_toolkit_Keywords: 'Keywords',
  ep_admin_toolkit_logo_maximum1M: 'The image size cannot exceed 1M',
  ep_admin_toolkit_Drag_the_Toolkits_to_sort_it: 'Drag the Toolkits to sort it',
  ep_admin_toolkit_delete_toolkit: 'Are you sure delete this toolkit?',
  ep_admin_toolkit_delete_group: 'Are you sure delete this group?',
  ep_admin_toolkit_toolkit_Name: 'Toolkit Name',
  ep_admin_points_type_449_tip: 'On: Partial points task are calculated for membership, this option will not affect the current points system and usage. Off: All task points arecalculated for membership.',
  ep_admin_points_type_449_tip1: 'On: Partial points task are calculated for membership, this option will not affect the current points system and usage.',
  ep_admin_points_type_449_tip2: 'Off: All task points arecalculated for membership.',
  ep_admin_points_Membership_Calculation: 'Membership Calculation',
  ep_admin_points_Partial_Points_calculation_for_Membership_tip: 'Be cautious of turning this on as it will affect the membership system, are you sure?',
  ep_admin_points_Membership_calculation_tip: 'Be cautious of turning this on/off as it may affect membership level calculation. Do you want to continue?',
  ep_admin_member_eLearning_Certificate: 'eLearning Certificate',
  ep_admin_member_eLearning_Certificate_Not_Required: 'Not Required',
  ep_admin_member_eLearning_Certificate_Certificate_Total_Number: 'Certificate Number',
  ep_admin_member_eLearning_Certificate_Certificate_Name: 'Certificate Name',
  ep_admin_member_eLearning_Certificate_tip: 'This will clear previous configuration, are you sure?',
  ep_admin_member_certificate_name_cannot_empty: 'The certificate name cannot be empty.',
  ep_admin_member_publish_status_tip1: "Please turn on/off the Caculation Mode.",
  ep_admin_member_publish_status_tip2: "Note: If 'Partial points caculation for membership' option turned on in Rewards type, only points of membership will be calculated.",
  ep_admin_member_level_Conditions_tip: "Each level need to meet both Points & Certificate condition",
  ep_admin_toolkit_toolkit: 'Toolkit',
  ep_admin_toolkit_delete_Favorites_toolkit: 'Are you sure remove this toolkit from favorites?',

  ep_admin_dpp_Signature_Method: 'Signature Method',
  ep_admin_dpp_Signature_Method_Docusign: 'Docusign',
  ep_admin_dpp_Signature_Method_Confirm_and_agree_agreement: 'Confirm and agree agreement',
  ep_admin_se_allowcustomersDis: 'Allow customers to initiate contracting',
  ep_admin_survey_data: 'Data',
  ep_admin_survey_overview: 'Overview',
  ep_admin_survey_survey_id: 'Survey ID',
  ep_admin_survey_survey_name: 'Survey Name',
  ep_admin_survey_authorize: 'Authorize',
  ep_admin_survey_points_tips: 'Only APP rewards points',
  ep_admin_survey_recovery: 'Recovery',
  ep_admin_survey_cancelled: 'Cancelled',
  ep_admin_survey_respondent: 'Respondent',
  ep_admin_survey_effective: 'Effective',
  ep_admin_survey_answering_duration: 'Answering Duration',
  ep_admin_survey_average_duration_per_person: 'Average duration per person',
  ep_admin_survey_min: 'min',
  ep_admin_survey_total_number_of_questions: 'Total number of questions',
  ep_admin_survey_qs: 'Qs',
  ep_admin_survey_participation_statistics: 'Participation Statistics',
  ep_admin_survey_complete_the_answer_sheet: 'Complete the answer sheet',
  ep_admin_survey_participation_number: 'Participation Number',
  ep_admin_survey_answering_analysis: 'Answering Analysis',
  ep_admin_survey_answering_analysis_tip: 'The following problem analysis is limited to true or false questions only, and does not include declarative questions',
  ep_admin_survey_people: 'people',
  ep_admin_survey_statistics: 'Statistics',
  ep_admin_survey_chart: 'Chart',
  ep_admin_survey_by_h5: 'By H5',
  ep_admin_survey_hpp_h5: 'HPP H5',
  ep_admin_survey_data_filter: 'Data Filter',
  ep_admin_membership_level: 'Membership Level',
  ep_admin_survey_share_title: 'Share',
  ep_admin_survey_share_portal_link: 'Portal Link',
  ep_admin_survey_share_h5_link: 'H5 Link',
  ep_admin_survey_share_app_link: 'App Link',
  ep_admin_form_maximumTips: 'Image must be smaller than 2M',
  ep_admin_form_landing_page_settings: 'Landing page settings',
  ep_admin_form_reset_default: 'Reset Default',
  ep_admin_form_result_tip: 'The content to be displayed after the user clicks submit',
  ep_admin_form_landing_page: 'Landing page',
  ep_admin_form_explaination: 'Explaination',
  ep_admin_form_showType: 'Show Type',
  ep_admin_form_left: 'Left',
  ep_admin_form_right: 'Right(ar)',
  ep_admin_points_Membership_Level: 'Membership Level',

  ep_admin_scan_Email_Receiver: 'Email Receiver',
  ep_admin_scan_Email_Receiver_required_tip: 'Email Receiver must be configured.',
  ep_admin_gift_Gift_Management_Log: 'Gift Management Log',
  ep_admin_user_HPC_Company_ID_long: 'HPC Company ID (long)',
  ep_admin_user_HPC_Company_ID_long_tip: 'Unique ID in HPC (long)',
  ep_admin_user_epCompanyId_tip: 'Unique ID in EPAdmin',
  ep_admin_user_hpcCompanyId_tip: 'General unique ID in all platforms. Displayed to clients',
  ep_admin_banner_Explore: 'Explore',

  ep_admin_region_Explore_Tab_Sort: 'Explore Tab Sort:',
  ep_admin_region_explore_config_NO: 'NO.',
  ep_admin_region_explore_config_Tab: 'Tab',
  ep_admin_region_Explore_Elearning_Sync_Event: 'eLearning sync Event',
  ep_admin_region_Explore_Elearning_Sync_Event_tip: 'After turning on the switch, Classroom、Webinar、Workshop、Seminar in eLearning will be created as an event in HPP automatically',

  // 社区配置
  ep_admin_community_current_region: 'Current Country/Region',
  ep_admin_community_sync_region: 'SYNC Up To Other Country/Regions',
  ep_admin_community_name: 'Community Name',
  ep_admin_community_introduction: 'Community Introduction',
  ep_admin_community_icon_upload: 'Icon',
  ep_admin_community_icon_formate_tips: 'Only supports png/jpg format, size no more than 2M, reference 1:1',
  ep_admin_community_cover_image: 'Cover Image',
  ep_admin_community_cover_image_formate_tips: 'Only supports png/jpg format, size no more than 2M, reference 343*100px',
  ep_admin_community_cover_image_formUploadType: 'Only accept PNG/JPG format image',
  ep_admin_community_icon_formUploadType: 'Only accept PNG/JPG format image',
  ep_admin_community_icon_size_limit: 'Image size does not exceed 2M',
  ep_admin_community_icon_size_limit_gb: 'Image size does not exceed 1G',
  ep_admin_community_description: 'Community Description',
  ep_admin_community_Rules: 'Community Rules',
  ep_admin_community_privacy_poicy: 'Privacy Poicy',
  ep_admin_community_post_id: 'Post ID',
  ep_admin_community_one_hik_id: 'OneHikId',
  ep_admin_community_country_region: 'Country/Region',
  ep_admin_community_last_modify_date: 'Last Modify Date',
  ep_admin_community_post_review_status: 'Status',
  ep_admin_community_post_type: 'Type',
  ep_admin_community_post_approval_time: 'Approval Time',
  ep_admin_community_post_review_time: 'Review Time',
  ep_admin_community_post_is_reported: 'Is Reported',
  ep_admin_community_post_comments: 'Comments',
  ep_admin_community_author: 'Author',
  ep_admin_community_post_title: 'Title',
  ep_admin_community_post_content: 'Content',
  ep_admin_community_post_reject_reason: 'Reason for Rejected',
  ep_admin_community_post_feedback_type: 'Feedback Type',
  ep_admin_community_post_detailed_explanation: 'Detailed Explanation',
  ep_admin_community_post_reviewer: 'Reviewer',
  ep_admin_community_select_all: 'All',
  ep_admin_community_to_be_approvaled: 'To be Approved',
  ep_admin_community_post_approvaled: 'Approved',
  ep_admin_community_post_reject: 'Rejected',
  ep_admin_community_post_type_discussion: 'Discussion',
  ep_admin_community: 'Community',
  ep_admin_community_post_type_feeds: 'Feeds',
  ep_admin_community_post_type_event: 'Event',
  ep_admin_community_post_type_techZone: 'Tech Zone',
  ep_admin_community_post_type_featured: 'Featured',
  ep_admin_community_post_has_new_comments: 'New comment',
  ep_admin_community_post_no_new_comments: 'No new comment',
  ep_admin_community_post_explanation_ignore: 'Ignore',
  ep_admin_community_post_explanation_detail: 'Detail',
  ep_admin_community_post_choose_reject_reason: 'Choose Reason for Rejection',
  ep_admin_community_post_reject_reason_involve_explicit: 'Involve explicit content',
  ep_admin_community_post_reject_reason_sensitive_political: 'Sensitive political terms',
  ep_admin_community_post_reject_reason_violent_terrorist: 'Content containing violent and terrorist information',
  ep_admin_community_post_reject_reason_prohibited_information: 'Garbage and prohibited information',
  ep_admin_community_post_reject_reason_offensive_language: 'Content containing offensive language',
  ep_admin_community_post_reject_reason_infringement: 'Infringement',
  ep_admin_community_post_publish_tip: 'Are you sure to publish this post?',
  ep_admin_community_post_conceal_tip: 'Are you sure to conceal this post?',
  ep_admin_community_comment_commentator: 'Commentator',
  ep_admin_community_comment_reply_to: 'Reply to',
  ep_admin_community_comment_time: 'Comment Time',
  ep_admin_community_comment_content: 'Comment Content',
  ep_admin_community_member_role: 'Role',
  ep_admin_community_member_top_fans: 'Top Fans',
  ep_admin_community_member_ordinary_users: 'Ordinary Users',
  ep_admin_community_member_custom_tags: 'Custom Tags',
  ep_admin_community_member_invitation_link: 'By Invitation link',
  ep_admin_community_member_join_proactively: 'Join Proactively',
  ep_admin_community_member_user_name: 'Member name',
  ep_admin_community_member_user_email: 'User Email',
  ep_admin_community_member_user_role: 'Role',
  ep_admin_community_member_number_of_posts: 'Number of Posts',
  ep_admin_community_member_method_of_joining: 'Method of Joining',
  ep_admin_community_member_join_date: 'Join Date',
  ep_admin_community_member_company_name: 'Company Name',
  ep_admin_community_member_authorized_status: 'Authorized Status',
  ep_admin_community_member_tags: 'Tags',
  ep_admin_community_member_tags_management: 'Tags Management',
  ep_admin_community_member_top_fans_desc: 'High user post counts and comment volumes',
  ep_admin_community_member_ordinary_users_desc: 'Average-performing users',
  ep_admin_community_member_no_custom_tags: 'No custom tags',
  ep_admin_community_member_tags_limit: 'Limit to adding 10 tags',
  ep_admin_community_member_tags_words_limit: 'max 100 characters',
  ep_admin_community_community_cover: 'Community Cover',
  ep_admin_community_community_cover_image_formate_tips: 'Image size no more than 20M, reference 343*120px',
  ep_admin_community_community_cover_image_maximum: 'The image size cannot exceed 20M',
  ep_admin_community_community_ai_status: 'AI Status',
  ep_admin_community_community_ai_tags: 'AI Tags',
  ep_admin_community_community_ai_suspect: 'Suspect',
  ep_admin_community_community_ai_failed: 'Failed',
  ep_admin_community_community_add_post: 'Add Post',
  ep_admin_community_community_edit_post: 'Edit Post',
  ep_admin_community_community_post_comment_img: 'Comment Image',
  ep_admin_community_post_type_official: 'Official',
  ep_admin_community_community_post_picture_or_video: 'Picture or Video',
  ep_admin_community_member_mute: 'Mute',
  ep_admin_community_member_mute_member: 'Mute Member',
  ep_admin_community_member_mute_tip: 'After you muted, member will not be able to post or comment',
  ep_admin_community_member_mute_date_tip: 'The customer has been muted until {time}',
  ep_admin_community_member_mute_permanent_tip: 'The customer has been muted permanently',
  ep_admin_community_member_mute_permanent: 'permanent',
  ep_admin_community_member_mute_cancel: 'cancel mute',
  ep_admin_community_member_mute_option_day: '{day} days',
  ep_admin_certification_certification_name: 'Certificate Name',
  ep_admin_certification_Is_Expired: 'Is Expired',
  ep_admin_certification_Is_Expired_Yes: 'Yes',
  ep_admin_certification_Is_Expired_No: 'No',
  ep_admin_certification_EP_Company_ID: 'EP Company ID',
  ep_admin_certification_EP_Company_Name: 'EP Company Name',
  ep_admin_certification_OneHikID: 'OneHikID',
  ep_admin_certification_Obtained_Date: 'Obtained Date',
  ep_admin_certification_ID: 'ID',
  ep_admin_certification_Region: 'Region',
  ep_admin_certification_Obtainer_OneHikID: 'Obtainer OneHikID',
  ep_admin_certification_Obtainer_Name: 'Obtainer Name',
  ep_admin_certification_eLearning_Certificate_ID: 'eLearning Certificate ID',
  ep_admin_certification_Certificate_Type: 'Certificate Type',
  ep_admin_certification_Certificate_Type_0: 'Certification',
  ep_admin_certification_Certificate_Type_1: 'Non-Certification',
  ep_admin_certification_Certificate_Name: 'Certificate Name',
  ep_admin_certification_Certificate: 'Certificate',
  ep_admin_certification_Expire_Date: 'Expire Date',
  ep_admin_certification_Last_Update_Date: 'Last Update Date',
  ep_admin_screen_Points: 'Points',
  ep_admin_redeem_status: 'Status',
  ep_admin_redeem_status_Saved: 'Saved',
  ep_admin_redeem_status_Approving: 'Approving',
  ep_admin_redeem_status_Rejected: 'Rejected',
  ep_admin_redeem_status_Approved: 'Approved',
  ep_admin_redeem_status_Terminated: 'Terminated',
  ep_admin_redeem_status_Redeeming: 'Redeeming',
  ep_admin_redeem_status_Finished: 'Finished',
  ep_admin_redeem_Redemption_Code_Keyword: 'Redemption Code Keyword',
  ep_admin_redeem_Redemption_Code_Keyword_tip: 'Redemption Code ID / Redemption Code Name',
  ep_admin_redeem_Creation_Date: 'Creation Date',
  ep_admin_redeem_Redemption_Code_ID: 'Redemption Code ID',
  ep_admin_redeem_Redemption_Code_Name: 'Redemption Code Name',
  ep_admin_redeem_Count: 'Count',
  ep_admin_redeem_Redeemed_Count: 'Redeemed Count',
  ep_admin_redeem_Points_Value: 'Points Value',
  ep_admin_redeem_Region: 'Region',
  ep_admin_redeem_Redeem_Period: 'Redeem Period',
  ep_admin_redeem_Reason: 'Reason',
  ep_admin_redeem_New_Redemption_Code: 'New Redemption Code',
  ep_admin_redeem_Edit_Redemption_Code: 'Edit Redemption Code',
  ep_admin_redeem_Redemption_Code: 'Redemption Code',
  ep_admin_redeem_Points_value_of_each_code: 'Points value of each code',
  ep_admin_redeem_Add_Code: 'Add Code',
  ep_admin_redeem_Total_Count: 'Total Count: {totalCount}',
  ep_admin_redeem_Total_Points_Value: 'Total Points Value: {totalPoints}',
  ep_admin_redeem_Redemption_Code_Information: 'Redemption Code Information',
  ep_admin_redeem_Code_Status_Unredeemed: 'Unredeemed',
  ep_admin_redeem_Code_Status_Redeemed: 'Redeemed',
  ep_admin_redeem_Company_ID: 'Company ID',
  ep_admin_redeem_OneHikID: 'OneHikID',
  ep_admin_redeem_Points: 'Points ',
  ep_admin_redeem_Redeem_Time: 'Redeem Time',
  ep_admin_redeem_Country: 'Country',
  ep_admin_redeem_EP_Company_ID: 'EP Company ID',
  ep_admin_redeem_Company_Name: 'Company Name',
  ep_admin_redeem_User_Name: 'User Name',
  ep_admin_redeem_User_Email: 'User Email',
  ep_admin_redeem_totalCount_tip: 'The maximum number of redemption codes is 100',
  ep_admin_redeem_submit_Redeem_tip_title: 'Submit for approval?',
  ep_admin_redeem_submit_Redeem_tip: 'After approval, customers can redeem points during the redeem period.',
  ep_admin_redeem_terminated_Redeem_tip_title: 'Terminate the Redemption code?',
  ep_admin_redeem_terminated_Redeem_tip: 'After termination, customers can not redeem points any more.',

  ep_admin_dpp_Level_display: 'Level Display',


  ep_admin_eCoupons_Company_Authorization_Date: 'Company Authorization Date',
  ep_admin_eCoupons_Company_Authorization_Date_tip: 'Issue the coupon to those customers authorized within this date range.',
  ep_admin_member_eLearning_Certificate_Number: 'Certificate Number',
  ep_admin_member_eLearning_Certificates: 'Certificates',
  ep_admin_member_eLearning_Certificates_tip: 'This number is just for display purposes and does not mean that you have activated the membership according to the certificate.',
  ep_admin_store_Website_tip: 'Please enter full address, including https/http',
  ep_admin_member_Recalculate: 'Recalculate',
  ep_admin_member_Calculation_mode_alert1: 'This country is currently in',
  ep_admin_member_Calculation_mode_alert2: 'Calculation',
  ep_admin_member_Calculation_mode_alert3: 'mode. It may take 20~60 mins after recalculation.',
  ep_admin_member_Published_mode_alert1: 'This country is currently in',
  ep_admin_member_Published_mode_alert2: 'Official Published',
  ep_admin_member_Published_mode_alert3: 'mode',
  ep_admin_member_MemberShip_Configure_confirm_tip: 'Please review new parameter carefully as it will lead to lots of recalculation, continue?',
  ep_admin_eCoupons_disburseManage: 'Disbursement Accounting',
  ep_admin_tip_Are_you_sure_to_delete_it: 'Are you sure to delete it?',
  ep_admin_scan_Fake_Process_by_AI_tip_Important: 'Important: System check fake code & reset points from',
  ep_admin_dpp_Total_max_supplier_number: 'Total max supplier number',

  ep_admin_complement_oa_number: 'OA Number',
  ep_admin_complement_shared_date: 'Shared Date',
  ep_admin_member_State: 'State',
  ep_admin_member_City: 'City',
  ep_admin_member_Zipcode: 'Zip Code',
  ep_admin_smart_quote_Template_ID: 'Template ID',
  ep_admin_smart_quote_Template_Name: 'Template Name',
  ep_admin_smart_quote_Region: 'Region',
  ep_admin_smart_quote_ID: 'ID',
  ep_admin_smart_quote_Catalogue: 'Catalogue',
  ep_admin_smart_quote_Status: 'Status',
  ep_admin_smart_quote_Update_Time: 'Update Time',
  ep_admin_smart_quote_Modified_By: 'Modified By',
  ep_admin_smart_quote_Add_Smart_Quote_Template: 'Add Smart Quote Template',
  ep_admin_smart_quote_Edit_Smart_Quote_Template: 'Edit Smart Quote Template',
  ep_admin_user_merged: 'Merged',
  ep_admin_user_merged_Information: 'Merged Information',
  ep_admin_companyMerge_merged_type: 'Merge Type',
  ep_admin_companyMerge_mergeType: 'Merge Type',



  ep_admin_region_map_Distance_Unit: 'Distance Unit',
  ep_admin_region_map_Display_Distance_range: 'Display Distance range',
  ep_admin_consignment_amount_limited: 'Consignment Amount Limited',
  ep_admin_consignment_amount_currency: 'Currency',
  ep_admin_consignment_minPctAmountForOrder: 'Minimum percentage amount for consignment orders (%)',
  ep_admin_consignment_minAmountForOrder: 'Minimum amount for consignment orders',
  ep_admin_consignment_monthlyOrderLimit: 'Monthly Consignment Order Limit',
  ep_admin_explore_Parent_Id: 'Parent Id',
  ep_admin_tutorial_type_Howto: 'Howto',
  ep_admin_tutorial_type_MarketMaterial: 'MarketMaterial',
  ep_admin_tutorial_type_Handouts: 'Handouts',
  ep_admin_tutorial_type_TechnicalGuidance: 'TechnicalGuidance',
  ep_admin_tutorial_Format_Document: 'Document',
  ep_admin_tutorial_Format_Video: 'Video',
  ep_admin_tutorial_Format_Paper_Material: 'Paper Material',
  ep_admin_tutorial_Topic: 'Topic',
  ep_admin_dpp_programAgree_tip: 'Only support word, if no signature is required, upload PDF',
  ep_admin_companyMerge_mergeType_Complete: 'Complete',
  ep_admin_companyMerge_mergeType_Parallel: 'Parallel',
  ep_admin_customer_invitation_Invitation_Type: 'Invitation Type',
  ep_admin_customer_invitation_Invitation_Type_All: 'All',
  ep_admin_customer_invitation_Invitation_Type_Invite_Friend: 'Invite Friend',
  ep_admin_customer_invitation_Invitation_Type_Invite_Employee: 'Invite Employee',
  ep_admin_customer_invitation_Inviter_Company_Name: 'Inviter Company Name',
  ep_admin_customer_invitation_Inviter_HPC_Company_ID_Short: 'Inviter HPC Company ID(short)',
  ep_admin_customer_invitation_Inviter_EP_Company_ID: 'Inviter EP Company ID',
  ep_admin_customer_invitation_Inviter_User_Email: 'Inviter User Email',
  ep_admin_customer_invitation_Invitee_Company_Name: 'Invitee Company Name',
  ep_admin_customer_invitation_Invitee_User_Email: 'Invitee User Email',
  ep_admin_customer_invitation_Region: 'Region',
  ep_admin_customer_invitation_Inviter_OneHikiD: 'Inviter OneHikiD',
  ep_admin_customer_invitation_Inviter_Email: 'Inviter Email',
  ep_admin_customer_invitation_Inviter_Name: 'Inviter Name',
  ep_admin_customer_invitation_Inviter_Company_Type: 'Inviter Company Type',
  ep_admin_customer_invitation_Company_Status: 'Inviter Company Status',
  ep_admin_customer_invitation_Company_Status_In_Authorize: 'In Authorize',
  ep_admin_customer_invitation_Company_Status_Authorized: 'Authorized',
  ep_admin_customer_invitation_Company_Status_Authorized_by_Code: 'Authorized by Code',
  ep_admin_customer_invitation_Company_Status_Refused: 'Refused',
  ep_admin_customer_invitation_Company_Status_Non_Authorized: 'Non-Authorized',
  ep_admin_customer_invitation_Invitee_OneHikID: 'Invitee OneHikID',
  ep_admin_customer_invitation_Invitee_Email: 'Invitee Email',
  ep_admin_customer_invitation_Invitee_Name: 'Invitee Name',
  ep_admin_customer_invitation_Invitee_HPC_Company_ID_Short: 'Invitee HPC Company ID(short)',
  ep_admin_customer_invitation_Invitee_EP_Company_ID: 'Invitee EP Company ID',
  ep_admin_customer_invitation_Invitee_Company_Type: 'Invitee Company Type',
  ep_admin_customer_invitation_Invitee_Company_Status: 'Invitee Company Status',
  ep_admin_customer_invitation_Inviter_Obtained_Points: 'Inviter Obtained Points',
  ep_admin_customer_invitation_Invitee_Obtained_Points: 'Invitee Obtained Points',
  ep_admin_customer_invitation_Invite_Date: 'Invite Date',
  ep_admin_product_category_number: 'category Number',
  ep_admin_product_category_name: 'category Name',
  ep_admin_product_category_name_EN: 'category Name(EN)',
  ep_admin_product_Level: 'Level',
  ep_admin_product_language: 'Language',
  ep_admin_product_Translate_Time: 'Translate Time',
  ep_admin_product_Translation_Time: 'Translation Time',
  ep_admin_product_Send_to_Hitranslator: 'Send to Hitranslator',
  ep_admin_product_SYNC_Task: 'SYNC Task',
  ep_admin_product_Translate_Task_Detail: 'Translate Task Detail',
  ep_admin_product_Create_translate_task: 'Create translate task',
  ep_admin_product_Due_Date: 'Due Date',
  ep_admin_product_Task_Name: 'Task Name',
  ep_admin_product_Notes: 'Notes',
  ep_admin_product_Hitranslator_Project: 'Hitranslator Project',
  ep_admin_product_Target_Language: 'Target Language',
  ep_admin_adpage_Display_Time: 'Display Time',
  ep_admin_adpage_ID: 'ID',
  ep_admin_adpage_Picture: 'Picture',
  ep_admin_adpage_Country: 'Country',
  ep_admin_adpage_Update_Time: 'Update Time',
  ep_admin_adpage_Creator: 'Creator',
  ep_admin_adpage_Modify_By: 'Modify By',
  ep_admin_adpage_Publish: 'Publish',
  ep_admin_adpage_Message: 'Message',
  ep_admin_adpage_Published_tip: 'Only one effective AD page at one time. In your selected display period, following countries have effective AD Page. Please adjust this AD page country range/Display time or adjust the historical publish records',
  ep_admin_adpage_Published_tip_msg: 'ID: {id},  Country:{countryName}, Display time: {displayDate}',
  ep_admin_customer_Edit_CRM_Lead_ID: 'Edit CRM Lead ID',
  ep_admin_customer_CRM_lead_id: 'CRM lead id',
  ep_admin_customer_info_change_approval: 'Info change approval',
  ep_admin_customer_Partner_program_number: 'Partner program number',
  ep_admin_customer_HDP_number: 'HDP number',

  ep_admin_opportunity_hik_project_no: 'Hik-Project No.',
  ep_admin_opportunity_quotation_no: 'Quotation No.',
  ep_admin_opportunity_sap_no: 'SAP No.',
  ep_admin_opportunity_pi_no: 'PI No.',
  ep_admin_opportunity_customer_id: 'Customer ID',
  ep_admin_opportunity_valid_date: 'Valid Date',
  ep_admin_opportunity_create_time: 'Create Time',
  ep_admin_opportunity_update_time: 'Update Time',
  ep_admin_opportunity_valid_to: 'Valid To',
  ep_admin_isInternation: 'isInternation',
  ep_admin_limit: 'Limit',
  ep_admin_remain: 'Remain',
  ep_admin_on_the_way: 'On The Way',
  ep_admin_opportunity_item: 'Item',
  ep_admin_opportunity_rac: 'RAC',
  ep_admin_yes: 'Yes',
  ep_admin_no: 'No',
  ep_admin_ranking_Add_Device: 'Add Device',
  ep_admin_ranking_Invitation: 'Invitation',
  ep_admin_ranking_Ranking_List_Type: 'Ranking List Type',
  ep_admin_ranking_Ranking_List_ID: 'Ranking List ID',
  ep_admin_ranking_Ranking_List_Name: 'Ranking List Name',
  ep_admin_ranking_Device_Analysis: 'Device Analysis',
  ep_admin_ranking_Blacklist: 'Blacklist',
  ep_admin_ranking_Add_Ranking_List: 'Add Ranking List',
  ep_admin_ranking_Region: 'Region',
  ep_admin_ranking_Ranking_Type: 'Ranking Type',
  ep_admin_ranking_Ranking_Type_Weekly: 'Weekly',
  ep_admin_ranking_Ranking_Type_Monthly: 'Monthly',
  ep_admin_ranking_Ranking_Type_Quarterly: 'Quarterly',
  ep_admin_ranking_Ranking_Type_Annual: 'Annual',
  ep_admin_ranking_Ranking_Count: 'Ranking Count',
  ep_admin_ranking_Ranking_Encryption: 'Company Name Encryption',
  ep_admin_ranking_Ranking_Period: 'Ranking Period',
  ep_admin_ranking_Publish: 'Publish',
  ep_admin_ranking_Copy_Link: 'Copy Link',
  ep_admin_ranking_Ranking_List_Information: 'Ranking List Information',
  ep_admin_ranking_Customer_Type: 'Customer Type',
  ep_admin_ranking_Ranking_Rule: 'Ranking Rule',
  ep_admin_ranking_Color_Value: 'Color Value',
  ep_admin_ranking_Color_Value_tip: 'Please input the correct color value',
  ep_admin_ranking_Background_Image: 'Background Image',
  ep_admin_ranking_to: 'to',
  ep_admin_ranking_Company_ID: 'Company ID',
  ep_admin_ranking_Blacklist_Time: 'Blacklist Time',
  ep_admin_ranking_Add_Device_Count: 'Add Device Count',
  ep_admin_ranking_Invitees_Number: 'Invitees Number',
  ep_admin_ranking_EP_Company_ID: 'EP Company ID',
  ep_admin_ranking_Company_Name: 'Company Name',
  ep_admin_ranking_Company_Type: 'Company Type',
  ep_admin_ranking_Company_Email: 'Company Email',
  ep_admin_ranking_Country: 'Country',
  ep_admin_ranking_Rank: 'Rank',
  ep_admin_ranking_Portal_Link: 'Portal Link',
  ep_admin_ranking_App_Link: 'App Link',
  ep_admin_ranking_Are_you_sure_to_delete_it: 'Are you sure to delete it？',
  ep_admin_ranking_Background_Image_tip: 'Support format:jpg、png、jpeg、webp, Ratio: 343:120',
  ep_admin_ranking_edit_ranking_tip: 'Are you sure to submit it？ This modification only applies to the unfinished ranking cycle.',
  ep_admin_eCoupons_company_Store: 'Company Store',
  ep_admin_eCoupons_Stores_that_can_verify_eCoupons: 'Stores that can verify eCoupons',
  ep_admin_eCoupons_Unselected_Stores: 'Unselected Stores',
  ep_admin_map_edit_tag: 'Edit Tag',
  ep_admin_map_add_store_tip: 'No authorized and active company found, please check in Customer Management',

  ep_admin_SMB_SMB_Solution_Publish_report: 'SMB Solution Publish report',
  ep_admin_SMB_SMB_function_Publish_report: 'SMB function Publish report',
  // ep_admin_SMB_Product_function_Publish_report: 'Product function Publish report',
  // ep_admin_SMB_Quote_function_Publish_report: 'Quote function Publish report',
  ep_admin_points_453_tip: 'Set the points value that can be earned by scoring 【Feeds/TechZone Contents】',
  ep_admin_agent_Apply_to_Region: 'Apply to Region',
  ep_admin_agent_Define_Agent: 'Define Agent',
  ep_admin_agent_Sync_to_Regions: 'Sync to Regions',
  ep_admin_agent_Sync_to_Regions_tip: 'This may sync HQ agent name, display name, icon and sort to regions, are you sure?',
  ep_admin_agent_Add_Agent: 'Add Agent',
  ep_admin_agent_Edit_Agent: 'Edit Agent',
  ep_admin_agent_Agent_Detail: 'Agent Detail',
  ep_admin_agent_sort: 'Sort',
  ep_admin_agent_No: 'No.',
  ep_admin_agent_HQ_Agent_Name: 'HQ Agent Name',
  ep_admin_agent_HQ_Agent_Display_Name: 'HQ Agent Display Name',
  ep_admin_agent_Display_Icon: 'Display Icon',
  ep_admin_agent_Visible_in_Region: 'Hikie Enable',
  ep_admin_agent_Visible_to_Some_Companies: 'Company Whitelist',
  ep_admin_agent_Visible_to_Some_Companies_tip: 'Please enter Company HPC long Ids separated with ";"',
  ep_admin_agent_Succeeded: 'Succeeded',
  ep_admin_agent_Failed_please_try_again: 'Failed, please try again',
  ep_admin_agent_Copy_to: 'Copy to',
  ep_admin_agent_Copy_to_tip: 'This will sync company white list to each agent and overwite previous values, are you sure?',
  ep_admin_agent_All: 'All',
  ep_admin_agent_Copy_White_List: 'Copy White List',
  ep_admin_agent_external_link: 'External Link',
  ep_admin_agent_external_link_placeholder: 'Enter external link',
  ep_admin_agent_external_link_title: 'Add Link for Chatbot Agent',
  ep_admin_agent_external_link_tip: 'The default value priority of the external link is: country >BU>HQ.',
  ep_admin_agent_external_link_alert: 'Please check carefully. Your new setting will overwrite the previous values.',
  ep_admin_b2b_agent_customer_whitelist_tip: 'Please enter customer SAP ids separated with ","',
  ep_admin_b2b_agent_channel_link_tip: 'Please enter the robot corresponding link',
  ep_admin_b2b_agent_channel_link_required: 'Channel Link is required when Hikie B2B Enable is ON',
  ep_admin_b2b_agent_fetch_failed: 'Failed to fetch data',
  ep_admin_b2b_agent_update_success: 'Update successful',
  ep_admin_b2b_agent_update_failed: 'Update failed, please try again',
  ep_admin_agent_whitelist_tooltip: 'Please enter Company HPC long Ids separated with ";"',
  ep_admin_agent_whitelist_placeholder: 'Enter company whitelist',
  ep_admin_agent_Failed_to_load_config: 'Failed to load config',
  ep_admin_b2b_return_no: 'B2B Return No',
  ep_admin_sap_order: 'SAP Order',
  ep_admin_create_time: 'Create Time',
  ep_admin_create_by: 'Create By',
  ep_admin_invoice_number: 'Invoice Number',
  ep_admin_customer_reference_number: 'Customer Reference Number',
  ep_admin_user_sapid: 'User SapId',
  ep_admin_return_user_name: 'User Name',
  ep_admin_total_net_amount: 'Total Net Amount',
  ep_admin_currency: ' Currency',
  ep_admin_appendix: 'Appendix',
  ep_admin_return_status: 'Return Status',
  ep_admin_expand: 'Expand',
  ep_admin_return_quantity: 'Return Quantity',
  ep_admin_production_notes: 'Production Notes',
  ep_admin_project_number: 'Project Number',
  ep_admin_sync_from_oa: 'sync from OA',
  ep_admin_submit_to_oa: 'submit to OA',
  ep_admin_order_download: 'Order Download',
  ep_admin_order_return_download: 'Order Return Download',
  ep_admin_return_customerId: 'Customer ID',
  ep_admin_dn_no: 'DN NO.',
  ep_admin_sap_return_order_number: 'SAP Return Order Number',
  ep_admin_item_id: 'Item Id',
  ep_admin_return_price: 'Price',
  ep_admin_select_all: 'select all',
  ep_admin_collection_Collection_ID: 'Collection ID',
  ep_admin_collection_Collection_Title: 'Collection Title',
  ep_admin_collection_Content_ID: 'Content ID',
  ep_admin_collection_Content_Title: 'Content Title',
  ep_admin_collection_Sort: 'Sort',
  ep_admin_collection_Sort_hot: 'Hot',
  ep_admin_collection_Sort_medium: 'Medium',
  ep_admin_collection_Sort_low: 'Low',
  ep_admin_collection_Publish: 'Publish',
  ep_admin_collection_Publish_Y: 'Y',
  ep_admin_collection_Publish_N: 'N',
  ep_admin_collection_Creation_Date: 'Creation Date',
  ep_admin_collection_Content_Count: 'Content Count',
  ep_admin_collection_Display_Area: 'Display Area',
  ep_admin_collection_Display_Time: 'Display Time',
  ep_admin_collection_Last_Modify_Date: 'Last Modify Date',
  ep_admin_collection_Pulisher: 'Pulisher',
  ep_admin_collection_Pin: 'Pin',
  ep_admin_collection_Edit_Collection: 'Edit Collection',
  ep_admin_collection_Add_Collection: 'Add Collection',
  ep_admin_collection_Basic_Information: 'Basic Information',
  ep_admin_collection_Content: 'Content',
  ep_admin_collection_Title: 'Title',
  ep_admin_collection_Country_Region: 'Country/Region',
  ep_admin_collection_In_site_Video: 'In-site Video',
  ep_admin_collection_Add_Cotents: 'Add Cotents',
  ep_admin_collection_Content_ID_Content_Title: 'Content ID/Content Title',
  ep_admin_collection_Content_Limit_100: 'Add up to 100 content',
  ep_admin_collection_pin_tip: 'Are you sure to pin this collection？There is a pined collection already.',
  ep_admin_collection_delete_tip: 'Are you sure to delete this collection',
  ep_admin_region_Explore_Hot_Topic_Switch: 'Hot Topic Switch',
  ep_admin_region_Explore_Hot_Topic_Switch_tip: 'When the switch is turned n，App displays the hot topic module',
  ep_admin_region_Explore_Category_Entrance: 'Category Entrance',
  ep_admin_region_Explore_Category_Entrance_tip: 'Up to 4 categories can be selected',
  ep_admin_region_Explore_Category_Entrance_select_tip: "Category Entrance can't be less than 4",
  ep_admin_region_Explore_Hot_Topic_Source: "Hot Topic Source",
  ep_admin_region_Explore_Hot_Topic_Source_tip: "Automatically：App displays the most viewed content in the last 7 days；Manually：Operators manually configure titles and links；",
  ep_admin_region_Explore_Hot_Topic_Count: "Hot Topic Count",
  ep_admin_region_Explore_Hot_Topic_Count_tip: "The number of hot topics displayed on App",
  ep_admin_region_Explore_Topic_Name: "Topic Name {sort}",
  ep_admin_region_Explore_Topic_Link: "Topic Link {sort}",
  ep_admin_ranking_Company_Short_ID: 'Company Short ID',

  ep_admin_gift_title: 'Gift Configure',
  ep_admin_gift_notification: 'Approver Notification',
  ep_admin_gift_approver: 'Gift Approver',
  ep_admin_gift_manager: '3PL Manager',
  ep_admin_gift_ship_by: 'Ship by Hikvision ERP (SAP)',
  ep_admin_gift_sap_gift: 'SAP Configure',
  ep_admin_gift_3rd: 'Ship by 3rd Party:',
  ep_admin_gift_local_cur: 'Gift Local Currency:',
  ep_admin_gift_none: 'None',
  ep_admin_gift_YOUGotaGift: 'YOUGotaGift',
  ep_admin_gift_SofTecki: 'SofTecki',
  ep_admin_gift_PhoneTopup: 'Phone Top-up(No integration)',
  ep_admin_gift_Credofaster: 'Credofaster',
  ep_admin_gift_OmniVAS: 'OmniVAS',

  ep_admin_gift_YOUGotaGift_BrandID: 'Brand(Gift) ID',
  ep_admin_gift_YOUGotaGift_BrandCode: 'Brand Code',
  ep_admin_gift_YOUGotaGift_BrandName: 'Brand Name',
  ep_admin_gift_YOUGotaGift_ProductImage: 'Product Image',
  ep_admin_gift_YOUGotaGift_Description: 'Description',
  ep_admin_gift_YOUGotaGift_RedemptionType: 'Redemption Type',
  ep_admin_gift_YOUGotaGift_brandLogo: 'Brand Logo',
  ep_admin_gift_YOUGotaGift_Category: 'Category',
  ep_admin_gift_YOUGotaGift_ValidityinMonths: 'Validity in Months',
  ep_admin_gift_YOUGotaGift_SelectandContinue: 'Select and Continue',
  ep_admin_gift_YOUGotaGift_IntegrationAmount: 'Integration Amount',
  ep_admin_gift_YOUGotaGift_IntegrationAmount_des: "This amount is for one gift and will be sent to 3rd party gift platform.Due to safefty, the max number limit to 1500.",
  ep_admin_gift_SofTeckiCredofaster_IntegrationAmount_des: "This amount is for one gift and will besent to 3rd party gift platform.",
  ep_admin_gift_YOUGotaGift_Currency: 'Currency',
  ep_admin_gift_YOUGotaGift_desc1: 'This amount will be sent to 3rd party gift platform',
  ep_admin_gift_YOUGotaGift_desc2: 'Please input amount between',
  ep_admin_smb_link_add_title: 'Added {num} item(s)',
  ep_admin_smb_link_notadd_title: 'Not added {num} item(s)',
  ep_admin_smb_link_add_tip: 'Click here and place the link on the image.',
  ep_admin_smb_link_max_tip: 'The total number of links cannot exceed 6.',
  ep_admin_smb_link_clearall: 'Clear All',
  ep_admin_event_customer_selection_Conditional_filtering: "Conditional filtering",
  ep_admin_event_customer_selection_Conditional_filtering_tip: "When there are multiple filters,the customer range will be the intersection of the selected filters. But if you don' t select non-required filter such as Company Authorization Date, system will skip this filter.",
  ep_admin_event_customer_selection_OneHikID_filtering: "OneHikID filtering",
  ep_admin_event_customer_selection_Tag_Filtering: "Tag Filtering",
  ep_admin_event_customer_selection_Tag_Filtering_Company: "Company",
  ep_admin_event_customer_selection_Tag_Filtering_User: "User",
  ep_admin_event_Tag_Selection: "Tag Selection",
  ep_admin_event_customer_selection_Tag_Filtering_tip: "Target company/user list from ibc-itags platform has a 1-day delay. The data will be synchronized for 5-10 mins after completing the current step.",
  ep_admin_event_Total_Number: "Total Number",
  ep_admin_event_Sync_Status: "Sync Status",
  ep_admin_event_Preview_List: "Preview List",
  ep_admin_tag_tag_sync_status_Not_Start: "Not Start",
  ep_admin_tag_tag_sync_status_Synchronizing: "Synchronizing",
  ep_admin_tag_tag_sync_status_Synchronizing_tip: "Synchronizing from ibc-itag platform, it may take approximately 5 to 10 minutes, please come back later to publish the event",
  ep_admin_tag_tag_sync_status_Success: "Synchronized",
  ep_admin_tag_tag_sync_status_Fail: "Sync Failed",
  ep_admin_tag_itag_sync_status: "itag sync status",
  ep_admin_tag_customer_oneHikid: "oneHikid",
  ep_admin_tag_sync_Retry: "Retry",
  ep_admin_tag_filtering_failed: "Target count= 0 , please reselect tags",
  ep_admin_eCoupons_tag_sync_tip: 'If you need to preview company list, please save first. Once submit, the ecoupons can be claimed by the company list you have selected once synchronized.',
  ep_admin_tag_itag_sync_status_tip: 'Synchronizing from ibc-itag platform, will only be effective after synchronization completes.',
  ep_admin_message_title: 'Main Title',
  ep_admin_message_msgStatus: 'Meassage Status',
  ep_admin_message_msgType: 'Meassage Type',
  ep_admin_message_status: 'Status',
  ep_admin_message_status_Saved: 'Saved',
  ep_admin_message_status_Published: 'Published',
  ep_admin_message_status_Failed: 'Failed',
  ep_admin_message_status_To_be_Approved: 'To be Approved',
  ep_admin_message_status_Rejected: 'Rejected',
  ep_admin_message_status_Deleted: 'Deleted',
  ep_admin_message_Meassage_Id: 'Meassage ID',
  ep_admin_message_Type: 'Type',
  ep_admin_message_Type_System: 'System',
  ep_admin_message_Type_Activity: 'Activity',
  ep_admin_message_Picture: 'Picture',
  ep_admin_message_Title: 'Title',
  ep_admin_message_User_Type: 'User Type',
  ep_admin_message_Push: 'Push',
  ep_admin_message_Recall_tip_title: 'Are you sure to recall this notification？',
  ep_admin_message_Recall_tip_content: 'After recall，customers will not be able to see this notification in Notification Center anymore.',
  ep_admin_message_Add_Notification: 'Add Notification',
  ep_admin_message_Edit_Notification: 'Edit Notification',
  ep_admin_message_Clone_Notification: 'Clone Notification',
  ep_admin_message_Notification_Detail: 'Notification Detail',
  ep_admin_message_Publish_To: 'Publish To',
  ep_admin_message_Description: 'Description',
  ep_admin_message_Portal_Picture: 'Portal Picture',
  ep_admin_message_App_Picture: 'App Picture',
  ep_admin_message_Picture_upload_tip: 'The size of the picture is not appropriate.',
  ep_admin_region_Explore_HiEvent_Sync_Event: 'HiEvent sync Event',
  ep_admin_region_Explore_HiEvent_Sync_Event_tip: 'After turning on the switch, HiEvent will be created as an event in HPP automatically',
  ep_admin_event_Source: 'Source',
  ep_admin_event_Source_Type_HPP: 'HPP',
  ep_admin_event_Source_Type_eLearning: 'eLearning',
  ep_admin_event_Source_Type_HiEvent: 'HiEvent',
  ep_admin_category_Brand: 'Brand',
  ep_admin_category_Category: 'Category',
  ep_admin_category_Product_Line: 'Product Line',
  ep_admin_category_Series: 'Series',
  ep_admin_category_Offering: 'Offering',
  ep_admin_region_ME_Sort: 'Choose data metrics which displayed on the HPP App client ME page,and drag to sort.',
  ep_admin_notice_Web_Notice: 'Web Notice',
  ep_admin_notice_App_Notice: 'App Notice',
  ep_admin_notice_Top_Status: 'Top Status',
  ep_admin_notice_Top_Status_TOP: 'TOP',
  ep_admin_notice_Top_Status_NO_TOP: 'NO TOP',
  ep_admin_notice_Date_Range: 'Date Range',
  ep_admin_notice_Title: 'Title',
  ep_admin_notice_Jump_Notice: 'Jump Notice',
  ep_admin_notice_Jump_Notice_YES: 'YES',
  ep_admin_notice_Jump_Notice_NO: 'NO',
  ep_admin_notice_Notice_Id: 'Notice Id',
  ep_admin_notice_Summary: 'Summary',
  ep_admin_notice_Sequence: 'Sequence',
  ep_admin_notice_Start_Date: 'Start Date',
  ep_admin_notice_End_Date: 'End Date',
  ep_admin_notice_Notice_Type: 'Notice Type',
  ep_admin_notice_Notice_Type_News: 'News',
  ep_admin_notice_Notice_Type_Product_announcement: 'Product announcement',
  ep_admin_notice_Notice_Type_Promotion_announcement: 'Promotion announcement',
  ep_admin_notice_Notice_Country: 'Notice Country',
  ep_admin_notice_Push_Email: 'Push Email',
  ep_admin_notice_Add_APP_Notice: 'Add APP Notice',
  ep_admin_notice_Edit_APP_Notice: 'Edit APP Notice',
  ep_admin_notice_Main_Title: 'Main Title',
  ep_admin_notice_Description: 'Description',
  ep_admin_notice_Notice_Time: 'Notice Time',
  ep_admin_notice_Button_Text: 'Button Text',
  ep_admin_notice_Link_Type: 'Link Type',
  ep_admin_notice_Link_ID: 'Link ID',
  ep_admin_notice_APP_Url: 'APP Url',
  ep_admin_notice_Region_Country: 'Region/Country',
  ep_admin_designer_edit_product: "Edit Product",
  ep_admin_designer_detail_product: "Detail Product",
  ep_admin_designer_cctv_product_data_governance: 'CCTV Product Data Governance',
  ep_admin_designer_product_category: 'Product Category',
  ep_admin_designer_model_number: 'Model Number',
  ep_admin_designer_product_id: 'Product ID',
  ep_admin_designer_model: 'Model',
  ep_admin_designer_model_code: 'Model Code',
  ep_admin_designer_case_type: 'Case Type',
  ep_admin_designer_available_material: 'Available Material',
  ep_admin_designer_network_analog: 'Network/Analog',
  ep_admin_designer_channels: 'Channels',
  ep_admin_designer_supplement_light_type: 'Supplement Light Type',
  ep_admin_designer_video_compression: 'Video Compression(Main)',
  ep_admin_designer_supplement_light_range: 'Supplement Light Range',
  ep_admin_power_supply: 'Power Supply',
  ep_admin_designer_power: 'Power',
  ep_admin_designer_frame_rate: 'Frame Rate(Main)',
  ep_admin_designer_creation_time: 'Creation Time',
  ep_admin_designer_update_time: 'Update Time',
  ep_admin_designer_channel_no: 'Channel No.',
  ep_admin_designer_lens_type: 'Lens Type',
  ep_admin_designer_resolution: 'Resolution',
  ep_admin_designer_horizontal_resolution: 'Horizontal Resolution',
  ep_admin_designer_vertical_resolution: 'Vertical Resolution',
  ep_admin_designer_image_sensor: 'Image Sensor',
  ep_admin_designer_pixel_size: 'Pixel Size(μm)',
  ep_admin_designer_focal_length: 'Focal Length',
  ep_admin_designer_HFOV: 'HFOV',
  ep_admin_designer_VFOV: 'VFOV',
  ep_admin_designer_DFOV: 'DFOV',
  ep_admin_designer_D: 'D(m)',
  ep_admin_designer_O: 'O(m)',
  ep_admin_designer_R: 'R(m)',
  ep_admin_designer_I: 'I(m)',
  ep_admin_designer_min_focal_length: 'Min Focal Length',
  ep_admin_designer_max_focal_length: 'Max Focal Length',
  ep_admin_designer_min_HFOV: 'Min HFOV',
  ep_admin_designer_max_HFOV: 'Max HFOV',
  ep_admin_designer_min_VFOV: 'Min VFOV',
  ep_admin_designer_max_VFOV: 'Max VFOV',
  ep_admin_designer_min_DFOV: 'Min DFOV',
  ep_admin_designer_max_DFOV: 'Max DFOV',
  ep_admin_designer_min_D: 'Min D(m)',
  ep_admin_designer_max_D: 'Max D(m)',
  ep_admin_designer_min_O: 'Min O(m)',
  ep_admin_designer_max_O: 'Max O(m)',
  ep_admin_designer_min_R: 'Min R(m)',
  ep_admin_designer_max_R: 'Max R(m)',
  ep_admin_designer_min_I: 'Min I(m)',
  ep_admin_designer_max_I: 'Max I(m)',
  ep_admin_designer_key_word: 'Key Word',
  ep_admin_designer_add_product: 'Add Product',
  ep_admin_designer_upload: 'Upload',
  ep_admin_designer_detail: 'Detail',
  ep_admin_designer_keyword: 'key Word',
  ep_admin_designer_material: 'Material',
  ep_admin_designer_wall_name: 'Wall Name',
  ep_admin_designer_description: 'Description',
  ep_admin_designer_thickness: 'Thickness(mm)',
  ep_admin_designer_2_4ghz: '2.4GHz(dB)',
  ep_admin_designer_5ghz: '5GHz(dB)',
  ep_admin_designer_433mhz: '433MHz(dB)',
  ep_admin_designer_868mhz: '868MHz(dB)',
  ep_admin_designer_add_wall: 'Add Wall',
  ep_admin_designer_wall_overview: 'Wall Overview',
  ep_admin_designer_Thickness: 'Thickness',
  ep_admin_designer_the_recommended_attenuation_factors_for_24_GHz_5_GHz_and_6_GHz_are_5_10_and_respectively: 'The recommended attenuation factors for 2.4 GHz, 5 GHz, and 6 GHz are 5, 10, and12, respectively.',
  ep_admin_designer_with_camera_or_not: 'With camera or not',
  ep_admin_designer_detection_target_type: 'Detection Target Type',
  ep_admin_designer_horizontal_detection_angle: 'Horizontal Detection Angle（°）',
  ep_admin_designer_vertical_detection_angle: 'Vertical Detection Angle（°）',
  ep_admin_designer_detection_distance_vehicle: 'Detection Distance-Vehicle(m)',
  ep_admin_designer_detection_distance_Human: 'Detection Distance-Human(m)',
  ep_admin_designer_detection_distance_ship: 'Detection Distance-Ship(m)',
  ep_admin_designer_distance_resolution: 'Distance Resolution(m)',
  ep_admin_designer_angle_resolution: 'Angle Resolution（°）',
  ep_admin_designer_speed_resolution: 'Speed Resolution(m/s)',
  ep_admin_designer_horizontal_detection_angle_wide_beam: "Horizontal Detection Angle(Wide beam)",
  ep_admin_designer_detection_distance_wide_beam: "detectionDistance(Wide beam)",

  attenuation_Factor_at_24_GHz: 'Attenuation Factor at 2.4 GHz',
  attenuation_Factor_at_5_GHz: 'Attenuation Factor at 5 GHz',
  attenuation_Factor_at_433_MHz: 'Attenuation Factor at 433 MHz',
  attenuation_Factor_at_868_MHz: 'Attenuation Factor at 868 MHz',
  ep_admin_message_Portal_Url: 'Portal Url',
  ep_admin_message_End_Time: 'End Time',
  ep_admin_message_tag_sync_status_Synchronizing_tip: "Synchronizing from ibc-itag platform, it may take approximately 5 to 10 minutes, can only publish when status turns Synchronized (you need to refresh the page)",
  ep_admin_explore_Vote: 'Vote',
  ep_admin_explore_Vote_tip: 'After turning on the switch and filling in the corresponding fields, customers can click on the option to participate in the voting in the content details. When setting up a binary voting, the option content should not exceed 15 characters.',
  ep_admin_explore_option: 'Option',
  ep_admin_explore_votetime: 'Vote Time',
  ep_admin_explore_OneHikID: 'OneHikID',
  ep_admin_explore_epid: 'EP Company ID',
  ep_admin_explore_companyid: 'Company Short ID',
  ep_admin_explore_VoteResult: 'Vote Result',
  ep_admin_explore_VoteQuestion: 'Voting Question',
  ep_admin_explore_OptionType: 'Option Type',
  ep_admin_explore_VotersNumber: 'Voters Number',
  ep_admin_explore_Email: 'Email',
  ep_admin_designer_installer_company_name: "Installer Company Name",
  ep_admin_designer_installer_contact_name: "Installer Contact Name",
  ep_admin_designer_end_user_customer_name: "EndUser Customer Name",
  ep_admin_designer_is_designed_by_designer: "Is Designed by Designer",
  ep_admin_designer_created_from: "Created From",
  ep_admin_designer_b2b_shopping_cart: "B2B Shopping Cart",
  ep_admin_designer_smb_solution: "SMB Solution",
  ep_admin_designer_is_designed: "Is Designed",
  ep_admin_designer_created_from_source: "Created From Source",
  ep_admin_designer_installer_email: "Installer Email",
  ep_admin_designer_end_user_name: "End User Name",
  ep_admin_designer_feedback_time: "Feedback Time",
  ep_admin_designer_feedback_category: "Feedback Category",
  ep_admin_designer_user_feedback_details: "Feedback Detail",

  ep_admin_explore_translate: 'Translate',
  ep_admin_explore_translating: 'Translating',
  ep_admin_explore_search_language: 'Search language',
  ep_admin_explore_translate_status: 'Translate Status',
  ep_admin_explore_translate_ID: 'ID',
  ep_admin_explore_translate_Language: 'Language',
  ep_admin_explore_translate_TranslateStatus: 'Translate Status',
  ep_admin_explore_translate_Creationdate: 'Creation date',
  ep_admin_explore_translate_HiTranslatorAddress: 'HiTranslator address',
  ep_admin_designer_working_frequency_band: "Working Frequency Band",
  ep_admin_designer_installation_mode: "Installation Mode",
  ep_admin_designer_2_4_G_transmit_power_dBm: "2.4G Transmit Power(dBm)",
  ep_admin_designer_5_G_transmit_power_dBm: "5G Transmit Power(dBm)",
  ep_admin_designer_6_G_transmit_power_dBm: "6G Transmit Power(dBm)",
  ep_admin_designer_2_4_G_antenna_gain_dBi: "2.4G Antenna Gain(dBi)",
  ep_admin_designer_5_G_antenna_gain_dBi: "5G Antenna Gain(dBi)",
  ep_admin_designer_6_G_antenna_gain_dBi: "6G Antenna Gain(dBi)",
  ep_admin_designer_2_4_G_cable_and_connector_loss_dB: "2.4G Cable and connector loss(dB)",
  ep_admin_designer_5_G_cable_and_connector_loss_dB: "5G Cable and connector loss(dB)",
  ep_admin_designer_6_G_cable_and_connector_loss_dB: "6G Cable and connector loss(dB)",
  ep_admin_designer_interface_type: "Interface Type",
  ep_admin_designer_interface_number: "Interface Number",
  ep_admin_designer_uplink_interface_type: "Uplink Interface Type",
  ep_admin_designer_uplink_interface_number: "Uplink Interface Number",
  ep_admin_designer_signalLoss_type: "signalLossType",
  ep_admin_designer_signalLoss_param: "signalLossParam",
  ep_admin_designer_product_category_governance: "Product category governance",
  ep_admin_designer_question_id: 'Question ID',
  ep_admin_designer_paired_mode: "Paired Mode",
  ep_admin_designer_transmission_distance: "Transmission distance",
  ep_admin_designer_networking_mode: "Networking Mode",
  ep_admin_designer_channel_width: "Channel Width",
  ep_admin_designer_device_capacity: "Device Capacity",
  ep_admin_designer_transmitting_power: "Transmitting Power",
  ep_admin_designer_antenna_gain: "Antenna Gain",
  ep_admin_designer_horizontal_antenna_angle: "Horizontal Antenna Angle",
  ep_admin_designer_vertical_antenna_angle: "Vertical Antenna Angle",
  ep_admin_designer_receiving_sensitivity: "Receiving Sensitivity",
  ep_admin_designer_network_interface_type: "Network Interface Type",
  ep_admin_designer_network_interface_number: "Network Interface Number",

  ep_admin_sn_number: 'Serial Number',
  ep_admin_sn_material_code: 'Material Code',
  ep_admin_sn_is_hikvision: 'Is Hikvision',
  ep_admin_sn_owning_company_name: 'Owning Company Name',
  ep_admin_sn_owning_company_OneHikId: 'Owning Company One Hik Id',
  ep_admin_sn_OwningCompanyType: 'Owning Company Type',
  ep_admin_sn_CountryName: 'Country',
  ep_admin_sn_LastTransactionTime: 'Last Transaction Time',
  ep_admin_sn_operatorType: 'Operator Type',
  ep_admin_sn_operationType: 'Operation Type',
  ep_admin_sn_documentType: 'Document Type',
  ep_admin_sn_documentNo: 'Document Number',
  ep_admin_sn_SendingCompanyName: 'Sending Company Name',
  ep_admin_sn_SendingCompanyOneHikId: 'Sending Company One Hik Id',
  ep_admin_sn_SendingCompanyType: 'Sending Company Type',
  ep_admin_sn_ReceivingCompanyName: 'Receiving Company Name',
  ep_admin_sn_ReceivingCompanyOneHikId: 'Receiving Company One Hik Id',
  ep_admin_sn_ReceivingCompanyType: 'Receiving Company Type',
  ep_admin_sn_TransactionTime: 'Transaction Time',
  ep_admin_designer_the_recommended_attenuation_factors_for_respectively: "The recommended attenuation factors for 2.4 GHz, 5 GHz, and 6 GHz are 5, 10, and12, respectively.",
  ep_admin_dpp_to_be_docusign: 'Awaiting signature',
  ep_admin_dpp_to_be_select_nd: 'Select Supplier',
  ep_admin_user_scan_for_inbound: "Scan for Inbound",
  ep_admin_user_scan_for_inbound_tips: '渠道扫码权限如DPP入库扫码，非积分扫码',
  ep_admin_channel_price_id: 'Price ID',
  ep_admin_channel_DPP_purchase_price: 'DPP Purchase Price',
  ep_admin_channel_DPP_selling_price: 'DPP Selling Price',
  ep_admin_channel_log_title: 'DPP Purchase Price Change Log',
  ep_admin_channel_import: 'Import',
  ep_admin_channel_inbound_scan_history: 'Inbound Scan History',
  ep_admin_channel_distributor_id: 'Distributor SAP ID',
  ep_admin_channel_batch_maintain_price: "Batch Maintain Price",
  ep_admin_channel_scan_type: 'Scan Type',
  ep_admin_channel_allow_Shipping_Country: 'Allow Shipping from Country',
  ep_admin_channel_price_email: 'Price Maint. Notification Email',
  ep_admin_channel_claim_email: 'Claim Approval Notification Email',
  ep_admin_channel_allow_shipping_tips: 'The countries maintained here will not be judged as bugsell. Please maintain two digital country code, for example, CN. If there are multiple countries, please separate them with a comma.',
  ep_admin_channel_no_price_warning: 'No Price Warning ({num})',
  ep_admin_channel_no_price: 'No Price',
  ep_admin_channel_price_sync: 'Price Sync',
  ep_admin_channel_no_price_tips: 'Please add the price for scan items without price below. You can also click "Price Sync" button to update the price if you already maintained the price master data.',
  ep_admin_channel_distributor_company_name: 'Distributor Company Name',
  ep_admin_channel_add_price: 'Add Price',
  ep_admin_channel_appeov_or_reject: 'Approve/Reject',
  ep_admin_channel_deactivate_only: 'Deactivate Only',
  ep_admin_channel_fake_and_deactivate: 'Fake and Deactivate',
  ep_admin_channel_shipment_date: 'Shipment Date',
  ep_admin_channel_screenshot_status: 'Screenshot Status',
  ep_admin_channel_scan_local_date: 'Scan Local Date',
  ep_admin_shipManage_wenhao: 'This is used for daily shipment management, approving or rejecting. In some cases, if Shipment fails, you need to click Ship, or Reject to refund the points to the customer.',
  ep_admin_explore_linkName: 'Link Name',
  ep_admin_explore_linkURL: 'Link URL',
  ep_admin_home_copySuccess: 'Copy Success',
  ep_admin_designer_Feedback_ID: "Feedback ID",
  ep_admin_designer_Image: "Image",
  ep_admin_designer_Feedback_Info: "Feedback Info",
  ep_admin_designer_User_Name: "User Name",
  ep_admin_designer_User_Email: "User Email",
  ep_admin_designer_Status: "Status",
  ep_admin_designer_Creation_Time: "Creation Time",
  ep_admin_designer_Latest_Reply: "Latest Reply",
  ep_admin_designer_Bu: "Bu",
  ep_admin_designer_Subbu: "Subbu",
  ep_admin_designer_Country: "Country",
  ep_admin_designer_companyName: "Company Name",
  ep_admin_designer_creationTime: "Creation Time",
  ep_admin_designer_Feedback_Information: "Feedback Information",
  ep_admin_designer_Category: "Category",
  ep_admin_designer_Module: "Module",
  ep_admin_designer_Send: "Send",
  ep_admin_designer_Close_Feedback: "Close Feedback",
  ep_admin_designer_Reply_Time: "Reply Time",
  ep_admin_designer_Paired_P2P: "Paired P2P",
  ep_admin_designer_Priority: "Priority",
  ep_admin_designer_Paired_P2MP: "Paired P2MP",

  ep_admin_designer_ip_channel_number: "IP Channel Number",
  ep_admin_designer_sync_status_Success: "Synchronized",
  ep_admin_designer_after_deletion_wall_type: "After deletion, all applied walls will be changed to the common wall type. Are you sure you want to delete the {0} wall type",
  incoming_Bandwidth: "Incoming Bandwidth",
  incoming_Bandwidth_RAID_Mode: "Incoming Bandwidth (RAID Mode)",
  sata: "SATA",
  esata: "eSATA",
  maximum_capacity_per_disk: "Maximum capacity per disk",
  decoding_capability: "Decoding Capability",
  recording_resolution: "Recording Resolution",
  maximum_recording_resolution: "Maximum Recording Resolution",
  poe_number: "POE Number",
  paid_type: "RAID Type",
  analog_video_input: "Analog video input",
  ip_video_input: "IP video input",
  input_resolution: "Input Resolution",
  maximum_input_resolution: "Maximum Input Resolution",
  industrial_non_industrial: "Industrial/Non-industrial",
  switch_type: "Switch Type",
  switching_capacity: "Switching Capacity",
  installation_mode: "Installation Mode",
  poe_switch: "POE Switch",
  poe_standard: "POE Standard",
  total_number_of_rj45_ports: "Total Number of RJ45 Ports",
  total_number_of_optical_ports: "Total Number of optical Ports",
  number_of_1ge_sef_ports: "Number of 1GE  SFP  Ports",
  number_of_10ge_sep_ports: "Number of 10GE  SFP+ Ports",
  number_of_10_100_1000base_t_ports: "Number of 10,100,1000BASE-T  Ports",
  number_of_poe_poe_ports: "Number of POE/POE+ Ports",
  power_supply: "Power Supply",
  power_consumption: "Power Consumption",
  ep_admin_batch_gift: 'Batch Ship 3rd Party integrated Gift',
  ep_admin_ygift_info8: '4 Items failed, please check details by filterring the status of "Failed"',
  ep_admin_designer_Intelligent_Parameters: 'Intelligent Parameters',
  ep_admin_designer_coverage360: '360° Coverage',
  ep_admin_designer_preset: 'Preset',
  ep_admin_designer_Model_Id: 'Model ID',
  ep_admin_designer_Sensor_Width: 'Sensor Width',
  ep_admin_designer_Sensor_Length: 'Sensor Length',
  ep_admin_designer_Min_Shooting_Distance: 'Min Shooting Distance(m)',
  ep_admin_designer_Visible_Light_Resolution: 'Visible Light Resolution',
  ep_admin_designer_Visible_Light_Min_Focal_Length: 'Visible Light Min Focal Length',
  ep_admin_designer_Visible_Light_Max_Focal_Length: 'Visible Light Max Focal Length',
  ep_admin_designer_VCA_Min_Pixel_Number: "VCA Min Pixel Number",
  ep_admin_designer_VCA_Maxi_Distance_Coefficient: "VCA Maxi Distance Coefficient",
  ep_admin_designer_Fire_Detection: "Fire Detection",
  ep_admin_designer_Fire_Detection_Min_Pixel_Count: "Fire Detection Min Pixel Count",
  ep_admin_designer_Fire_Detection_Visible_Light_Min_Pixel_Count: "Fire Detection Visible Light Min Pixel Count",
  ep_admin_designer_Smoke_Detection_Min_Pixel_Count: "Smoke Detection Min Pixel Count",
  ep_admin_designer_Smoke_Detection_Default_Target_Size: "Smoke Detection Default Target Size",
  ep_admin_designer_Visible_Light_Max_Horizontal_FOV: "Visible Light Max Horizontal FOV",
  ep_admin_designer_Visible_Light_Min_Horizontal_FOV: "Visible Light Min Horizontal FOV",
  ep_admin_designer_Visible_Light_Max_Vertical_FOV: "Visible Light Max Vertical FOV",
  ep_admin_designer_Visible_Light_Min_Vertical_FOV: "Visible Light Min Vertical FOV",
  ep_admin_designer_Quote: "Quote",
  ep_admin_product_Maximum_of_5_images_allowed: "Maximum of 5 images allowed.",
  ep_admin_product_quotation_list: "Quotation List",
  ep_admin_product_Export_Center: "Export Center",
  ep_admin_product_Select_Quote_Template: "Select Quote Template",
  ep_admin_product_PDF: "PDF",
  ep_admin_product_Excel: "Excel",
  ep_admin_product_Picture: "Picture",
  ep_admin_product_Word: "Word",
  ep_admin_product_Product_Pictures: "Product Pictures",
  ep_admin_product_Product_Model_Name: "Product Model Name",
  ep_admin_product_Product_Parameters: "Product Parameters",
  ep_admin_product_Front_and_Back_Covers: "Cover and Back Cover",
  ep_admin_product_Custom_Options: "Custom Options",
  ep_admin_product_status_Processing: "Processing",
  ep_admin_product_status_Succeed: "Succeed",
  ep_admin_product_status_Failed: "Failed",
  ep_admin_designer_DORI: 'DORI (m)',
  ep_admin_designer_product_tip: 'This material is already bound to other specifications. Please confirm if rebinding is required.',

  // Customer Data Governance
  'menu.userManage.customerDataGovernance': 'Customer Data Governance',
  ep_admin_cdg_duplicate_processing: 'Duplicate Processing',
  ep_admin_cdg_company_keyword: 'Company Key Word',
  ep_admin_cdg_bu: 'BU',
  ep_admin_cdg_sub_bu: 'Sub BU',
  ep_admin_cdg_country: 'Country',
  ep_admin_cdg_state: 'State',
  ep_admin_cdg_company_type: 'Company Type',
  ep_admin_cdg_is_authorized: 'Is Authorized',
  ep_admin_cdg_search: 'Search',
  ep_admin_cdg_reset: 'Reset',
  ep_admin_cdg_export: 'Export',
  ep_admin_cdg_company_id: 'Company ID',
  ep_admin_cdg_company_name: 'Company Name',
  ep_admin_cdg_sap_id: 'SAP ID',
  ep_admin_cdg_crm_account_id: 'CRM Account ID',
  ep_admin_cdg_authorized_status: 'Authorized Status',
  ep_admin_cdg_merge: 'Merge',
  ep_admin_cdg_ignore: 'Ignore',
  ep_admin_cdg_select_company: 'Select Company',
  ep_admin_cdg_merge_selected: 'Merge Selected',
  ep_admin_cdg_no_data: 'No Data',

  ep_admin_cdg_integration: 'Integration',
  ep_admin_cdg_processed: 'Processed',
  ep_admin_cdg_active_status: 'Active Status',
  ep_admin_cdg_tax_id: 'Tax ID',
  ep_admin_cdg_btn_mark_primary_merge: 'Merge Accounts',
  ep_admin_cdg_tooltip_mark_primary_merge: 'This will initiate Client account merge. Merge records can be found in Company Combination',
  ep_admin_cdg_btn_mark_primary_update_crm: 'Merge CRM ID',
  ep_admin_cdg_tooltip_mark_primary_update_crm: 'The CRM account id of selected companies (if have), will be updated to primary and sync to eSales',
  ep_admin_cdg_btn_mark_unduplicate: 'Mark as unduplicate',
  ep_admin_cdg_tooltip_mark_unduplicate: 'Selected companies will be removed from the group and mark as unduplicate',

  // Duplicate Processing Confirmations
  ep_admin_cdg_confirm_merge_accounts_title: 'Confirm Merge Accounts',
  ep_admin_cdg_confirm_merge_accounts_content: 'This will initiate Client account merge. Merge records can be found in Company combination.',
  ep_admin_cdg_confirm_merge_crm_title: 'Confirm Merge CRM ID',
  ep_admin_cdg_confirm_merge_crm_content: 'The CRM account id of selected companies (if have), will be updated to primary and sync to eSales',
  ep_admin_cdg_confirm_mark_unduplicate_title: 'Confirm Mark as Unduplicate',
  ep_admin_cdg_confirm_mark_unduplicate_content: 'Selected companies will be removed from the group and mark as unduplicate',
  ep_admin_cdg_unduplicate_success: 'Marked as unduplicate successfully',
  ep_admin_cdg_confirm_detach_title: 'Confirm Detach Company',
  ep_admin_cdg_confirm_detach_content: 'Are you sure you want to detach "{companyName}" from the group?',
  ep_admin_cdg_load_company_list_failed: 'Failed to load company list',
  ep_admin_cdg_load_data_failed: 'Failed to load data',
  ep_admin_cdg_merge_failed: 'Merge failed',
  ep_admin_cdg_update_crm_failed: 'Update CRM Account ID failed',
  ep_admin_cdg_mark_unduplicate_failed: 'Mark as unduplicate failed',
  ep_admin_cdg_detach_failed: 'Detach company failed',
  ep_admin_cdg_merge_success: 'Merge success',
  ep_admin_cdg_update_crm_success: 'Update CRM Account ID success',
  ep_admin_cdg_detach_success: 'Detach company success',



  ep_admin_cdg_group_id: 'Group ID',
  ep_admin_cdg_hpc_company_id: 'HPC Company ID (short)',
  ep_admin_cdg_ep_company_id: 'EP Company ID',
  ep_admin_cdg_city: 'City',
  ep_admin_cdg_address: 'Address',
  ep_admin_cdg_user_number: 'User Number',
  ep_admin_cdg_company_email: 'Company Email',
  ep_admin_cdg_company_phone: 'Company phone',
  ep_admin_cdg_device_no: 'Device No.',
  ep_admin_cdg_available_points: 'Available points',
  ep_admin_cdg_value_added_services: 'Value Added Services Purchased',
  ep_admin_cdg_hc_account: 'HC account',
  ep_admin_cdg_hpp_level: 'HPP level',
  ep_admin_cdg_partner_program_signed: 'Partner Program signed',
  ep_admin_cdg_hpp_project_no: 'HPP Project No.',
  ep_admin_cdg_last_login_time: 'Last Login Time',
  ep_admin_cdg_creation_time: 'Creation Time',
  ep_admin_cdg_merge_status: 'Merge Status',
  ep_admin_cdg_merge_status_merge: 'Merge',
  ep_admin_cdg_merge_status_multiple: 'Multiple',
  ep_admin_cdg_btn_detach: 'Detach',
  ep_admin_cdg_btn_log: 'Log',
  ep_admin_cdg_log_title: 'Log',
  ep_admin_cdg_primary: 'Primary',

  // Column Config
  ep_admin_cdg_column_config: 'Column Config',
  ep_admin_cdg_show: 'Show',
  ep_admin_cdg_hide: 'Hide',
  ep_admin_cdg_search_placeholder: 'Search columns',
  ep_admin_cdg_company_list: 'Company List',
  ep_admin_cdg_company_column_config: 'Company List Column Config',

  // Log Modal
  ep_admin_cdg_log_action: 'Action',
  ep_admin_cdg_log_user: 'User',
  ep_admin_cdg_log_date: 'Date',
  ep_admin_cdg_log_operator: 'Operator',

  // Freeze/Pre Freeze
  ep_admin_cdg_company_keyword_placeholder: 'Company ID/Company Name/Company Email/CRM account id/CRM Partner No./SAP ID',
  ep_admin_cdg_active_status_0: 'Active',
  ep_admin_cdg_active_status_1: 'Prefreeze',
  ep_admin_cdg_active_status_2: 'Manual freeze',
  ep_admin_cdg_active_status_3: 'System freeze',
  ep_admin_cdg_email_sent: 'Email Sent',
  ep_admin_cdg_appeal: 'Appeal',
  ep_admin_cdg_appeal_status_0: '-',
  ep_admin_cdg_appeal_status_1: 'New',
  ep_admin_cdg_appeal_status_2: 'Solved',
  ep_admin_cdg_appeal_status_3: 'Rejected',
  ep_admin_cdg_btn_unlock: 'Unlock',
  ep_admin_cdg_btn_lock: 'Lock',
  ep_admin_cdg_tooltip_unlock: 'Support batch unlock: Only applicable to records with Active status as Freeze',
  ep_admin_cdg_tooltip_lock: 'Support batch lock: Only applicable to records with Active status as Prefreeze or Active',
  ep_admin_cdg_latest_email_sent_time: 'Latest Email Sent Time',
  ep_admin_cdg_lock_reason_title: 'Lock Reason',
  ep_admin_cdg_lock_reason_label: 'Manual Lock Reason',
  ep_admin_cdg_lock_reason_placeholder: 'Please enter the manual lock reason',
  ep_admin_cdg_lock_reason_required: 'Please enter',
  ep_admin_cdg_tips_select_records: 'Please select the records to operate',
  ep_admin_cdg_tips_unlock_only_freeze: 'Only records with Active Status as Freeze can be unlocked',
  ep_admin_cdg_tips_lock_only_prefreeze_or_active: 'Only records with Active Status as Prefreeze or Active can be locked',
  ep_admin_cdg_unlock_success: 'Unlock successful',
  ep_admin_cdg_unlock_failed: 'Unlock failed',
  ep_admin_cdg_lock_success: 'Lock successful',
  ep_admin_cdg_lock_failed: 'Lock failed',

  // Company Log Modal
  ep_admin_cdg_company_log_title: 'Company Log',
  ep_admin_cdg_changed_type: 'Changed Type',
  ep_admin_cdg_changed_by: 'Changed By',
  ep_admin_cdg_changed_at: 'Changed At',
  ep_admin_cdg_details: 'Details',
  ep_admin_cdg_remark: 'Remark',

  // Appeal Modal
  ep_admin_cdg_appeal_detail_title: 'Appeal Detail',
  ep_admin_cdg_appeal_date: 'Appeal Date',
  ep_admin_cdg_contact_email: 'Contact Email',
  ep_admin_cdg_appeal_reason: 'Appeal Reason',
  ep_admin_cdg_latest_lock_reason: 'Latest Lock Reason',
  ep_admin_cdg_btn_appeal_detail: 'Appeal',
  ep_admin_cdg_btn_reject: 'Reject',
  ep_admin_cdg_appeal_unlock_success: 'Appeal unlocked successfully',
  ep_admin_cdg_appeal_reject_success: 'Appeal rejected successfully',
  ep_admin_cdg_btn_batch_upload: 'Batch Import',
  ep_admin_cdg_tooltip_batch_upload: 'Support lock or unlock companies in batch. The companies being locked by this way can only appeal to unlock.',
  ep_admin_cdg_download_template: 'Download Template',
  ep_admin_cdg_batch_upload_success: 'Batch upload successful',
  ep_admin_cdg_batch_upload_failed: 'Batch upload failed',

  // Detach Company Confirmation
  ep_admin_designer_Shape: "Shape",
  ep_admin_designer_Shape_ID: "Shape ID",
  ep_admin_explore_messageImage: 'Message Image',
  ep_admin_explore_upload: 'Upload',
  ep_admin_explore_imageTips: 'Ratio: 1080*540, File Size < 2M, Format: JPG、PNG',
  ep_admin_explore_imageFormatError: 'You can only upload JPG/PNG file!',
  ep_admin_explore_imageSizeError: 'Image must smaller than 2MB!',
  ep_admin_explore_imageRatioError: 'Image ratio must be 1080*540!',
  ep_admin_explore_uploadSuccess: 'Upload successfully!',
  ep_admin_explore_uploadError: 'Upload failed!',
  ep_admin_case_white_modal_not_found_companies: 'The following companies were not found:',
  ep_admin_case_white_modal_not_found_users: 'The following users were not found:',
  ep_admin_user_enable_qr_scan: "Enable QR Scan",
  ep_admin_user_enable_qr_scan_tips: '是否允许扫集成码',
  ep_admin_scan_Group_Id: 'Group Id',
  ep_admin_scanning_method: 'Scanning Method',
  ep_admin_scan_S_N: 'S/N',
  ep_admin_scan_QR_Code: 'QR Code',
  ep_admin_customer_dpp_set_signatories: 'Set Signatories',


  ep_admin_designer_device_type: "Device Type",
  ep_admin_designer_mounting_method: "Mounting Method",
  ep_admin_designer_function_description: "Function Description",
  ep_admin_designer_application_scenario: "Application Scenario",
  ep_admin_designer_rf_frequency: "RF Frequency",
  ep_admin_designer_transmit_power_R3: "Transmit Power(R3)",
  ep_admin_designer_transmit_power_Rx: "Transmit Power(Rx)",
  ep_admin_designer_receiver_gain: "Receiver Gain",
  ep_admin_designer_horizontal_field_of_view: "Horizontal Field of View",
  ep_admin_designer_vertical_field_of_view: "Vertical Field of View",
  ep_admin_designer_horizontal_pir_detection_angle: "Horizontal PIR Detection Angle",
  ep_admin_designer_vertical_pir_detection_angle: "Vertical PIR Detection Angle",
  ep_admin_designer_detection_range: "Detection Range",
  ep_admin_survey_average_score: 'Average Score',

  // Batch Change Country
  ep_admin_customer_batchChangeCountry_title: "Batch Change Country",
  ep_admin_customer_batchChangeCountry_updateSso: "Change User's country information in SSO",
  ep_admin_customer_batchChangeCountry_uploadWarning: "Please upload a file first",
  ep_admin_customer_batchChangeCountry_updateFailed: "Update failed",
  ep_admin_customer_company_twoFactorEnabled: 'Two-Factor Authentication',
  ep_admin_customer_company_twoFactorEnabled_enable: 'Enable Two-Factor Authentication',
  ep_admin_customer_company_twoFactorEnabled_disable: 'Disable Two-Factor Authentication',
  ep_admin_customer_company_twoFactorEnabled_confirm: 'Confirm {showStatus}?',


  // Automated Marketing
  ep_admin_automatedMarketing_campaignName: 'Campaign Name',
  ep_admin_automatedMarketing_description: 'Description',
  ep_admin_automatedMarketing_creator: 'Creator',
  ep_admin_automatedMarketing_status: 'Status',
  ep_admin_automatedMarketing_channels: 'Channels',
  ep_admin_automatedMarketing_benefits: 'Benefits',
  ep_admin_automatedMarketing_objective: 'Objective',
  ep_admin_automatedMarketing_pushTime: 'Push Time',

  // Campaign channels
  ep_admin_campaign_channels_email: 'Email',
  ep_admin_campaign_channels_message: 'Message',
  ep_admin_campaign_channels_appPush: 'App Push',
  ep_admin_campaign_channels: 'Channel',

  // Campaign benefits
  ep_admin_campaign_benefits_points: 'Points',
  ep_admin_campaign_benefits_latestContents: 'Latest Contents',
  ep_admin_campaign_benefits_valueAddedService: 'Value-added Service',
  ep_admin_campaign_benefits: 'Benefits',

  // Campaign status
  ep_admin_campaign_status_saved: 'Saved',
  ep_admin_campaign_status_toBeApproved: 'To be approved',
  ep_admin_campaign_status_rejected: 'Rejected',
  ep_admin_campaign_status_approved: 'Approved',
  ep_admin_campaign_status_notStart: 'Not Start',
  ep_admin_campaign_status_ongoing: 'Ongoing',
  ep_admin_campaign_status_terminated: 'Terminated',
  ep_admin_campaign_status_finished: 'Finished',

  // Campaign objective
  ep_admin_automatedMarketing_objective_activation: 'Activation',
  ep_admin_automatedMarketing_objective_activation_tip: 'The benefits will be directly distributed to the customer\'s account',
  ep_admin_automatedMarketing_objective_authentication: 'Authentication',
  ep_admin_automatedMarketing_objective_authentication_tip: 'From the start of the push message/email to the end of the activity +7 days, customers who complete the authentication will receive benefits',
  ep_admin_automatedMarketing_objective_addDevice: 'Add Device',
  ep_admin_automatedMarketing_objective_addDevice_tip: 'From the start of the push message/email to the end of the activity +7 days, customers can receive rewards for the first time they add a device',

  // Campaign actions
  ep_admin_campaign_terminate_title: 'Are you sure to terminate this campaign?',
  ep_admin_campaign_terminate_content: 'After termination, the system will no longer push emails or messages to customers.',
  ep_admin_campaign_terminate_confirm: 'Confirm',
  ep_admin_campaign_terminate_success: 'Terminated successfully',
  ep_admin_campaign_delete_title: 'Are you sure to delete this campaign?',
  ep_admin_campaign_delete_content: 'After deletion, the campaign and its associated OA process will be permanently removed.',
  ep_admin_campaign_delete_confirm: 'Confirm',
  ep_admin_campaign_delete_success: 'Deleted successfully',

  // Campaign New/Edit Page
  ep_admin_automatedMarketing_pushDate: 'Push Date',
  ep_admin_automatedMarketing_timing: 'Timing',
  ep_admin_campaign_Page2_Title: 'Content Configuration',
  ep_admin_campaign_Page2_SubTitle: 'Configure campaign content settings',
  ep_admin_btns_return_to_list: 'Return to List',
  ep_admin_campaign_setCustomers: 'Set Customers',
  ep_admin_campaign_uploadOneHikId: 'Upload OneHikID',
  ep_admin_campaign_tagFiltering: 'Tag Filtering',
  ep_admin_campaign_tagSelection: 'Tag Selection',
  ep_admin_btns_startDate: 'Start Date',
  ep_admin_btns_endDate: 'End Date',
  ep_admin_automatedMarketing_pointsValue: 'Points Value',
  ep_admin_automatedMarketing_valueAddedService: 'Value-added Service',

  // Role Mapping
  ep_admin_role_mapping_role_list: 'Role List',
  ep_admin_role_mapping_role_index: 'Role {index}',
  ep_admin_role_mapping_role_permissions: 'Role Permissions',
  ep_admin_role_mapping_new_role: 'New Role',
  ep_admin_role_mapping_create_new_role: 'Create New Role',
  ep_admin_role_mapping_edit_new_role: 'Edit New Role',
  ep_admin_role_mapping_feature_role_configuration: 'Feature Role Configuration',
  ep_admin_role_mapping_feature_category_tools: 'Feature Category & Tools',
  ep_admin_role_mapping_role_conflict: 'Role Conflict',
  ep_admin_role_mapping_duplicate_users_found: 'Duplicate Users Found.',
  ep_admin_role_mapping_download_list: 'Download List',
  ep_admin_role_mapping_overwrite: 'Overwrite',
  ep_admin_role_mapping_sync_failed_tip: 'Sync Failed.',
  ep_admin_role_mapping_enable_confirm_content:
    'Enabling this switch will apply all configured user roles and permissions. Are you sure you want to continue?',
  ep_admin_role_mapping_role_name: 'Role Name',
  ep_admin_role_mapping_role_description: 'Role Description',
  ep_admin_role_mapping_select_users: 'Select Users',
  ep_admin_role_mapping_preview_list: 'Preview List',
  ep_admin_role_mapping_one_hik_id: 'OneHikID',
  ep_admin_role_mapping_user_email: 'User Email',
  ep_admin_role_mapping_country: 'Country',
  ep_admin_role_mapping_user_name: 'User Name',
  ep_admin_role_mapping_user_id: 'User ID',
  ep_admin_role_mapping_company_name: 'Company Name',
  ep_admin_role_mapping_upload_max_size: 'The file size cannot exceed 20M',
  // HiContent Material Selector
  ep_admin_hicontent_title_select_image: 'Select HiContent Image',
  ep_admin_hicontent_title_select_video: 'Select HiContent Video',
  ep_admin_hicontent_title_select_material: 'Select HiContent Material',
  ep_admin_hicontent_title_select_pdf: 'Select HiContent PDF',
  ep_admin_hicontent_label_material_name: 'Material Name',
  ep_admin_hicontent_label_format: 'Format',
  ep_admin_hicontent_label_tag: 'Tag',
  ep_admin_hicontent_label_language: 'Language',
  ep_admin_hicontent_no_materials_found: 'No materials found',
  ep_admin_hicontent_selected_count: 'Selected: {count} item(s)',
  ep_admin_hicontent_selected_single: 'Selected: 1 item',
  ep_admin_hicontent_title_crop_image: 'Crop Image',
  ep_admin_hicontent_message_upload_success: 'Image uploaded successfully!',
  ep_admin_hicontent_message_upload_failed: 'Upload failed',
  ep_admin_hicontent_message_crop_upload_failed: 'Failed to crop and upload image',
  ep_admin_hicontent_message_s3_transfer_failed: 'Failed to transfer to S3',
  ep_admin_hicontent_message_size_limit: 'Image size cannot exceed {maxSize}KB',

  // ImageCropperModal
  ep_admin_imagecropper_title: 'Crop Image',
  ep_admin_imagecropper_not_initialized: 'Cropper not initialized',
  ep_admin_imagecropper_failed: 'Failed to crop image',

  // Content Management - Common
  ep_admin_explore_synced_to: 'Synced to',
  ep_admin_explore_video_description: 'Video Description',
  ep_admin_explore_video_desc_unsupported: 'Images and Excels are not supported in video description.',
  ep_admin_explore_select_video: 'Select Video',
  ep_admin_explore_change_video: 'Change Video',
  ep_admin_explore_delete: 'Delete',
  ep_admin_explore_no_translate_content: 'No translate content',
  ep_admin_explore_translation_completed: 'Translation completed',
  ep_admin_explore_translation_failed: 'Translation failed',

  // HiContent Tab (TinyMCE Rich Text Editor)
  ep_admin_hicontent_tab: 'HiContent',
  ep_admin_explore_hicontent_formats: 'Supported formats: JPG, PNG, JPEG, WebP',

  // Banner Management
  ep_admin_banner_select_publish_to: 'Please select publish to first',
  ep_admin_banner_hicontent_select_image: 'Select HiContent Image',
  ep_admin_banner_hicontent_or_local: 'or',
  ep_admin_banner_hicontent_select_from_hicontent: 'Select Image from HiContent',

  // AWS Request Timeout
  ep_admin_tips_aws_timeout: 'AWS request timeout, please try again',

  // HiContent Common Messages
  ep_admin_hicontent_image_process_failed: 'Failed to process image',
  ep_admin_hicontent_image_transfer_failed: 'Failed to transfer image',
  ep_admin_hicontent_no_hicontent_image_selected: 'No HiContent image selected',

  // HiContent Crop Ratio
  ep_admin_hicontent_crop_ratio_16_9: '16:9',
  ep_admin_hicontent_crop_ratio_9_16: '9:16',
  ep_admin_hicontent_crop_ratio_4_3: '4:3',
  ep_admin_hicontent_crop_ratio_3_4: '3:4',
  ep_admin_hicontent_crop_ratio_1_1: '1:1',
  ep_admin_hicontent_preview_alt: 'Preview Image',

  // Content Management - HiContent Related
  ep_admin_explore_select_from_hicontent: 'Select from HiContent',
  ep_admin_explore_insert_pdf: 'Insert PDF',
  ep_admin_explore_local_upload: 'Local Upload',
  ep_admin_explore_select_hicontent_image: 'Select HiContent Image',
  ep_admin_explore_select_hicontent_pdf: 'Select HiContent PDF',
  ep_admin_explore_select_hicontent_material: 'Select HiContent Material',
  ep_admin_explore_hicontent_image: 'HiContent Image',
  ep_admin_explore_hicontent_video: 'HiContent Video',

  ep_admin_user_scan_for_outbound: "Scan for Outbound",
  ep_admin_user_scan_for_outbound_tips: '渠道扫码权限如DPP出库扫码，非积分扫码',
  ep_admin_outbound_ordeNo: 'Order No.',
  ep_admin_outbound_customerFirstName: 'Customer First Name',
  ep_admin_outbound_customerLastName: 'Customer Last Name',
  ep_admin_outbound_customerMobilePhone: 'Customer Mobile Phone',
  ep_admin_outbound_customerEmail: 'Customer Email',
  ep_admin_outbound_successfulQty: 'Successful Qty',
  ep_admin_outbound_failedQty: 'Failed Qty',
  ep_admin_outbound_outboundDate: 'Outbound Date',
  ep_admin_outbound_sellerCountry: 'Seller Country',
  ep_admin_outbound_sellerScanType: "Seller Scan Type",
  ep_admin_outbound_sellerCompanyID: 'Seller Company ID',
  ep_admin_outbound_sellerCompanyName: 'Seller Company Name',
  ep_admin_outbound_sellerOneHikID: 'Seller OneHikID',
  ep_admin_outbound_sellerUserName: 'Seller User Name',
  ep_admin_outbound_sellerUserEmail: 'Seller User Email',
  ep_admin_outbound_orderStatus: 'Order Status',
  ep_admin_outbound_customerFirst_or_lastName: 'Customer First/ Last Name',
  ep_admin_outbound_batchSellingPrice: 'Batch Selling Price',
  ep_admin_outbound_dpp_selling_price: 'DPP Selling Price',
  ep_admin_channel_scan_configure: 'Scan Configure',
  ep_admin_channel_rebate_valid: 'Rebate Valid',
  ep_admin_user_scan_integration_code: "Scan Integration Code",
  ep_admin_user_scan_integration_code_tips: '是否允许扫入库和出库集成码',
  ep_admin_outbound_detail_title: 'OutBound History Detail',
  ep_admin_outbound_order_no: 'Order No',
  ep_admin_outbound_customer_company_name: 'Customer Company Name',
  ep_admin_outbound_seller_company_name: 'Seller Company Name',
  ep_admin_outbound_seller_user_name: 'Seller User Name',
  ep_admin_outbound_seller_user_email: 'Seller User Email',
  ep_admin_outbound_status_completed: 'Completed',
  ep_admin_outbound_status_ongoing: 'Ongoing',
  ep_admin_outbound_status_successful: 'Successful',
  ep_admin_outbound_status_failed: 'Failed',
  ep_admin_outbound_fake_true_code: 'True Code',
  ep_admin_outbound_fake_fake: 'Fake',
  ep_admin_outbound_fake_not_handled: 'Not Handled',
  ep_admin_outbound_client_hpp_app: 'HPP APP',
  ep_admin_outbound_client_hpp_portal: 'HPP Portal',
  ep_admin_outbound_client_barcode_scanner: 'Barcode Scanner',
  ep_admin_outbound_client_pda: 'PDA',
  ep_admin_outbound_screenshot_failed: 'Failed',
  ep_admin_outbound_screenshot_succeeded: 'Succeeded',
  ep_admin_outbound_screenshot_no_capture: 'NO Capture',
  ep_admin_outbound_scan_type_inbound: 'DPP Inbound',
  ep_admin_outbound_scan_type_outbound: 'DPP Outbound',
  ep_admin_outbound_na: 'N/A',
  ep_admin_outbound_confirm_deactivate: 'Confirm to deactivate it ?',
  ep_admin_outbound_confirm_true_code: 'Confirm to mark as true code?',
  ep_admin_outbound_reset_failed: '{ids} reset failed!',
  ep_admin_outbound_file_upload_failed: '{name} file upload failed.',
  ep_admin_scan_Client_Version: 'Client Version',
  // ND Stock FOB Price
  ep_admin_nd_year: 'Year',
  ep_admin_nd_quarter: 'Quarter',
  ep_admin_nd_sap_id: 'SAP ID',
  ep_admin_nd_material_code: 'Material Code',
  ep_admin_nd_price_id: 'Price ID',
  ep_admin_nd_stock_fob_price: 'Stock FOB Price',
  ep_admin_nd_currency: 'Currency',
  ep_admin_nd_update_time: 'Update Time',
  ep_admin_nd_delete_confirm: 'Do you want to delete this data?',
  ep_admin_nd_add_title: 'Add',
  ep_admin_nd_edit_title: 'Edit',
  ep_admin_nd_import_title: 'Import',
  ep_admin_nd_upload_success: 'Uploaded successfully!',
  // Qty Limitation
  ep_admin_qty_limitation: 'Limitation',
  ep_admin_qty_add_title: 'Add Qty Limitation',
  ep_admin_qty_edit_title: 'Edit Qty Limitation',
  ep_admin_qty_delete_confirm: 'Do you want to delete this data?',
  ep_admin_qty_import_title: 'Import Qty Limitation',
  ep_admin_qty_upload_success: 'Uploaded successfully!',

}
